webpackJsonp([3],[
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["l"] = resolvePath;
/* harmony export (immutable) */ __webpack_exports__["r"] = formatBytes;
/* harmony export (immutable) */ __webpack_exports__["s"] = formatDate;
/* unused harmony export utc2date */
/* harmony export (immutable) */ __webpack_exports__["h"] = isVideo;
/* harmony export (immutable) */ __webpack_exports__["g"] = isAudio;
/* harmony export (immutable) */ __webpack_exports__["i"] = isDocs;
/* harmony export (immutable) */ __webpack_exports__["j"] = isPdf;
/* harmony export (immutable) */ __webpack_exports__["m"] = getMyEncodeURI;
/* harmony export (immutable) */ __webpack_exports__["o"] = getPreviewUrl;
/* harmony export (immutable) */ __webpack_exports__["n"] = getSession;
/* harmony export (immutable) */ __webpack_exports__["e"] = getCSSActionByCode;
/* unused harmony export getAuthTypeByAuthMask */
/* unused harmony export getFileAuthTypeByAuthMask */
/* harmony export (immutable) */ __webpack_exports__["t"] = getAuthNameByAccessMode;
/* unused harmony export getPrivatePrivilege */
/* unused harmony export getAllAuthName */
/* harmony export (immutable) */ __webpack_exports__["f"] = canPreview;
/* harmony export (immutable) */ __webpack_exports__["q"] = typeIcon;
/* unused harmony export getQueryStringByName */
/* harmony export (immutable) */ __webpack_exports__["c"] = getUserId;
/* harmony export (immutable) */ __webpack_exports__["k"] = getSessionId;
/* harmony export (immutable) */ __webpack_exports__["b"] = getApiVersion;
/* unused harmony export revertHtml */
/* unused harmony export canComment */
/* harmony export (immutable) */ __webpack_exports__["d"] = validFilename;
/* unused harmony export revisionOp */
/* unused harmony export setCookie */
/* harmony export (immutable) */ __webpack_exports__["a"] = getCookie;
/* harmony export (immutable) */ __webpack_exports__["p"] = delCookie;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_index__ = __webpack_require__(4);
/**
 * Created by Litong on 17/8/23.
 */

// 版本
var apiVersion = '/v2';

// 自定义权限编码
var G_CUSTOM_AUTH_CODE = {
  preview: 1025,
  download: 1028,
  upload: 1026,
  create: 1056,
  delivery: 1048,
  'delete': 1088,
  rename: 1152,
  copy: 1536,
  move: 1280,
  comment: 3072
  // 标准权限掩码
};var G_STANDARD_AUTH_CODE = { preview: 3073, upload: 3130, download: 3613, uploaddownload: 3647, edit: 4095, deny: 0
  // // 标准权限拒绝掩码
};var G_STANDARD_AUTH_CODE_DENY = { preview: 0, upload: 0, download: 0, uploaddownload: 0, edit: 0, deny: 4095
  // // 标准权限掩码(文件共享用)
};var G_STANDARD_AUTH_CODE_FILE = { preview: 3073, download: 3613, edit: 3615, deny: 0
  // 标准权限掩码ID
};var G_STANDARD_AUTH_CODE_ID = { preview: 3001, upload: 3002, download: 3003, uploaddownload: 3004, edit: 3005, deny: 3006
  // // 标准权限拒绝掩码(文件共享用)
};var G_STANDARD_AUTH_CODE_DENY_FILE = { preview: 0, download: 0, edit: 0, deny: 3615
  // 权限名称
};var G_AUTH_TITLE = {
  preview: '预览',
  upload: '上传',
  download: '下载',
  uploaddownload: '上传/下载',
  edit: '编辑',
  deny: '禁止访问',
  custom: '自定义'
};



function resolvePath(path, flag) {
  if (path === '/') {
    return { name: '', type: '' };
  }
  var regName = /\/([^/]+)$/;
  var exSuffix = /\.([^.]+)$/;
  var name, suffix;
  if (!path) return '';
  name = path.match(regName);
  if (!flag && name[1]) {
    suffix = name[1].match(exSuffix) || ['', ''];
  }
  return {
    name: name[1] || '',
    type: flag ? 'folder' : suffix[1].toLowerCase()
  };
}

function formatBytes(baseNumber, fixed) {
  var sizeUnits = [1099511627776, 1073741824, 1048576, 1024, 1];
  var sizeUnitLabels = ['TB', 'GB', 'MB', 'KB', 'B'];
  return _formatUnits(baseNumber, sizeUnits, sizeUnitLabels, true, fixed);
}

function _formatUnits(baseNumber, unitDivisors, unitLabels, singleFractional, fixed) {
  var i, unit, unitDivisor, unitLabel;
  if (typeof fixed !== 'number') {
    fixed = 2;
  }
  if (baseNumber === 0) {
    return '0 ' + unitLabels[unitLabels.length - 1];
  }

  if (singleFractional) {
    unit = baseNumber;
    unitLabel = unitLabels.length >= unitDivisors.length ? unitLabels[unitDivisors.length - 1] : '';
    for (i = 0; i < unitDivisors.length; i++) {
      if (baseNumber >= unitDivisors[i]) {
        unit = (baseNumber / unitDivisors[i]).toFixed(fixed);
        unitLabel = unitLabels.length >= i ? ' ' + unitLabels[i] : '';
        break;
      }
    }

    return unit + unitLabel;
  } else {
    var formattedStrings = [];
    var remainder = baseNumber;

    for (i = 0; i < unitDivisors.length; i++) {
      unitDivisor = unitDivisors[i];
      unitLabel = unitLabels.length > i ? ' ' + unitLabels[i] : '';

      unit = remainder / unitDivisor;
      if (i < unitDivisors.length - 1) {
        unit = Math.floor(unit);
      } else {
        unit = unit.toFixed(0);
      }
      if (unit > 0) {
        remainder = remainder % unitDivisor;
        formattedStrings.push(unit + unitLabel);
      }
    }

    return formattedStrings.join(' ');
  }
}

function formatDate(dateObj, fmt) {
  var year, month, date, hours, minutes, seconds;

  if (!dateObj) return;

  if (Object.prototype.toString.call(dateObj) === '[object Date]') {
    year = dateObj.getFullYear();
    month = dateObj.getMonth() + 1;
    date = dateObj.getDate();
    hours = dateObj.getHours();
    minutes = dateObj.getMinutes();
    seconds = dateObj.getSeconds();
  } else {
    var regexp = /([\d]{4})-([\d]{2})-([\d]{2})T([\d]{2}):([\d]{2}):([\d]{2})(?:\+([\d]{2}):([\d]{2}))?/;
    var d = regexp.exec(dateObj);
    if (!d) return;
    year = d[1];
    month = d[2];
    date = d[3];
    hours = d[4];
    minutes = d[5];
    seconds = d[6];
  }
  var o = {
    'M+': +month, // 月份
    'd+': +date, // 日
    'h+': +hours, // 小时
    'm+': +minutes, // 分
    's+': +seconds, // 秒
    'q+': Math.floor((+month + 3) / 3)
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (year + '').substr(4 - RegExp.$1.length));
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
  }
  return fmt;
}
/**
 * utc转换日期
 * @param utc
 * @returns String
 */
function utc2date(utc) {
  var datetime = new Date(utc);
  var year = datetime.getFullYear();
  var month = datetime.getMonth() + 1 < 10 ? '0' + (datetime.getMonth() + 1) : datetime.getMonth() + 1;
  var day = datetime.getDate() < 10 ? '0' + datetime.getDate() : datetime.getDate();
  var hour = datetime.getHours() < 10 ? '0' + datetime.getHours() : datetime.getHours();
  var min = datetime.getMinutes() < 10 ? '0' + datetime.getMinutes() : datetime.getMinutes();
  var sec = datetime.getSeconds() < 10 ? '0' + datetime.getSeconds() : datetime.getSeconds();
  return year + '-' + month + '-' + day + ' ' + hour + ':' + min + ':' + sec;
}

/**
 * 是否为音视频
 * @param mime
 * @returns {boolean}
 */
function isVideo(mime) {
  return (/\.avi|f4v|mpg|wma|mp4|flv|wmv|mov|3gp|rmvb|mkv|asf|264|ts|mts|vob|m4v/.test(mime)
  );
}

/**
 * 是否为音频
 * @param mime
 * @returns {boolean}
 */
function isAudio(mime) {
  if (/\.rar/.test(mime)) {
    return false;
  }
  return (/\.mp3|aac|ape|flac|wma|ra|wav|mid|vqf|aif|au|dsp|cmf|cda|mod|iff|m3u|m4a|mpa|aiff|ac3|mur|mp2|amr/.test(mime)
  );
}

/**
 * 是否为文档
 * @param mime
 * @returns {boolean}
 */
function isDocs(mime) {
  return (/\.doc|dps|wps|et|ppt|txt|xls|docx|pptx|xlsx/.test(mime)
  );
}

/**
 * 是否为pdf
 * @param mime
 * @returns {boolean}
 */
function isPdf(mime) {
  return (/\.pdf/.test(mime)
  );
}

function getMyEncodeURI(path) {
  path = encodeURI(path).replace(/&/g, '%26').replace(/#/g, '%23').replace(/\+/g, '%2B');
  return path;
}

function getPreviewUrl(item) {
  var type = 'doc';
  if (isVideo(item.mime_type) || isAudio(item.mime_type)) {
    type = 'av';
  }
  var uri = '/v2/preview_router?type=' + type + '&root=databox&path=' + getMyEncodeURI(item.path) + '&path_type=' + item.path_type + '&from' + item.from + '&neid=' + item.neid + '&';
  uri += 'rev=' + item.rev;
  uri = uri.replace('//', '/');
  return uri;
}

function getSession() {
  return __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state.userInfo['X-LENOVO-SESS-ID'];
}

function getCSSActionByCode(code) {
  var rs = '';
  var returnData = {};
  for (var o in G_CUSTOM_AUTH_CODE) {
    if ((code & G_CUSTOM_AUTH_CODE[o]) === G_CUSTOM_AUTH_CODE[o]) {
      if (rs !== '') {
        rs += ':' + o;
      } else {
        rs = o;
      }
    }
  }
  returnData.authCSS = rs;
  for (var i in G_STANDARD_AUTH_CODE) {
    if (code === G_STANDARD_AUTH_CODE[i]) {
      returnData.authType = i;
    }
    if (!returnData.authType) {
      returnData.authType = 'custom';
    }
  }
  return returnData;
}

/**
 * 根据权限的掩码判断文件夹是否是标准权限
 */
function getAuthTypeByAuthMask(allowedMask, deniedMask) {
  for (var o in G_STANDARD_AUTH_CODE) {
    if (allowedMask === G_STANDARD_AUTH_CODE[o] && deniedMask === G_STANDARD_AUTH_CODE_DENY[o]) {
      return { 'isStandard': true, 'authName': o };
    }
  }
  return { 'isStandard': false, 'authName': 'custom' };
}

/**
 * 根据权限的掩码判断文件是否是标准权限
 */
function getFileAuthTypeByAuthMask(allowedMask, deniedMask) {
  for (var o in G_STANDARD_AUTH_CODE) {
    if (allowedMask === G_STANDARD_AUTH_CODE_FILE[o] && deniedMask === G_STANDARD_AUTH_CODE_DENY_FILE[o]) {
      return { 'isStandard': true, 'authName': o };
    }
  }
  return { 'isStandard': false, 'authName': 'custom' };
}

/**
 * 根据权限的掩码判断文件是否是标准权限
 */
function getAuthNameByAccessMode(accessMode) {
  for (var o in G_STANDARD_AUTH_CODE) {
    if (accessMode === G_STANDARD_AUTH_CODE[o]) {
      return { 'isStandard': true, 'authName': G_AUTH_TITLE[o] };
    }
  }
  return { 'isStandard': false, 'authName': 'custom' };
}

function getPrivatePrivilege(cssAction) {
  return {
    canPreview: /preview|edit|download\b|download-\w+/.test(cssAction),
    canUpload: /upload|edit/.test(cssAction),
    canDownload: /download|edit/.test(cssAction),
    canLink: /delivery|edit/.test(cssAction),
    canCreate: /create|edit|upload\b|upload-\w+/.test(cssAction),
    canDelete: /delete|edit/.test(cssAction),
    canRename: /rename|edit/.test(cssAction),
    canMove: /move|edit/.test(cssAction),
    canCopy: /copy|download\b|download-\w+|edit/.test(cssAction)
  };
}
/**
 * 获取所有的权限名称
 * @param code
 */
function getAllAuthName(code) {
  console.log(code);
  if (isNaN(code)) {
    return code;
  }
  var rs = '';
  var key = '';
  for (var o in G_STANDARD_AUTH_CODE_ID) {
    if (G_STANDARD_AUTH_CODE_ID[o] === parseInt(code)) {
      key = o;
      break;
    }
  }
  rs = G_AUTH_TITLE[key];
  if (!rs) {
    return '自定义';
  }
  return rs;
}

/**
 * 文件是否能预览
 */
function canPreview(mime) {
  if (!mime) {
    return false;
  }
  // ZH Bug #39987.diff后缀文件不应该显示预览按钮
  if (/\.diff/.test(mime)) {
    return false;
  }
  return (/\.doc|dps|wps|et|pdf|ppt|xls|docx|vsdx|pptx|xlsx|png|jpeg|jpg|gif|JPEG|JPG|GIF|pic|word|excel|mp4|wma|mp3|docx|avi|f4v|mpg|flv|wmv|mov|3gp|rmvb|mkv|asf|264|ts|mts|vob|wav|m4v|ape|flac|aac/.test(mime)
  );
}

function typeIcon(typeIcon) {
  var ImgType = typeIcon;
  var jar = {
    'folder_team': 'folder_team',
    'folder_share': 'folder_share',
    'folder': 'folder',
    'doc': 'word',
    'docx': 'word',
    'wps': 'word',
    'rtf': 'word',
    'txt': 'text',
    'jpg': 'pic',
    'JPG': 'pic',
    'jpeg': 'pic',
    'JPEG': 'pic',
    'png': 'pic',
    'BMP': 'pic',
    'bmp': 'pic',
    'gif': 'pic',
    'GIF': 'pic',
    'tiff': 'pic',
    'pcx': 'pic',
    'thm': 'pic',
    'yuv': 'pic',
    'pps': 'ppt',
    'dps': 'ppt',
    'ppsx': 'ppt',
    'ppt': 'ppt',
    'pptx': 'ppt',
    'xls': 'excel',
    'xlsx': 'excel',
    'et': 'excel',
    'csv': 'excel',
    'lock': 'lock',
    'pct': 'pdf',
    'pdf': 'pdf',
    'pmd': 'pdf',
    'mp3': 'music',
    'aac': 'music',
    'flac': 'music',
    'ape': 'music',
    'wma': 'music',
    'ra': 'music',
    'wav': 'music',
    'mid': 'music',
    'vqf': 'music',
    'aif': 'music',
    'au': 'music',
    'dsp': 'music',
    'cmf': 'music',
    'cda': 'music',
    'mod': 'music',
    'iff': 'music',
    'm3u': 'music',
    'm4a': 'music',
    'mpa': 'music',
    'aiff': 'music',
    'ac3': 'music',
    'mur': 'music',
    'mp2': 'music',
    'amr': 'music',
    'avi': 'video',
    'mov': 'video',
    'mpg': 'video',
    'mp4': 'video',
    'xv': 'video',
    '3gp': 'video',
    'divx': 'video',
    'rm': 'video',
    'rmvb': 'video',
    'asf': 'video',
    'wmv': 'video',
    'vob': 'video',
    'mkv': 'video',
    'dat': 'video',
    '264': 'video',
    'flv': 'video',
    '3g2': 'video',
    'asx': 'video',
    'f4v': 'video',
    'h.264': 'video',
    'ts': 'video',
    'mts': 'video',
    'm4v': 'video',
    'exe': 'exe',
    'rar': 'zip',
    'zip': 'zip',
    'zipx': 'zip',
    '7z': 'zip',
    'cab': 'zip',
    'arj': 'zip',
    'jar': 'zip',
    'lzh': 'zip',
    'bin': 'zip',
    'deb': 'zip',
    'gz': 'zip',
    'rpm': 'zip',
    'sit': 'zip',
    'sitx': 'zip',
    'tar': 'zip',
    'cad': 'cad',
    'dxf': 'cad',
    'psd': 'ps',
    'ai': 'ai',
    'dw': 'dw',
    'fil': 'fl',
    'id': 'id',
    'ae': 'ae',
    '3d': '3d',
    'eps': 'svg',
    'svg': 'svg',
    'cdr': 'svg',
    'pages': 'other',
    'log': 'other',
    'msg': 'other',
    'xps': 'other',
    'chm': 'other',
    'pdg': 'other',
    'key': 'other',
    'efx': 'other',
    'sdf': 'other',
    'vcf': 'other',
    'wks': 'other',
    'munbers': 'other',
    '3dm': 'other',
    'diff': 'other',
    'max': 'other',
    'com': 'other',
    'bat': 'other',
    'scr': 'other',
    'lib': 'other',
    'app': 'other',
    'cgi': 'other',
    'gadget': 'other',
    'vb': 'other',
    'wsf': 'other',
    'accdb': 'other',
    'db': 'other',
    'dbf': 'other',
    'mdb': 'other',
    'pdb': 'other',
    'sql': 'other',
    'cpl': 'setting',
    'cur': 'setting',
    'dll': 'setting',
    'dmp': 'setting',
    'drv': 'setting',
    'lnk': 'setting',
    'sys': 'setting',
    'cfg': 'setting',
    'ini': 'setting',
    'keychain': 'setting',
    'prf': 'setting',
    'c': 'cpp',
    'class': 'cpp',
    'cpp': 'cpp',
    'cs': 'cpp',
    'dtd': 'cpp',
    'fla': 'cpp',
    'java': 'cpp',
    'm': 'cpp',
    'pl': 'cpp',
    'py': 'cpp',
    'html': 'html',
    'htm': 'html',
    'xhtml': 'html',
    'php': 'html',
    'css': 'html',
    'js': 'html',
    'xml': 'html',
    'asp': 'html',
    'cer': 'html',
    'rss': 'html',
    'ttf': 'font',
    'fnt': 'font',
    'otf': 'font',
    'fon': 'font',
    'dmg': 'iso',
    'toast': 'iso',
    'vcd': 'iso',
    'iso': 'iso',
    'apk': 'apk',
    'dwg': 'dwg'
  };
  var Extension;
  for (var o in jar) {
    if (ImgType === o) {
      Extension = jar[o];
    }
  }
  if (Extension === undefined) {
    Extension = 'other';
  }
  typeIcon = Extension;
  return typeIcon;
}

function getQueryStringByName(name) {
  var result = location.search.match(new RegExp('[?&]' + name + '=([^&]+)', 'i'));
  if (result == null || result.length < 1) {
    return '';
  }
  return result[1];
}

function getUserId() {
  return __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state.userInfo['user_id'];
}

function getSessionId() {
  return __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state.userInfo['X-LENOVO-SESS-ID'];
}

function getApiVersion() {
  return apiVersion;
}

function revertHtml(str, reg) {
  return str ? str.replace(reg || /[&<">]/g, function (m) {
    return {
      '<': '&lt;',
      '&': '&amp;',
      '"': '&quot;',
      '>': '&gt;'
    }[m];
  }) : '';
}

/**
 * 是否有可评论权限
 * @param code
 * @returns {boolean}
 */
function canComment(code) {
  if ((code & G_CUSTOM_AUTH_CODE['comment']) === G_CUSTOM_AUTH_CODE['comment']) {
    return true;
  }
  return false;
}

function validFilename(filename) {
  var rs = '';
  var reg = /[/:*?？、"<>|\\]/;
  var reg1 = /^[.]/;
  if (reg.test(filename)) {
    rs = '名称不能包括下列任何字符 : &#92 /:*?？、"<>|';
  }
  if (reg1.test(filename)) {
    rs = '名称不能以.开头';
  }
  if (filename === '') {
    rs = '名称不能为空';
  }
  return rs;
}
function revisionOp(operator) {
  var op = {
    create: '创建',
    restore: '恢复',
    undelete: '还原',
    update: '更新',
    rename: '重命名',
    move: '移动',
    delete: '删除'
  };
  return op[operator];
}
function setCookie(name, value) {
  var cookieString = name + '=' + value;
  document.cookie = cookieString;
}

function getCookie(name) {
  var sessionid = '';
  var arrstr = document.cookie.split('; ');
  for (var i = 0; i < arrstr.length; i++) {
    var temp = arrstr[i].split('=');
    if (temp[0] === name) {
      sessionid = temp[1];
    }
  }
  return sessionid;
}

function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null) {
    document.cookie = name + '=' + cval + ';expires=-1';
  }
}

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_filelist_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_currentSeletctFileMenu_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_currentFolderMenu_js__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_navigator_js__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_sortlist_js__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_search_js__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_logout_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_delivery_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_movecopy_js__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_message_js__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_comments_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_history_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_deliveryTransfor_js__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_util__ = __webpack_require__(0);
















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    allInfo: [],
    userInfo: null,
    token: null,
    title: '',
    startUpload: false,
    isSearch: false,
    searchKeyword: '',
    startPreview: false,
    onlyWIFI: false,
    currentNetworkType: 2, // 0无网络 1WIFI 2移动网络
    configJson: {},
    toast: {
      isShow: false,
      message: '',
      iconClass: '',
      autoClose: true
    },
    progress: {
      isShow: false,
      message: ''
    }
  },
  getters: {
    getAllInfo: function getAllInfo(state) {
      return state.allInfo;
    },
    getConfigJson: function getConfigJson(state) {
      return state.configJson;
    },
    getCurrentNetworkType: function getCurrentNetworkType(state) {
      return state.currentNetworkType;
    },
    getCurrentUserInfo: function getCurrentUserInfo(state) {
      return state.userInfo;
    }
  },
  mutations: {
    setAllInfo: function setAllInfo(state, obj) {
      state.allInfo = obj;
    },
    setStartUpload: function setStartUpload(state, obj) {
      state.startUpload = obj;
    },
    setStartPreview: function setStartPreview(state, obj) {
      state.startPreview = obj;
    },

    login: function login(state, data) {
      state.userInfo = data;
    },
    logout: function logout(state) {
      localStorage.removeItem('userInfo');
      state.userInfo = null;
      __WEBPACK_IMPORTED_MODULE_15_util__["p" /* delCookie */]('X-LENOVO-SESS-ID');
    },
    setToast: function setToast(state, obj) {
      state.toast = obj;
    },
    setProgress: function setProgress(state, obj) {
      state.progress = obj;
    },
    setIsSearch: function setIsSearch(state, obj) {
      state.isSearch = obj;
    },
    setNetworkType: function setNetworkType(state, obj) {
      state.currentNetworkType = obj;
    },
    setOnlyWIFI: function setOnlyWIFI(state, obj) {
      state.onlyWIFI = obj;
    }
  },
  actions: {
    set_AllInfo: function set_AllInfo(_ref, obj) {
      var commit = _ref.commit;

      commit('setAllInfo', obj);
    }
  },

  modules: {
    fileInfo: __WEBPACK_IMPORTED_MODULE_2__modules_filelist_js__["a" /* default */],
    actionList: __WEBPACK_IMPORTED_MODULE_4__modules_currentFolderMenu_js__["a" /* default */],
    sortList: __WEBPACK_IMPORTED_MODULE_5__modules_navigator_js__["a" /* default */],
    senseList: __WEBPACK_IMPORTED_MODULE_6__modules_sortlist_js__["a" /* default */],
    search: __WEBPACK_IMPORTED_MODULE_7__modules_search_js__["a" /* default */],
    menuList: __WEBPACK_IMPORTED_MODULE_3__modules_currentSeletctFileMenu_js__["a" /* default */],
    logout: __WEBPACK_IMPORTED_MODULE_8__modules_logout_js__["a" /* default */],
    delivery: __WEBPACK_IMPORTED_MODULE_9__modules_delivery_js__["a" /* default */],
    movecopy: __WEBPACK_IMPORTED_MODULE_10__modules_movecopy_js__["a" /* default */],
    comments: __WEBPACK_IMPORTED_MODULE_12__modules_comments_js__["a" /* default */],
    history: __WEBPACK_IMPORTED_MODULE_13__modules_history_js__["a" /* default */],
    message: __WEBPACK_IMPORTED_MODULE_11__modules_message_js__["a" /* default */],
    deliveryTransfor: __WEBPACK_IMPORTED_MODULE_14__modules_deliveryTransfor_js__["a" /* default */]
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = ajaxGet;
/* harmony export (immutable) */ __webpack_exports__["c"] = ajaxPost;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_qs__);


/**
 * Created by Litong on 17/8/22.
 * http配置
 */





// import router from './index'


// axios 配置
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.timeout = 30000;
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.baseURL = '';
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.withCredentials = true;
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// http request 拦截器
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.interceptors.request.use(function (config) {
  var prefix = '&';
  if (__WEBPACK_IMPORTED_MODULE_3_store__["a" /* default */].state.userInfo) {
    if (config.url.indexOf('?') === -1) {
      prefix = '?';
    }
    config.url += prefix;
    if (!/LENOVO/.test(config.url)) {
      config.url += 'X-LENOVO-SESS-ID=' + __WEBPACK_IMPORTED_MODULE_3_store__["a" /* default */].state.userInfo['X-LENOVO-SESS-ID'];
    }
    config.url += '&_=' + new Date().getTime();
  }
  if (config.url.indexOf('?') === -1) {
    prefix = '?';
  } else {
    prefix = '&';
  }
  if (__WEBPACK_IMPORTED_MODULE_4_util__["a" /* getCookie */]('S')) {
    config.url += prefix + 'S=' + __WEBPACK_IMPORTED_MODULE_4_util__["a" /* getCookie */]('S');
  }
  return config;
}, function (err) {
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
});

// http response 拦截器
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response) {
    console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error)); // console : Error: Request failed with status code 402
  }
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error.response.data);
});

function ajaxGet(url, params) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    url = url.replace(/\+/g, '%2B');
    url = url.replace(/#/g, '%23');
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url, params).then(function (response) {
      // console.log('get' + response)
      if (response) {
        resolve(response.data);
      }
    }, function (err) {
      resolve(err);
      reject(err);
    }).catch(function (error) {
      reject(error);
    });
  });
}

function ajaxPost(url, params) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    url = url.replace(/\+/g, '%2B');
    url = url.replace(/#/g, '%23');
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, __WEBPACK_IMPORTED_MODULE_5_qs___default.a.stringify(params)) // Qs是对post请求参数一个转换
    .then(function (response) {
      console.log(response);
      resolve(response.data);
    }, function (err) {
      reject(err);
      resolve(err);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_axios___default.a);

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = signin;
/* harmony export (immutable) */ __webpack_exports__["f"] = getDomains;
/* harmony export (immutable) */ __webpack_exports__["i"] = getInfo;
/* harmony export (immutable) */ __webpack_exports__["b"] = getInfoByCookie;
/* harmony export (immutable) */ __webpack_exports__["c"] = mobileDownload;
/* harmony export (immutable) */ __webpack_exports__["j"] = signout;
/* unused harmony export configSet */
/* harmony export (immutable) */ __webpack_exports__["a"] = configGet;
/* harmony export (immutable) */ __webpack_exports__["h"] = authlogin;
/* harmony export (immutable) */ __webpack_exports__["d"] = getCode;
/* harmony export (immutable) */ __webpack_exports__["e"] = verifyCode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_http__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jsencrypt__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jsencrypt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jsencrypt__);


/**
 * Created by Smile on 2017/9/2.
 */




// api版本
var prefix = __WEBPACK_IMPORTED_MODULE_3_util__["b" /* getApiVersion */]();

/**
 * 登陆
 */
function signin(params) {
  var url = prefix + '/user/login';
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_2__router_http__["b" /* ajaxGet */](encodeURI('/v2/system/get_publickey?account_id=-1&uid=-1&S=undefined')).then(function (res) {
      var encryptor = new __WEBPACK_IMPORTED_MODULE_4_jsencrypt___default.a();
      encryptor.setPublicKey(res.public_key); // 设置公钥
      var password = encryptor.encrypt(params.password); // 对密码进行加密
      var postData = {
        user_slug: params.user_slug,
        password: password,
        bind_type: params.bind_type,
        timesid: params.timesid
      };
      resolve(__WEBPACK_IMPORTED_MODULE_2__router_http__["c" /* ajaxPost */](encodeURI(url), postData));
    }).catch(function (error) {
      reject(error);
    });
  });
}
/**
 * 获取AD域
 */
function getDomains(params) {
  var url = prefix + '/ad/get_domains?isPhoneLogin=1';
  return __WEBPACK_IMPORTED_MODULE_2__router_http__["b" /* ajaxGet */](encodeURI(url));
}

/**
 * 获取用户信息
 */
function getInfo(params) {
  var url = prefix + '/user/info/get?account_id=1&uid=' + __WEBPACK_IMPORTED_MODULE_3_util__["c" /* getUserId */]();
  if (params.user_id) {
    url += params.user_id;
  }
  return __WEBPACK_IMPORTED_MODULE_2__router_http__["b" /* ajaxGet */](encodeURI(url));
}
/**
 * 获取用户信息By Cookie
 */
function getInfoByCookie(params) {
  var url = prefix + '/user/info/get?X-LENOVO-SESS-ID=' + params.token;
  return __WEBPACK_IMPORTED_MODULE_2__router_http__["b" /* ajaxGet */](encodeURI(url));
}

/**
 * 获取客户端下载地址
 */
function mobileDownload(postData) {
  var url = prefix + '/config/mobileDownloadUrl';
  return __WEBPACK_IMPORTED_MODULE_2__router_http__["c" /* ajaxPost */](encodeURI(url), postData);
}
/**
 * 用户退出登录
 @param {object} params
 @param {function} params.callback 回调函数
 */
function signout(params) {
  var url = prefix + '/user/logout';
  var postData = {};
  return __WEBPACK_IMPORTED_MODULE_2__router_http__["c" /* ajaxPost */](encodeURI(url), postData);
}
/**
 * 设置自定义配置
 @param {object} params
 @param {function} params.callback 回调函数
 */
function configSet(params) {
  var url = prefix + '/config/set';
  var postData = {
    config_type: params.config_type,
    config_id: params.config_id,
    name: params.name,
    value: params.value
  };
  var json = { 'json': '[' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(postData) + ']' };
  return __WEBPACK_IMPORTED_MODULE_2__router_http__["c" /* ajaxPost */](encodeURI(url), json);
}
/**
 * 获取自定义配置
 @param {object} params
 @param {function} params.callback 回调函数
 */
function configGet(params) {
  var url = prefix + '/config/get?config_type=' + params.config_type + '&name=' + params.name;
  if (params.config_id !== '') {
    url += '&config_id=' + params.config_id;
  }
  return __WEBPACK_IMPORTED_MODULE_2__router_http__["b" /* ajaxGet */](encodeURI(url));
}
// 三方登录接口
function authlogin(params) {
  var url = prefix + '/authlogin/get?name=' + params.name + '&terminal=' + params.terminal;
  return __WEBPACK_IMPORTED_MODULE_2__router_http__["b" /* ajaxGet */](encodeURI(url));
}
// 发送验证码
function getCode(postData) {
  var url = prefix + '/user/captche_send?account_id=-1&uid=-1&S=undefined';
  return __WEBPACK_IMPORTED_MODULE_2__router_http__["c" /* ajaxPost */](encodeURI(url), postData);
}
// 校验验证码
function verifyCode(postData) {
  var url = prefix + '/user/captche_verify?account_id=-1&uid=-1&S=undefined';
  return __WEBPACK_IMPORTED_MODULE_2__router_http__["c" /* ajaxPost */](encodeURI(url), postData);
}

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = metaData;
/* harmony export (immutable) */ __webpack_exports__["i"] = info;
/* harmony export (immutable) */ __webpack_exports__["l"] = search;
/* harmony export (immutable) */ __webpack_exports__["k"] = batchDelete;
/* harmony export (immutable) */ __webpack_exports__["g"] = copy;
/* harmony export (immutable) */ __webpack_exports__["j"] = rename;
/* harmony export (immutable) */ __webpack_exports__["h"] = move;
/* harmony export (immutable) */ __webpack_exports__["c"] = createFolder;
/* harmony export (immutable) */ __webpack_exports__["a"] = checkUploadAuth;
/* harmony export (immutable) */ __webpack_exports__["d"] = getHistory;
/* harmony export (immutable) */ __webpack_exports__["e"] = deleteHistory;
/* harmony export (immutable) */ __webpack_exports__["m"] = setFavorite;
/* harmony export (immutable) */ __webpack_exports__["o"] = getFavorite;
/* harmony export (immutable) */ __webpack_exports__["n"] = removeFavorite;
/* harmony export (immutable) */ __webpack_exports__["f"] = restore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_http__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util__ = __webpack_require__(0);

/**
 * Created by Litong on 17/9/1.
 */



// api版本
var prefix = __WEBPACK_IMPORTED_MODULE_2_util__["b" /* getApiVersion */]();

function metaData(params) {
  var url = prefix + '/metadata/databox';

  if (params.path) {
    url += params.path;
  } else {
    url += '/';
  }
  if (params.path_type) {
    url += '?path_type=' + params.path_type;
  } else {
    url += '?path_type=ent';
  }
  if (params.offset) {
    url += '&offset=' + params.offset;
  } else {
    url += '&offset=0';
  }
  if (params.limit) {
    url += '&limit=' + params.limit;
  } else {
    url += '&limit=0';
  }
  if (params.sort) {
    url += '&sort=' + params.sort;
  } else {
    url += '&sort=desc';
  }
  if (params.from) {
    url += '&from=' + params.from;
  }
  if (params.prefix_neid) {
    url += '&prefix_neid=' + params.prefix_neid;
  }
  if (params.orderBy) {
    url += '&orderby=' + params.orderBy;
  } else {
    url += '&orderby=mtime';
  }
  if (params.content_type) {
    url += '&content_type=' + params.content_type;
  }
  url += '&include_deleted=false&account_id=1&uid=27';

  return __WEBPACK_IMPORTED_MODULE_1__router_http__["b" /* ajaxGet */](encodeURI(url));
}

function info(params) {
  var url = prefix + '/info/databox';

  // /v2/info/databox/888?neid=463&path_type=ent&_=1504925615436&account_id=1&uid=27

  if (params.path) {
    url += params.path;
  } else {
    url += '/';
  }
  if (params.path_type) {
    url += '?path_type=' + params.path_type;
  } else {
    url += '?path_type=ent';
  }
  if (params.neid) {
    url += '&neid=' + params.neid;
  }
  url += '&account_id=1&uid=27';

  return __WEBPACK_IMPORTED_MODULE_1__router_http__["b" /* ajaxGet */](encodeURI(url));
}

function search(params) {
  var url = prefix + '/search/databox';

  if (params.path) {
    url += '/' + params.path;
  }

  // let LocalAPI = '/v2?query=' + this.searchInputValue + '&path_type=ent&include_deleted=false&_=1504083658659&account_id=1&uid=27'

  if (params.query) {
    url += '?query=' + params.query;
  } else {
    url += '?query=';
  }
  if (params.path_type) {
    url += '&path_type=' + params.path_type;
  } else {
    url += '&path_type=ent';
  }
  if (params.page_size) {
    url += '&page_num=' + params.page_size;
  } else {
    url += '&page_num=0';
  }
  if (params.offset) {
    url += '&offset=0';
  } else {
    url += '&offset=0';
  }
  if (params.sort) {
    url += '&sort=' + params.sort;
  } else {
    url += '&sort=desc';
  }
  if (params.orderBy) {
    url += '&orderby=' + params.orderBy;
  } else {
    url += '&orderby=mtime';
  }
  url += '&page_button_count=5&include_deleted=false&page_size=20&account_id=1&uid=27';

  return __WEBPACK_IMPORTED_MODULE_1__router_http__["b" /* ajaxGet */](encodeURI(url));
}

function batchDelete(params) {
  var url = prefix + '/fileops/batch_delete';

  // let LocalAPI = '/v2?query=' + this.searchInputValue + '&path_type=ent&include_deleted=false&_=1504083658659&account_id=1&uid=27'

  var json = {};
  json.pathes = [];

  var obj = {};
  obj.root = 'databox';
  obj.neid = params.neid;
  obj.path = params.path;
  obj.from = params.from;
  obj.path_type = params.path_type;
  obj.prefix_neid = params.prefix_neid;
  json.pathes.push(obj);
  if (params.ignore_share) {
    json.ignore_share = true;
  }
  var postData = { 'json': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(json) };
  url += '?d=1';

  return __WEBPACK_IMPORTED_MODULE_1__router_http__["c" /* ajaxPost */](encodeURI(url), postData);
}
/**
 * 批量复制文件或目录。
 @param {object} params
 @param {function} params.callback 回调函数
 @param from 源路径
 @param to 目标路径
 */
function copy(params) {
  var url = prefix + '/fileops/batch_copy';
  var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
    from: [params.from],
    to: params.to
  });
  var postData = { 'json': data };
  return __WEBPACK_IMPORTED_MODULE_1__router_http__["c" /* ajaxPost */](encodeURI(url), postData);
}

function rename(params) {
  var url = prefix + '/fileops/move';

  // let LocalAPI = '/v2?query=' + this.searchInputValue + '&path_type=ent&include_deleted=false&_=1504083658659&account_id=1&uid=27'

  var postData = {
    root: 'databox',
    from_path: params.path,
    from_path_type: params.from_path_type,
    from_from: params.from,
    from_neid: params.neid,
    from_prefix_neid: params.prefix_neid,
    to_path: params.to_path,
    to_path_type: params.to_path_type,
    to_from: params.from,
    to_prefix_neid: params.prefix_neid
  };
  if (params.ignore_share) {
    postData.ignore_share = true;
  }
  url += '?d=1';
  return __WEBPACK_IMPORTED_MODULE_1__router_http__["c" /* ajaxPost */](encodeURI(url), postData);
}

/**
 * 批量移动文件/目录。
 @param {object} params
 @param {function} params.callback 回调函数
 @param {string} params.from (数组) 源路径
 @param {string} params.to   目标路径
 @param {string} params.ignore_share   是否忽略共享
 */
function move(params) {
  var url = prefix + '/fileops/batch_move';
  var data = {
    from: [params.from],
    to: params.to
  };
  if (params.ignore_share) {
    data.ignore_share = true;
  }
  var postData = { json: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data) };
  return __WEBPACK_IMPORTED_MODULE_1__router_http__["c" /* ajaxPost */](encodeURI(url), postData);
}

/**
 * 创建目录。
 @param {object} params
 @param {string} params.path 文件路径
 @param {string} params.path_type 路径类型
 @param {string} params.from 共享者的uid
 @param {string} params.neid 父目录元数据ID
 @param {string} params.prefix_neid path的前缀的neid
 */
function createFolder(params) {
  var uri = prefix + '/fileops/create_folder/databox' + params.path;
  uri = uri.replace('//', '/');
  var postData = {};
  postData.is_update = false;
  if (params.neid) {
    postData.neid = params.neid;
  } else {
    if (params.path_type) postData.path_type = params.path_type;
    if (params.from) postData.from = params.from;
  }
  if (/^share/.test(params.path_type)) postData.prefix_neid = params.prefix_neid;
  return __WEBPACK_IMPORTED_MODULE_1__router_http__["c" /* ajaxPost */](uri, postData);
}
/**
 * 验证上传权限
 * @param params
 */
function checkUploadAuth(params) {
  var uri = prefix + '/fileops/auth_upload/databox/';
  var getData = {
    path_type: params.path_type,
    bytes: params.bytes ? params.bytes : '0'
  };
  if (params.from) {
    getData.from = params.from;
  }
  if (params.prefix_neid) {
    getData.prefix_neid = params.prefix_neid;
  }
  if (params.iscloud) {
    getData.is_cloud = params.iscloud;
  }
  var tmp = [];
  if (params.path !== '') {
    uri += params.path;
  }
  for (var i in getData) {
    if (getData[i]) {
      tmp.push(i + '=' + getData[i]);
    }
  }
  uri += '?' + tmp.join('&');
  return __WEBPACK_IMPORTED_MODULE_1__router_http__["b" /* ajaxGet */](encodeURI(uri));
}

/**
 * 获取文件历史版本
 * @param params
 * @returns {*}
 */
function getHistory(params) {
  var url = prefix + '/revisions/databox';
  if (params.path) {
    url += params.path;
  } else {
    url += '/';
  }
  if (params.neid) {
    url += '?neid=' + params.neid;
  }
  return __WEBPACK_IMPORTED_MODULE_1__router_http__["b" /* ajaxGet */](encodeURI(url));
}

/**
 * 删除文件历史版本
 * @param params
 * @returns {*}
 */
function deleteHistory(params) {
  var url = prefix + '/revisions/databox';
  // if (params.path) {
  //   url += params.path
  // } else {
  //   url += '/'
  // }
  // if (params.neid) {
  //   url += params.neid
  // }
  return __WEBPACK_IMPORTED_MODULE_1__router_http__["b" /* ajaxGet */](encodeURI(url));
}

/**
 * （新建收藏）
 @param {object} params
 @param {function} params.callback 回调函数
 @param {object} params.snapshot 这里存放metaData返回的数据
 */
function setFavorite(params) {
  var uri = prefix + '/user/bookmark/create?account_id=1&uid=' + __WEBPACK_IMPORTED_MODULE_2_util__["c" /* getUserId */]();
  var json = {
    uid: params.uid,
    type: '1',
    neid: params.snapshot.neid,
    title: params.title || '',
    snapshot: params.snapshot
  };
  if (json.snapshot.desc) {
    json.snapshot.desc = json.snapshot.desc;
  }
  json.snapshot.path = encodeURIComponent(json.snapshot.path);
  var postData = { 'json': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(json) };
  return __WEBPACK_IMPORTED_MODULE_1__router_http__["c" /* ajaxPost */](uri, postData);
}

/**
 * (查询收藏)
 @param {object} params
 @param {function} params.callback 回调函数
 @param {string} params.sort 排序规则 asc，desc
 @param {string} params.n 取多少条数据（默认是50）
 @param {string} params.p 当前第几页
 */
function getFavorite(params) {
  var uri = 'v2/user/bookmark/list?sort=' + params.sort + '&order=' + params.order + '&n=' + params.n + '&p=' + params.p;
  return __WEBPACK_IMPORTED_MODULE_1__router_http__["b" /* ajaxGet */](encodeURI(uri));
}

/**
 * (批量取消收藏)
 @param {object} params
 @param {function} params.callback 回调函数
 @param {object} params.snapshot metaData返回的数据(数组)
 */
function removeFavorite(params) {
  var uri = 'v2/user/bookmark/delete?account_id=1&uid=' + __WEBPACK_IMPORTED_MODULE_2_util__["c" /* getUserId */]();
  if (params.snapshot.length > 1) {
    for (var i = 0, len = params.snapshot.length; i < len; i++) {
      if (i === 0) {
        uri += '&id=' + params.snapshot[i].bookmark_id;
      } else {
        uri += ',' + params.snapshot[i].bookmark_id;
      }
    }
  } else if (params.snapshot.length === 1) {
    uri += '&id=' + params.snapshot[0].bookmark_id;
  } else {
    uri += '&id=' + params.snapshot.bookmark_id;
  }
  return __WEBPACK_IMPORTED_MODULE_1__router_http__["b" /* ajaxGet */](encodeURI(uri));
}

/**
 * 将一个文件恢复到历史版本。
 @param {string} params.path 文件的路径
 @param {string} params.path_type 路径类型
 @param {string} params.from 共享者的uid 如:1343
 @param {string} params.neid 元数据ID 如:12343
 @param {string} params.rev 指定需要恢复的历史版本
 */
function restore(params) {
  var url = prefix + '/restore/databox' + params.path;
  var postData = {};

  if (params.neid) {
    postData.neid = params.neid;
  } else {
    if (params.path_type) {
      postData.path_type = params.path_type;
    }
    if (params.from) {
      postData.from = params.from;
    }
  }
  if (params.rev) {
    postData.rev = params.rev;
  }
  if (params.path_type === 'share_in' || params.path_type === 'share_out') {
    postData.prefix_neid = params.prefix_neid;
  }
  return __WEBPACK_IMPORTED_MODULE_1__router_http__["c" /* ajaxPost */](encodeURI(url), postData);
}

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(182)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(216),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["c"] = getDeliveryInfo;
/* harmony export (immutable) */ __webpack_exports__["d"] = delDelivery;
/* unused harmony export deliveryMetadata */
/* harmony export (immutable) */ __webpack_exports__["a"] = deliveryTransfor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_http__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util__ = __webpack_require__(0);

/**
 * Created by Smile on 2017/9/2.
 */



// api版本
var prefix = __WEBPACK_IMPORTED_MODULE_2_util__["b" /* getApiVersion */]();

/**
 * 创建外链
 */
function create(params) {
  var url = prefix + '/delivery/create/databox' + params.path + '?account_id=1&uid=' + __WEBPACK_IMPORTED_MODULE_2_util__["c" /* getUserId */]();

  var postData = {
    mode: params.mode,
    password: params.password,
    expiration: params.expiration
  };

  if (params.neid) {
    postData.neid = params.neid;
  } else {
    postData.path_type = params.path_type;
    postData.from = params.from;
  }
  if (params.prefix_neid) {
    postData.prefix_neid = params.prefix_neid;
  }

  return __WEBPACK_IMPORTED_MODULE_1__router_http__["c" /* ajaxPost */](encodeURI(url), postData);
}

/**
 *  获取外链信息
 */
function getDeliveryInfo(params) {
  var url = prefix + '/delivery/info/' + params.code + '?account_id=1&uid=' + __WEBPACK_IMPORTED_MODULE_2_util__["c" /* getUserId */]();
  return __WEBPACK_IMPORTED_MODULE_1__router_http__["b" /* ajaxGet */](encodeURI(url));
}

/**
 *  取消外链信息
 */
function delDelivery(params) {
  var url = prefix + '/delivery/batch_delete' + '/' + '?account_id=1&uid=' + __WEBPACK_IMPORTED_MODULE_2_util__["c" /* getUserId */]();
  return __WEBPACK_IMPORTED_MODULE_1__router_http__["c" /* ajaxPost */](encodeURI(url), params);
}

/**
 * 获取外链文件/目录的元数据
 @param {object} params
 @param {function} params.callback 回调函数
 @param {string} params.code 外链编码
 @param {string} params.relative_path 要查看的内容相对于外链的路径信息
 @param {string} params.token 访问令牌
 @param {string} params.order_type 默认mtime
 @param {string} params.sort 默认desc
 @param {string} params.offset 文件列表起始偏移量
 @param {string} params.limit 文件列表条数限制
 */
function deliveryMetadata(params) {
  if (!params.code) {
    return { code: 999, data: null, message: 'code不能为空!' };
  }
  var url = prefix + '/metadata/' + params.code;
  if (params.relative_path) {
    url += '/' + params.relative_path;
  }
  var queryString = [];
  if (params.token) {
    queryString.push('token=' + params.token);
  }
  if (params.order_type) {
    queryString.push('orderby=' + params.order_type);
  }
  if (params.sort) {
    queryString.push('sort=' + params.sort);
  }

  if (params.offset !== undefined) {
    queryString.push('offset=' + params.offset);
  }
  if (params.limit) {
    queryString.push('limit=' + params.limit);
  }
  if (params.preview_type) {
    queryString.push('preview_type=origin');
  }
  if (params.user_op) {
    queryString.push('user_op=preview');
  }
  if (queryString.length > 0) {
    url += '?' + queryString.join('&');
  }
  url = url.replace('//', '/');
  return __WEBPACK_IMPORTED_MODULE_1__router_http__["b" /* ajaxGet */](encodeURI(url));
}

/**
 * 外链转存
 @param {object} params
 @param {function} params.callback 回调函数
 */
function deliveryTransfor(params) {
  var url = prefix + '/delivery/delivery_transfor';
  var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
    from: params.from,
    to: params.to,
    other_data: params.other_data,
    nsid: window.nsid
  });
  var postData = {
    json: data
  };
  return __WEBPACK_IMPORTED_MODULE_1__router_http__["c" /* ajaxPost */](encodeURI(url), postData);
}

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(178)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(212),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);


function plugin(Vue) {
  // Exit if the plugin has already been installed.
  if (plugin.installed) return;
  // Create a `vm` to serve as our global event bus.
  var events = new Vue({
    methods: {
      /**
       * Emit the given event.
       *
       * @param {string|object} event
       * @param {...*} args
       */
      emit: function emit(event) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        this.$emit.apply(this, [event].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(args)));
      },


      /**
       * Emit the given event.
       *
       * @param {string|object} event
       * @param {...*} args
       */
      fire: function fire(event) {
        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        this.emit.apply(this, [event].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(args)));
      },


      /**
       * Listen for the given event.
       *
       * @param {string} event
       * @param {function} callback
       */
      on: function on(event, callback) {
        this.$on(event, callback);
      },


      /**
       * Listen for the given event.
       *
       * @param {string} event
       * @param {function} callback
       */
      listen: function listen(event, callback) {
        this.on(event, callback);
      },


      /**
       * Listen for the given event once.
       *
       * @param {string} event
       * @param {function} callback
       */
      once: function once(event, callback) {
        this.$once(event, callback);
      },


      /**
       * Remove one or more event listeners.
       *
       * @param {string} event
       * @param {function} callback
       */
      off: function off(event, callback) {
        this.$off(event, callback);
      },


      /**
       * Remove one or more event listeners.
       *
       * @param {string} event
       * @param {function} callback
       */
      remove: function remove(event, callback) {
        this.off(event, callback);
      }
    }
  });

  // Extend `Vue.prototype` to include our global event bus.
  Object.defineProperty(Vue.prototype, '$events', {
    get: function get() {
      return events;
    }
  });

  // Register a mixin that adds an `events` option to Vue 2.0 components.
  Vue.mixin({
    // Hook into the Vue 2.0 `beforeCreate` life-cycle event.
    beforeCreate: function beforeCreate() {
      // Exit if there's no `events` option.
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.$options.events) !== 'object') return;
      // Cache of events to bound functions for automatic unsubscriptions
      var eventMap = {};
      // Loop through each event.
      for (var key in this.$options.events) {
        // Assign event type and bound function to map
        eventMap[key] = this.$options.events[key].bind(this);
      }
      // Listen for the `hook:beforeMount` Vue 2.0 life-cycle event.
      this.$once('hook:beforeMount', function () {
        // Loop through each event.
        for (var key in eventMap) {
          // Register a listener for the event.
          events.$on(key, eventMap[key]);
        }
      });
      // Listen for the `hook:beforeDestroy` Vue 2.0 life-cycle event.
      this.$once('hook:beforeDestroy', function () {
        // Loop through each event.
        for (var key in eventMap) {
          // Register a listener for the event.
          events.$off(key, eventMap[key]);
        }
        // Release cache
        eventMap = null;
      });
    }
  });
}

// Check for `window.Vue`
if (typeof window !== 'undefined' && window.Vue) {
  // Install plugin automatically.
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zh_index__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_index__ = __webpack_require__(107);



/* harmony default export */ __webpack_exports__["a"] = ({
  default: 'zh',
  zh: __WEBPACK_IMPORTED_MODULE_0__zh_index__["a" /* default */],
  en: __WEBPACK_IMPORTED_MODULE_1__en_index__["a" /* default */]
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SDK_UserManager__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__page_login_login__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__page_login_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__page_login_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__page_secondary_certification_secondary_certification__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__page_secondary_certification_secondary_certification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__page_secondary_certification_secondary_certification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util__ = __webpack_require__(0);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

// 异步写法如下
// const ent = resolve => require(['@/page/ent/ent'], resolve)
// const myshare = resolve => require(['@/page/myshare/myshare'], resolve)
// const sharetome = resolve => require(['@/page/sharetome/sharetome'], resolve)
// const self = resolve => require(['@/page/self/self'], resolve)
// const favorite = resolve => require(['@/page/favorite/favorite'], resolve)
// const setting = resolve => require(['@/page/setting/setting'], resolve)
var NotFoundComponent = function NotFoundComponent(resolve) {
  return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(233)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var channel = function channel(resolve) {
  return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(232)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// const comments = resolve => require(['@/components/filelist/filelist_comment'], resolve)
// const fileDetail = resolve => require(['@/components/filelist/filelist_file_detail'], resolve)
// const history = resolve => require(['@/components/filelist/filelist_history'], resolve)
// const movecopy = resolve => require(['@/components/movecopy/movecopy'], resolve)
// const delivery = resolve => require(['@/components/delivery/delivery'], resolve)
// const message = resolve => require(['@/components/message/message'], resolve)
// const previewDoc = resolve => require(['@/components/preview/preview_doc'], resolve)
// const deliveryTransfor = resolve => require(['@/components/delivery/delivery_transfor'], resolve)
var routes = [
// {
//   path: '/self',
//   name: 'self',
//   meta: {
//     requireAuth: true
//   },
//   component: self
// },
// {
//   path: '/myshare',
//   name: 'myshare',
//   meta: {
//     requireAuth: true
//   },
//   component: myshare
// },
// {
//   path: '/sharetome',
//   name: 'sharetome',
//   meta: {
//     requireAuth: true
//   },
//   component: sharetome
// },
// {
//   path: '/favorite',
//   name: 'favorite',
//   meta: {
//     requireAuth: true
//   },
//   component: favorite
// },
{
  path: '/login',
  component: __WEBPACK_IMPORTED_MODULE_4__page_login_login___default.a,
  meta: {
    isLogin: true
  }
}, {
  path: '/secondary-certification',
  component: __WEBPACK_IMPORTED_MODULE_5__page_secondary_certification_secondary_certification___default.a,
  meta: {
    isLogin: true
  }
}, {
  path: '/',
  meta: {
    requireAuth: true
  },
  component: channel
},
// {
//   path: '/ent',
//   name: 'ent',
//   meta: {
//     requireAuth: true
//   },
//   component: ent
// },
// {
//   path: '/comments',
//   name: 'comments',
//   meta: {
//     requireAuth: true
//   },
//   component: comments
// },
// {
//   path: '/setting',
//   name: 'setting',
//   meta: {
//     requireAuth: true
//   },
//   component: setting
// },
// {
//   path: '/delivery',
//   name: 'delivery',
//   meta: {
//     requireAuth: true
//   },
//   component: delivery
// },
// {
//   path: '/fileDetail',
//   name: 'fileDetail',
//   meta: {
//     requireAuth: true
//   },
//   component: fileDetail
// },
// {
//   path: '/history',
//   name: 'history',
//   meta: {
//     requireAuth: true
//   },
//   component: history
// },
// {
//   path: '/movecopy',
//   name: 'movecopy',
//   meta: {
//     requireAuth: true
//   },
//   component: movecopy
// },
// {
//   path: '/message',
//   name: 'message',
//   meta: {
//     requireAuth: true
//   },
//   component: message
// },
// {
//   path: '/preview_doc',
//   name: 'preview_doc',
//   meta: {
//     requireAuth: true
//   },
//   component: previewDoc
// },
// {
//   path: '/deliveryTransfor',
//   name: 'deliveryTransfor',
//   meta: {
//     requireAuth: true
//   },
//   component: deliveryTransfor
// },
{
  path: '*',
  component: NotFoundComponent
}];

// 页面刷新时，重新赋值token
if (window.localStorage.getItem('userInfo')) {
  // console.log(JSON.parse(window.localStorage.getItem('userInfo')))
  __WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].commit('login', JSON.parse(window.localStorage.getItem('userInfo')));
}

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  // mode: 'history',
  routes: routes
});

// 接收需要转存的外链缓存数据
var linkStorage = window.localStorage.getItem('linkInfo');
var linkUrl = window.localStorage.getItem('linkUrl');
__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].state.linkInfo = JSON.parse(linkStorage);

/* let oauth = getQueryString('oauth')
let url = encodeURI('https://box.yst.com.cn/v2/weixin/user/login')
if (oauth) {
  // location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww5358bdb3655ef228&redirect_uri=' + url + '&response_type=code&scope=snsapi_base&agentid=1000013&state=cloud#wechat_redirect'
  location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx8a913347adfbce28&redirect_uri=' + url + '&response_type=code&scope=snsapi_base&agentid=1000016&state=cloud#wechat_redirect'
} */

function setTitle() {
  var title = sessionStorage.getItem('title');
  if (title) {
    document.title = title;
    return;
  }
  var customParams = {
    config_type: 0,
    config_id: 0,
    name: 'custom_product_zh_name'
  };
  __WEBPACK_IMPORTED_MODULE_3__SDK_UserManager__["a" /* configGet */](customParams).then(function (res) {
    var title = res[0].value;
    document.title = title;
    sessionStorage.setItem('title', title);
  });
}

router.beforeEach(function (to, from, next) {
  var title = document.title;
  if (!title) {
    setTitle();
  }
  if (to.path === '/login' || to.path === '/secondary-certification') {
    checkSession(function (response) {
      if (response.user_id) {
        if (linkStorage) {
          next({
            path: '/deliveryTransfor'
          });
        } else if (linkUrl) {
          window.location.href = linkUrl;
        } else {
          next({
            path: '/'
          });
        }
      } else {
        next();
      }
    });
  } else {
    checkSession(function (response) {
      if (response.user_id) {
        __WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].state.userInfo = response;
        if (to.matched.some(function (r) {
          return r.meta.requireAuth;
        })) {
          var sessionid = __WEBPACK_IMPORTED_MODULE_6_util__["a" /* getCookie */]('X-LENOVO-SESS-ID');
          if (sessionid) {
            __WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].state.userInfo['X-LENOVO-SESS-ID'] = sessionid;
            if (linkStorage && to.path !== '/deliveryTransfor') {
              next({
                path: '/deliveryTransfor'
              });
            } else if (linkStorage && to.path === '/deliveryTransfor') {
              next();
            } else {
              next();
            }
          } else {
            console.log('验证异常');
          }
        }
      } else if (response.data && response.data.state === 401 || response.state !== 200) {
        console.log('登录异常！！！！');
        // 内置浏览器通过手机浏览器打开，存储短链，以免丢失
        var linkFileReference = to.query && to.query.linkFileReference;
        if (linkFileReference) {
          window.localStorage.setItem('linkFileReference', linkFileReference);
        }
        next({
          path: '/login'
        });
      } else {
        next({
          path: '/login'
        });
      }
    });
  }
});

function checkSession(callback) {
  var sessionid = __WEBPACK_IMPORTED_MODULE_6_util__["a" /* getCookie */]('X-LENOVO-SESS-ID');
  __WEBPACK_IMPORTED_MODULE_3__SDK_UserManager__["b" /* getInfoByCookie */]({ token: sessionid }).then(function (response) {
    callback(response);
  }, function (error) {
    console.log(error);
  });
}

/* function getQueryString (name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r !== null) return unescape(r[2])
  return null
} */

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 82 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */,
/* 84 */,
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(190)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(124),
  /* template */
  __webpack_require__(225),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getComments;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteComment;
/* harmony export (immutable) */ __webpack_exports__["e"] = createComment;
/* harmony export (immutable) */ __webpack_exports__["f"] = checkWhetherAuth;
/* harmony export (immutable) */ __webpack_exports__["c"] = listForPages;
/* harmony export (immutable) */ __webpack_exports__["d"] = searchUser;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_http__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_util__ = __webpack_require__(0);
/**
 * Created by Litong on 17/9/1.
 */



// api版本
var prefix = __WEBPACK_IMPORTED_MODULE_1__common_js_util__["b" /* getApiVersion */]();
// const comm_type = exports.comm_type = {
//   comment: '1',
//   reply: '2',
//   ADMIN: '3'
// }

/**
 * 获取评论
 * @param params
 */
function getComments(params) {
  var url = prefix + '/comment/get_comment?neid=' + params.neid;

  if (!params.page_num) {
    url += '&page_num=' + 1;
  } else {
    url += '&page_num=' + params.page_num;
  }
  url += '&num_each_page=10';

  return __WEBPACK_IMPORTED_MODULE_0__router_http__["b" /* ajaxGet */](encodeURI(url));
}

/**
 * 删除评论
 * @param params.uid
 * @param params.ctime
 * @param params.from_uid
 */
function deleteComment(params) {
  var url = prefix + '/comment/delete_comment';
  var postData = {
    neid: params.neid,
    id: params.id
  };
  return __WEBPACK_IMPORTED_MODULE_0__router_http__["c" /* ajaxPost */](encodeURI(url), postData);
}

/**
 * 发送评论
 * @param params.uid
 * @param params.content
 * @param params.commTos
 * @param params.comm_type
 * @param params.comm_icons
 */
function createComment(params) {
  var url = prefix + '/comment/create_comment/';

  var postData = {
    words: params.words,
    neid: params.neid,
    commTos: params.commTos,
    comm_type: params.comm_type,
    comm_icon: params.comm_icon,
    id: params.id
  };

  return __WEBPACK_IMPORTED_MODULE_0__router_http__["c" /* ajaxPost */](encodeURI(url), postData);
}

/**
 * 验证是否有权限
 * @param params.neid 评论的文件(关联iris_file_info表中元数据
 * @param params.pushId 当前用户的id
 */
function checkWhetherAuth(params) {
  var url = prefix + '/comment/check_whether_auth';

  var postData = {
    neid: params.neid,
    pushId: params.pushId
  };

  return __WEBPACK_IMPORTED_MODULE_0__router_http__["c" /* ajaxPost */](encodeURI(url), postData);
}

/**
 * 获取用户信息
 */
function listForPages(params) {
  var url = prefix + '/user/list_for_pages';
  if (!params.role) {
    params.role = '1';
  }
  url += '?role=' + params.role;

  if (!params.page_num) {
    url += '&page_num=0';
  } else {
    url += '&page_num=' + params.page_num;
  }

  if (params.num_each_page) {
    url += '&num_each_page=' + params.num_each_page;
  }

  if (params.keyword) {
    url += '&keyword=' + params.keyword;
  }
  if (params.is_allow_self_cloud) {
    url += '&is_allow_self_cloud=' + params.is_allow_self_cloud;
  }
  if (params.is_allow_ent_cloud) {
    url += '&is_allow_ent_cloud=' + params.is_allow_ent_cloud;
  }
  // sort_by_name:self.listSort.byUpName,sort_by_email:self.listSort.ByEmail,sort_by_ctime:self.listSort.ByCtime
  if (params.sort_by_name) {
    url += '&sort_by_name=' + params.sort_by_name;
  } else if (params.sort_by_email) {
    url += '&sort_by_email=' + params.sort_by_email;
  } else if (params.sort_by_ctime) {
    url += '&sort_by_ctime=' + params.sort_by_ctime;
  }
  return __WEBPACK_IMPORTED_MODULE_0__router_http__["b" /* ajaxGet */](url);
}

/**
 * 获取用户信息
 */
function searchUser(params) {
  var url = prefix + '/user_team/search?keyword=' + params.keyword + '&page_num=' + params.page_num + '&num_each_page=' + params.num_each_page + '&type=user&is_filter_master=' + params.is_filter_master;
  if (params.is_allow_self_cloud) {
    url += '&is_allow_self_cloud=' + params.is_allow_self_cloud;
  }
  if (params.is_allow_ent_cloud) {
    url += '&is_allow_ent_cloud=' + params.is_allow_ent_cloud;
  }
  return __WEBPACK_IMPORTED_MODULE_0__router_http__["b" /* ajaxGet */](url);
}

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDynamicList;
/* harmony export (immutable) */ __webpack_exports__["b"] = getCommentList;
/* harmony export (immutable) */ __webpack_exports__["c"] = getNoticeList;
/* harmony export (immutable) */ __webpack_exports__["h"] = cleanMsg;
/* harmony export (immutable) */ __webpack_exports__["i"] = cleanComment;
/* harmony export (immutable) */ __webpack_exports__["d"] = getRedpoint;
/* harmony export (immutable) */ __webpack_exports__["e"] = setMsgStatus;
/* harmony export (immutable) */ __webpack_exports__["f"] = setCommentStatus;
/* harmony export (immutable) */ __webpack_exports__["g"] = setNoticeStatus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_http__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util__ = __webpack_require__(0);

/**
 * Created by Smile on 2017/9/2.
 */


var prefix = '/v2';

/**
 * 获取消息动态列表
 * @param {object} params
 * @param {function} params.callback 回调函数
 * @param {string} params.uid 用户id
 *@param {string} params.page_num 当前页码
 *@param {string} params.page_size 每页显示条数
 */
function getDynamicList(params) {
  var url = prefix + '/message/list_msg';
  url += '?page_num=' + params.page_num + '&page_size=' + params.page_size + '&is_update=false';
  return __WEBPACK_IMPORTED_MODULE_1__router_http__["b" /* ajaxGet */](encodeURI(url));
}
/**
 * 获取@我的评论列表
 * @param {object} params
 * @param {function} params.callback 回调函数
 * @param {string} params.uid 用户id
 *@param {string} params.page_num 当前页码
 *@param {string} params.page_size 每页显示条数
 *@param {string} params.is_need_total 总条数
 */
function getCommentList(params) {
  var url = prefix + '/comment/list_comment';
  url += '?page_num=' + params.page_num + '&num_each_page=' + params.num_each_page + '&is_need_total=' + params.is_need_total;
  return __WEBPACK_IMPORTED_MODULE_1__router_http__["b" /* ajaxGet */](encodeURI(url));
}
/**
 * 获取公告列表
 * @param {object} params
 * @param {function} params.callback 回调函数
 * @param {string} params.limit 文件列表条数限制  从0开始
 * @param {string} params.offset 文件列表起始偏移量  从0开始
 * @param {string} params.sort 排序规则 asc，desc ，默认desc
 */
function getNoticeList(params) {
  var url = prefix + '/notice/pull';
  var queryString = [];
  if (params.limit) {
    queryString.push('limit=' + parseInt(params.limit));
  }
  if (params.offset !== undefined) {
    queryString.push('offset=' + parseInt(params.offset));
  }
  if (queryString.length > 0) {
    url += '?' + queryString.join('&');
  }
  return __WEBPACK_IMPORTED_MODULE_1__router_http__["b" /* ajaxGet */](encodeURI(url));
}
/**
 * （动态全部清空）
 @param {object} params
 @param {function} params.callback 回调函数
 @param {object} params.snapshot 这里存放metaData返回的数据
 */
function cleanMsg() {
  var url = prefix + '/message/clear_msg';
  var json = {
    uid: __WEBPACK_IMPORTED_MODULE_2_util__["c" /* getUserId */]()
  };
  var postData = 'json = ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(json);
  return __WEBPACK_IMPORTED_MODULE_1__router_http__["c" /* ajaxPost */](encodeURI(url), postData);
}
/**
 * （@我的评论全部清空）
 @param {object} params
 @param {function} params.callback 回调函数
 */
function cleanComment() {
  var url = prefix + '/comment/clear_comment';
  var postData = {};
  return __WEBPACK_IMPORTED_MODULE_1__router_http__["c" /* ajaxPost */](encodeURI(url), postData);
}
/**
 * 获取消息动态小红点
 * @param {object} params
 * @param {function} params.callback 回调函数
 * @param {string} params.uid 用户id
 *@param {string} params.page_num 当前页码
 *@param {string} params.page_size 每页显示条数
 */
function getRedpoint() {
  var url = prefix + '/comment/get_redpoint';
  return __WEBPACK_IMPORTED_MODULE_1__router_http__["b" /* ajaxGet */](encodeURI(url));
}
/**
 * 设置消息为已读
 * @param params
 * @param {array} params.logIds 消息id
 * @param {function} params.callback 回调函数
 */
function setMsgStatus(params) {
  var url = prefix + '/message/set_msg_status';
  var postData = {
    logId: params.logId
  };
  return __WEBPACK_IMPORTED_MODULE_1__router_http__["c" /* ajaxPost */](encodeURI(url), postData);
}
/**
 * 设置评论为已读
 * @param params
 * @param {array} params.lastedTime 消息id
 * @param {function} params.callback 回调函数
 */
function setCommentStatus(params) {
  var url = prefix + '/comment/batch_update';
  var postData = {
    latestId: params.lastedId
  };
  return __WEBPACK_IMPORTED_MODULE_1__router_http__["c" /* ajaxPost */](encodeURI(url), postData);
}
/**
 * 公告未读变已读
 @param {object} params
 @param {function} params.callback 回调函数
 */
function setNoticeStatus(params) {
  var url = prefix + '/notice/batch_modify';
  var postData = {
    latestId: params.lastedId
  };
  return __WEBPACK_IMPORTED_MODULE_1__router_http__["c" /* ajaxPost */](encodeURI(url), postData);
}

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  posts: "My posts",
  contact: "Contact us",
  about: "About"
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__categories__ = __webpack_require__(106);


/* harmony default export */ __webpack_exports__["a"] = ({
  categories: __WEBPACK_IMPORTED_MODULE_0__categories__["a" /* default */],
  welcome: '{0} welcome to  {1}',
  upload: 'file upload',
  share: 'My Share',
  edit: 'edit 1',
  login_title: 'Lenovo Box',
  login_inputUsername: 'please Input User name',
  login_submit_text: 'submit',
  upload_progress_text: 'Uploading {0} files ({1} files)...',
  upload_complete_text: '{0} file transfer completed',
  message_dynamic_create_folder: '{0} has created a new folder "{1}"',
  message_dynamic_upload_file: '{0} uploaded a file "{1}"',
  message_dynamic_upload_folder: '{0} uploaded a file "{1}"',
  message_dynamic_update_file: '{0} has updated a file "{1}"',
  message_dynamic_add_auth: '{0} in the folder "{1}" has granted you the "{2}" permission',
  message_dynamic_update_auth: '{0} in the folder "{1}" changes your permissions from "{2}" to "{3}"',
  message_dynamic_delete_auth: '{0} removes your permissions in the folder "{1}"',
  message_dynamic_add_auth_for_share_folder: '{0} in the shared folder "{1}" gives you the "{2}" permission',
  message_dynamic_update_auth_for_share_folder: '{0} in the shared folder "{1}" changes your permissions from "{2}" to "{3}"',
  message_dynamic_delete_auth_for_share_folder: '{0} has removed your permissions on the shared file / folder "{1}"',
  message_dynamic_hand_over_share_folder_self: 'Your shared file / folder {0} is handed over to {1} by the administrator',
  message_dynamic_hand_over_share_folder: 'Administrator hand over the {0}\'s shared file / folder {1} to you',
  message_dynamic_update_user_name: 'Administrator updates your name to {0}',
  message_dynamic_update_user_mail: 'Administrator updates your mailbox information to {0}',
  message_dynamic_update_user_phone: 'Administrator updates your cell phone number to {0}',
  message_dynamic_update_user_datacenter: 'Administrator has adjusted your personal local space to {0}',
  message_dynamic_open_user_space: 'Administrator has opened your personal local space, size {0}, and configured your data center to {1}',
  message_dynamic_update_user_space: 'Administrator has adjusted your personal local space to {0}',
  message_dynamic_close_user_space: 'Administrator has closed your personal local space',
  message_dynamic_open_user_cloud_space: 'Administrator has opened your personal cloud space, {0} in size',
  message_dynamic_update_user_cloud_space: 'Administrator has adjusted your personal cloud space to {0}',
  message_dynamic_close_user_cloud_space: 'Administrator has closed your personal cloud space',
  message_dynamic_open_enterprise_cloud_space: 'Administrators have opened enterprise cloud space',
  message_dynamic_update_enterprise_cloud_space: 'Administrators updated the enterprise cloud space',
  message_dynamic_close_enterprise_cloud_space: 'Administrators have shut down enterprise cloud space',
  message_dynamic_open_speed_limit: 'Administrator opened the speed limit for the client transport, upload the threshold of {0}, download the threshold of {1}',
  message_dynamic_update_upload_speed: 'Administrator adjusts your client upload speed limit to {0}',
  message_dynamic_update_download_speed: 'Administrator adjusts your client download speed limit to {0}',
  message_dynamic_close_speed_limit: 'Administrator has closed your client speed limit',
  message_comment_content: '{0} mentioned you in "{1}"'
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  posts: "Postagens",
  about: "Sobre",
  contact: "Contato"
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__categories__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  categories: __WEBPACK_IMPORTED_MODULE_0__categories__["a" /* default */],
  welcome: '{0} {1} \u6B22\u8FCE\u4F60\uFF01',
  upload: '\u6587\u4EF6\u4E0A\u4F20',
  share: '\u6211\u7684\u5206\u4EAB1111',
  edit: '\u6211\u7684\u7F16\u8F91',
  login_title: '\u8054\u60F3\u4E91\u5B58\u50A8\u7CFB\u7EDF',
  login_inputUsername: '\u8BF7\u8F93\u5165\u7528\u6237\u540D',
  login_submit_text: '\u786E\u5B9A',
  upload_progress_text: '\u6B63\u5728\u4E0A\u4F20{0}\u4E2A\uFF08\u5171{1}\u4E2A\uFF09\u6587\u4EF6...',
  upload_complete_text: '{0}\u4E2A\u6587\u4EF6\u4F20\u8F93\u5B8C\u6210',
  message_dynamic_create_folder: '{0}新建了一个文件夹"{1}"',
  message_dynamic_upload_file: '{0}上传了一个文件"{1}"',
  message_dynamic_upload_folder: '{0}上传了一个文件"{1}"',
  message_dynamic_update_file: '{0}更新了一个文件"{1}"',
  message_dynamic_add_auth: '{0}在文件夹"{1}"为您授予了"{2}"权限',
  message_dynamic_update_auth: '{0}在文件夹"{1}"将您的权限由"{2}"修改为"{3}"',
  message_dynamic_delete_auth: '{0}删除了您在文件夹"{1}"的权限',
  message_dynamic_add_auth_for_share_folder: '{0}在共享文件夹"{1}"为您授予了"{2}"权限',
  message_dynamic_update_auth_for_share_folder: '{0}在共享文件夹"{1}"将您的权限由"{2}"修改为"{3}"',
  message_dynamic_delete_auth_for_share_folder: '{0}删除了您在共享文件夹"{1}"的权限',
  message_dynamic_hand_over_share_folder_self: '您的共享文件夹"{0}"被管理员移交给了"{1}"',
  message_dynamic_hand_over_share_folder: '管理员将"{0}"的共享文件夹"{1}"移交给了您',
  message_dynamic_update_user_name: '管理员将您的姓名更新为{0}',
  message_dynamic_update_user_mail: '管理员将您的邮箱信息更新为{0}',
  message_dynamic_update_user_phone: '管理员将您的手机号信息更新为{0}',
  message_dynamic_update_user_datacenter: '管理员将您的个人本地空间调整为{0}',
  message_dynamic_open_user_space: '管理员开启了您的个人本地空间，空间大小为{0}，并将您所属数据中心配置为{1}',
  message_dynamic_update_user_space: '管理员将您的个人本地空间调整为{0}',
  message_dynamic_close_user_space: '管理员关闭了您的个人本地空间',
  message_dynamic_open_user_cloud_space: '管理员开启了您的个人云空间，空间大小为{0}',
  message_dynamic_update_user_cloud_space: '管理员将您的个人云空间调整为{0}',
  message_dynamic_close_user_cloud_space: '管理员关闭了您的个人云空间',
  message_dynamic_open_enterprise_cloud_space: '管理员开启了企业云空间',
  message_dynamic_update_enterprise_cloud_space: '管理员更新了企业云空间',
  message_dynamic_close_enterprise_cloud_space: '管理员关闭了企业云空间',
  message_dynamic_open_speed_limit: '管理员为您开启了客户端传输限速，上传阀值为{0},下载阀值为{1}',
  message_dynamic_update_upload_speed: '管理员将您的客户端上传限速阀值调整为{0}',
  message_dynamic_update_download_speed: '管理员将您的客户端下载限速阀值调整为{0}',
  message_dynamic_close_speed_limit: '管理员关闭了您的客户端限速',
  message_comment_content: '{0}在"{1}"中提到了你'
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_router__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multilanguage__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multilanguage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multilanguage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lang_language__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_http__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_js_events_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_infinite_scroll__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_loadmore__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_loadmore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_loadmore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mint_ui_lib_style_css__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mint_ui_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mint_ui_lib_style_css__);












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_multilanguage___default.a, __WEBPACK_IMPORTED_MODULE_5__lang_language__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_infinite_scroll___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7__common_js_events_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$ajax = __WEBPACK_IMPORTED_MODULE_6__router_http__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_loadmore___default.a.name, __WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_loadmore___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('search', {
  bind: function bind(el, binding, vnode) {
    if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.fileInfo.isSearch) {
      var keyword = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.searchKeyword;
      var txt = void 0;
      if (keyword === '.') {
        txt = binding.value.replace(new RegExp(/\./, 'g'), '<label style="color:red">' + keyword + '</label>');
      } else {
        txt = binding.value.replace(new RegExp(keyword, 'g'), '<label style="color:red">' + keyword + '</label>');
      }

      el.innerHTML = txt;
    } else {
      el.innerHTML = binding.value;
    }
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router_router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SDK_CommentsManager__ = __webpack_require__(104);


var comments = {
  state: {
    isAuth: -1,
    comments: [],
    mentionUsers: {
      contents: [],
      pageNum: 0,
      loading: false,
      hasMore: true
    },
    searchMentionUsers: {
      contents: [],
      pageNum: 0,
      loading: false,
      hasMore: true
    },
    comments_total: 0,
    commentsStatus: -1,
    hasMore: true,
    isRefresh: false,
    isLoading: false,
    page_num: 1
  },
  getters: {
    getComments: function getComments(state) {
      return state.comments;
    },
    getCommentsHasMore: function getCommentsHasMore(state) {
      return state.hasMore;
    },
    getCommentsLoading: function getCommentsLoading(state) {
      return state.isLoading;
    },
    getMentionUsersList: function getMentionUsersList(state) {
      return state.mentionUsers.contents;
    },
    getSearchMentionUsersList: function getSearchMentionUsersList(state) {
      return state.searchMentionUsers.contents;
    },
    getCommentsStatus: function getCommentsStatus(state) {
      return state.commentsStatus;
    },
    getCommentsMentionHasMore: function getCommentsMentionHasMore(state) {
      return state.mentionUsers.hasMore;
    },
    getCommentsMentionLoading: function getCommentsMentionLoading(state) {
      return state.mentionUsers.loading;
    },
    getCommentsSearchMentionHasMore: function getCommentsSearchMentionHasMore(state) {
      return state.searchMentionUsers.hasMore;
    },
    getCommentsSearchMentionLoading: function getCommentsSearchMentionLoading(state) {
      return state.searchMentionUsers.loading;
    },
    getCurrentPageNum: function getCurrentPageNum(state) {
      return state.page_num;
    },
    getCurrentIsRefresh: function getCurrentIsRefresh(state) {
      return state.isRefresh;
    },
    getCurrentMentionNum: function getCurrentMentionNum(state) {
      return state.mentionUsers.pageNum;
    },
    getMentionAuth: function getMentionAuth(state) {
      return state.isAuth;
    },
    getCurrentSearchMentionNum: function getCurrentSearchMentionNum(state) {
      return state.searchMentionUsers.pageNum;
    }
  },
  mutations: {
    setComments: function setComments(state, obj) {
      state.comments = state.comments.concat(obj);
      state.hasMore = obj.length === 10;
      state.page_num += 1;
      state.isRefresh = false;
    },
    resetComments: function resetComments(state) {
      state.isRefresh = true;
      state.comments = [];
      state.hasMore = true;
      state.page_num = 1;
    },
    setMentionUsers: function setMentionUsers(state, obj) {
      state.mentionUsers.contents = state.mentionUsers.contents.concat(obj.content);
      state.mentionUsers.hasMore = obj.content.length === 12;
      state.mentionUsers.pageNum += 1;
    },
    setSearchMentionUsers: function setSearchMentionUsers(state, obj) {
      state.searchMentionUsers.contents = state.searchMentionUsers.contents.concat(obj.content);
      state.searchMentionUsers.hasMore = obj.content.length === 12;
      state.searchMentionUsers.pageNum += 1;
    },
    setStatus: function setStatus(state, obj) {
      state.commentsStatus = obj;
    },
    setCommentsMentionLoading: function setCommentsMentionLoading(state, obj) {
      state.mentionUsers.loading = obj;
    },
    setCommentsSearchMentionLoading: function setCommentsSearchMentionLoading(state, obj) {
      state.searchMentionUsers.loading = obj;
    },
    resetMentionUsers: function resetMentionUsers(state) {
      state.mentionUsers.hasMore = true;
      state.mentionUsers.contents = [];
      state.mentionUsers.pageNum = 0;
    },
    resetSearchMentionUsers: function resetSearchMentionUsers(state) {
      state.searchMentionUsers.hasMore = true;
      state.searchMentionUsers.contents = [];
      state.searchMentionUsers.pageNum = 0;
    },
    setAuth: function setAuth(state, obj) {
      state.isAuth = obj.retval;
    },
    resetAuth: function resetAuth(state) {
      state.isAuth = -1;
    }
  },
  actions: {
    getComments: function getComments(_ref, obj) {
      var commit = _ref.commit;

      var currentFile = obj.param.currentFile;
      currentFile.page_num = obj.param.page_num;
      __WEBPACK_IMPORTED_MODULE_0__SDK_CommentsManager__["a" /* getComments */](currentFile).then(function (response) {
        if (response.comments) {
          commit('setStatus', 200);
          commit('setComments', response.comments);
        } else {
          commit('setStatus', 0);
          commit('setComments', []);
        }
      }, function (err) {
        commit('setStatus', 0);
        commit('setComments', []);
        console.log(err);
      });
    },
    deleteComments: function deleteComments(_ref2, obj) {
      var commit = _ref2.commit;

      __WEBPACK_IMPORTED_MODULE_0__SDK_CommentsManager__["b" /* deleteComment */](obj.param).then(function (response) {
        console.log(response);
        commit('setStatus', 202);
      });
    },
    getMentionUsers: function getMentionUsers(_ref3, obj) {
      var commit = _ref3.commit;

      __WEBPACK_IMPORTED_MODULE_0__SDK_CommentsManager__["c" /* listForPages */](obj.param).then(function (response) {
        commit('setMentionUsers', response);
        commit('setCommentsMentionLoading', false);
      });
    },
    getSearchMentionUsers: function getSearchMentionUsers(_ref4, obj) {
      var commit = _ref4.commit;

      __WEBPACK_IMPORTED_MODULE_0__SDK_CommentsManager__["d" /* searchUser */](obj.param).then(function (response) {
        commit('setSearchMentionUsers', response);
        commit('setCommentsSearchMentionLoading', false);
      });
    },
    createComments: function createComments(_ref5, obj) {
      var commit = _ref5.commit;

      __WEBPACK_IMPORTED_MODULE_0__SDK_CommentsManager__["e" /* createComment */](obj.param).then(function (response) {
        commit('setStatus', 201);
        console.log(response);
      });
    },
    checkWhetherAuth: function checkWhetherAuth(_ref6, obj) {
      var commit = _ref6.commit;

      __WEBPACK_IMPORTED_MODULE_0__SDK_CommentsManager__["f" /* checkWhetherAuth */](obj.param).then(function (response) {
        commit('setAuth', response);
      });
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (comments);

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// 测面滑动菜单效果
var SHOW_MENU = true;
var HIDE_MENU = false;

var actionlist = {
  state: {
    isShow: false,
    detail: {
      title: 'title : by 把苹果咬哭',
      content: []
    }
  },
  mutations: {
    showActionMenu: function showActionMenu(state, obj) {
      state.detail = obj === undefined ? state.detail : obj.amount;
      state.isShow = SHOW_MENU;
    },
    hideActionMenu: function hideActionMenu(state) {
      state.detail = {};
      state.isShow = HIDE_MENU;
    }
  },
  actions: {
    showActionMenuList: function showActionMenuList(_ref, obj) {
      var commit = _ref.commit;

      commit('showActionMenu', obj);
      // 解决当上传窗口打开，点击取消，下次无法上传的问题
      commit('setStartUpload', false);
    },
    hideActionMenuList: function hideActionMenuList(_ref2) {
      var commit = _ref2.commit;

      commit('hideActionMenu');
    }
  },
  getters: {
    getActionListIsShow: function getActionListIsShow(state) {
      return state.isShow;
    },
    getShowActionMenuInfo: function getShowActionMenuInfo(state) {
      return state.detail;
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (actionlist);

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_util__ = __webpack_require__(0);


var SHOW_MENU = true;
var HIDE_MENU = false;

var menulist = {
  state: {
    isShow: false,
    menuListDefault: {
      title: 'title : by 把苹果咬哭',
      content: {
        download: {
          id: 1,
          name: '下载',
          type: 'router',
          action: 'download'
        },
        preview: {
          id: 2,
          name: '预览',
          type: 'router',
          action: 'preview'
        },
        delivery: {
          id: 3,
          name: '外链分享',
          type: 'router',
          action: 'delivery'
        },
        cancelDelivery: {
          id: 4,
          name: '取消外链',
          type: 'router',
          action: 'cancelDelivery'
        },
        favorite: {
          id: 5,
          name: '收藏',
          type: 'router',
          action: 'favorite'
        },
        cancelFavorite: {
          id: 6,
          name: '取消收藏',
          type: 'router',
          action: 'cancelFavorite'
        },
        comment: {
          id: 7,
          name: '评论',
          type: 'router',
          action: 'comment'
        },
        move: {
          id: 8,
          name: '移动',
          type: 'router',
          action: 'move'
        },
        copy: {
          id: 9,
          name: '复制',
          type: 'router',
          action: 'copy'
        },
        rename: {
          id: 10,
          name: '重命名',
          type: 'router',
          action: 'rename'
        },
        detail: {
          id: 11,
          name: '详情',
          type: 'router',
          action: 'detail'
        },
        history: {
          id: 12,
          name: '历史版本',
          type: 'router',
          action: 'history'
        },
        delete: {
          id: 13,
          name: '删除',
          type: 'router',
          color: '#FE3824',
          action: 'delete'
        }
      }
    },
    menuList: {
      title: '',
      content: []
    }
  },
  mutations: {
    showMenu: function showMenu(state, fileInfo) {
      var compare = function compare(prop) {
        return function (obj1, obj2) {
          var val1 = obj1[prop];
          var val2 = obj2[prop];
          if (val1 < val2) {
            return -1;
          } else if (val1 > val2) {
            return 1;
          } else {
            return 0;
          }
        };
      };

      state.menuList.title = fileInfo.currentFile.name;
      state.menuList.content = [];
      var auth = __WEBPACK_IMPORTED_MODULE_0__common_js_util__["e" /* getCSSActionByCode */](fileInfo.currentFile.access_mode).authCSS.split(':');
      for (var o in auth) {
        if (state.menuListDefault.content[auth[o]]) {
          // GY,BUG40747,选择团队文件夹，更多菜单里不应该显示重命名、移动和删除按钮
          if (fileInfo.currentFile.is_team && fileInfo.currentFile.is_dir && auth[o] === 'rename') {
            continue;
          }
          if (fileInfo.currentFile.is_team && fileInfo.currentFile.is_dir && auth[o] === 'move') {
            continue;
          }
          if (fileInfo.currentFile.is_team && fileInfo.currentFile.is_dir && auth[o] === 'delete') {
            continue;
          }
          if (!__WEBPACK_IMPORTED_MODULE_0__common_js_util__["f" /* canPreview */](fileInfo.currentFile.mime_type) && auth[o] === 'preview') {
            continue;
          }
          // 如果是文件夹则不显示下载按钮
          if (fileInfo.currentFile.is_dir && auth[o] === 'download') {
            continue;
          }
          if (fileInfo.currentFile.is_dir && auth[o] === 'comment') {
            continue;
          }
          // 共享根目录下不支持重命名
          if ((fileInfo.currentFolder.path_type === 'share_in' || fileInfo.currentFolder.path_type === 'share_out') && fileInfo.currentFolder.path === '/' && auth[o] === 'rename') {
            continue;
          }
          if (fileInfo.currentFile.is_dir && fileInfo.currentFolder.path_type === 'favorite' && fileInfo.currentFolder.path === '/' && (auth[o] === 'rename' || auth[o] === 'delete')) {
            continue;
          }
          if (!fileInfo.currentFile.is_dir && fileInfo.currentFolder.path_type === 'favorite' && fileInfo.currentFolder.path === '/' && (auth[o] === 'rename' || auth[o] === 'delete' || auth[o] === 'move' || auth[o] === 'copy' || auth[o] === 'comment')) {
            continue;
          }
          state.menuList.content.push(state.menuListDefault.content[auth[o]]);
        }
      }
      if (!fileInfo.currentFile.is_dir) {
        state.menuList.content.push(state.menuListDefault.content['history']);
      }
      // 外链code不为空 添加取消外链功能
      if (fileInfo.currentFile.delivery_code !== '') {
        state.menuListDefault.content.delivery.name = '查看外链';
        state.menuList.content.push(state.menuListDefault.content['cancelDelivery']);
      } else {
        state.menuListDefault.content.delivery.name = '外链分享';
      }
      // 文件已经收藏，添加取消收藏功能
      if (fileInfo.currentFile.is_bookmark === true || fileInfo.currentFolder.path_type === 'favorite') {
        state.menuListDefault.content.favorite.name = '取消收藏';
        state.menuList.content.push(state.menuListDefault.content['cancelFavorite']);
      } else {
        state.menuListDefault.content.favorite.name = '收藏';
        state.menuList.content.push(state.menuListDefault.content['favorite']);
      }
      state.menuList.content.push(state.menuListDefault.content['detail']);
      state.menuList.content.sort(compare('id'));
      state.isShow = SHOW_MENU;
    },
    hideMenu: function hideMenu(state) {
      // state.detail = {}
      state.isShow = HIDE_MENU;
    }
  },
  actions: {
    showMenuList: function showMenuList(_ref, obj) {
      var commit = _ref.commit,
          rootState = _ref.rootState;

      commit('showMenu', rootState.fileInfo);
    },
    hideMenuList: function hideMenuList(_ref2) {
      var commit = _ref2.commit;

      commit('hideMenu');
    }
  },
  getters: {
    getIsShow: function getIsShow(state) {
      return state.isShow;
    },
    getShowMenuList: function getShowMenuList(state) {
      return state.menuList;
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (menulist);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SDK_DeliveryManager__ = __webpack_require__(53);

// import * as Util from '../../common/js/util'

var SHOW_MENU = true;
var HIDE_MENU = false;

var link = {
  state: {
    isShow: false,
    deliveryInfo: {
      access_mode: 4095,
      // code: '5130f383d90b460fbebc2a1eec9cd2a8',
      code: '',
      // counter_download: 0,
      // counter_preview: 0,
      // counter_upload: 0,
      ctime: '',
      expiration: -1,
      has_password: '',
      id: '',
      mime_type: '',
      mode: '',
      mtime: '',
      neid: '',
      nsid: '',
      password: '',
      path: '',
      type: '',
      url: ''
    }
  },
  getters: {
    getLinkIsShow: function getLinkIsShow(state) {
      return state.isShow;
    },

    getDelivery: function getDelivery(state) {
      return state.content;
    }
    // getDeliveryCode: state => state.deliveryInfo.code,
    // getDeliveryCtime: state => state.deliveryInfo.ctime,
    // getDeliveryExpiration: state => state.deliveryInfo.expiration,
    // getDeliveryHasPassword: state => state.deliveryInfo.has_password,
    // getDeliveryId: state => state.deliveryInfo.id,
    // getDeliveryMimeType: state => state.deliveryInfo.mime_type,
    // getDeliveryMode: state => state.deliveryInfo.mode,
    // getDeliveryMtime: state => state.deliveryInfo.mtime,
    // getDeliveryNeid: state => state.deliveryInfo.neid,
    // getDeliveryNsid: state => state.deliveryInfo.nsid,
    // getDeliveryPassword: state => state.deliveryInfo.password,
    // getDeliveryPath: state => state.deliveryInfo.path,
    // getDeliveryType: state => state.deliveryInfo.type,
    // getDeliveryUrl: state => state.deliveryInfo.url
  },
  mutations: {
    showLink: function showLink(state, obj) {
      state.isShow = SHOW_MENU;
    },
    hideLink: function hideLink(state) {
      state.isShow = HIDE_MENU;
    },
    showDeliveryConfirmTips: function showDeliveryConfirmTips(state, obj) {
      state.deliveryconfirmTipsIsShow = true;
    },
    hideDeliveryConfirmTips: function hideDeliveryConfirmTips(state, obj) {
      state.deliveryconfirmTipsIsShow = false;
    },

    //   let contents = obj
    //   for (let i = 0; i < contents.length; i++) {
    //     let file = {}
    //     let item = contents[i]
    //     let d = Util.resolvePath(item.path, item.is_dir)
    //     file.access_mode = item.access_mode
    //     file.code = item.code
    //     file.counter_download = item.counter_download
    //     file.counter_preview = item.counter_preview
    //     file.counter_upload = item.counter_upload
    //     file.ctime = item.ctime
    //     file.description = item.description
    //     file.expiration = item.expiration
    //     file.has_password = item.has_password
    //     file.id = item.id
    //     file.mime_type = item.mime_type
    //     file.mode = item.mode
    //     file.cssAction = Util.getCSSActionByCode(item.mode).authCSS
    //     file.mtime = Util.formatDate(item.mtime, 'yyyy-MM-dd' + ' hh:mm')
    //     file.neid = item.neid
    //     file.nsid = item.nsid
    //     file.password = item.password
    //     file.path = item.path
    //     file.type = d.is_dir
    //     file.url = item.url
    //     state.content.push(file)
    //   }
    //   // state.content = files
    // },
    // setAuth (state, obj) {
    //   state.upload = Util.getPrivatePrivilege(state.content.cssAction || state.content.action).canUpload
    //   state.download = Util.getPrivatePrivilege(state.content.cssAction || state.content.action).canDownload
    //   state.preview = Util.getPrivatePrivilege(state.content.cssAction || state.content.action).canPreview
    // },
    getDeliveryInfo: function getDeliveryInfo(state, obj) {},
    cancelDeliveryInfo: function cancelDeliveryInfo(state, obj) {}
  },
  actions: {
    showLinkInfo: function showLinkInfo(_ref, obj) {
      var commit = _ref.commit;

      commit('showLink', obj);
    },
    hideLinkInfo: function hideLinkInfo(_ref2) {
      var commit = _ref2.commit;

      commit('hideLink');
    },
    createDelivery: function createDelivery(_ref3, obj) {
      var commit = _ref3.commit;

      __WEBPACK_IMPORTED_MODULE_0__SDK_DeliveryManager__["b" /* create */](obj.param).then(function (response) {
        console.log('创建数据' + response);
      });
    },
    getDelivery: function getDelivery(_ref4, obj) {
      var commit = _ref4.commit;

      __WEBPACK_IMPORTED_MODULE_0__SDK_DeliveryManager__["c" /* getDeliveryInfo */](obj.param).then(function (response) {
        console.log(response);
      });
    },
    cancelDelivery: function cancelDelivery(_ref5, obj) {
      var commit = _ref5.commit;

      __WEBPACK_IMPORTED_MODULE_0__SDK_DeliveryManager__["d" /* delDelivery */](obj.params).then(function (response) {
        console.log(response);
        if (response === '') {
          commit('setToast', { isShow: true, message: '取消成功', iconClass: 'icon-success' });
          commit('setIsReloadFilelist', true);
          // commit('setCurrentPathType')
        }
      }, function (err) {
        commit('setToast', { isShow: true, message: '取消失败', iconClass: 'icon-error' });
        console.log(err);
      });
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (link);

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SDK_FileManager__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SDK_DeliveryManager__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_js_util__ = __webpack_require__(0);




var deliveryTransfor = {
  state: {
    isShow: false,
    title: '请选择要转存的位置',
    isRoot: true,
    currentPath: '',
    content: [],
    currentFolder: {},
    isShowCreate: false,
    isSuccess: false,
    isBackReload: false,
    linkInfo: {}
    // linkInfo: {
    //   'uid': '33',
    //   'neid': '379',
    //   'nsid': '33',
    //   'path': '/测试xls.xls',
    //   'mode': 'rp',
    //   'protected': false,
    //   'password': '',
    //   'expiration': '-1',
    //   'type': 'file',
    //   'description': '',
    //   'ctime': '2018-01-26 17:29:54',
    //   'mtime': '2018-01-30 11:14:26',
    //   'counter_download': '1',
    //   'counter_upload': '0',
    //   'counter_preview': '0',
    //   'is_checked_watermark': '0',
    //   '_id': 'c0911a8979474edd8ae77bce1a7fff3e',
    //   'filename': '测试xls.xls',
    //   'url': 'http://172.16.52.67/link/view/c0911a8979474edd8ae77bce1a7fff3e',
    //   'account_expiration': false,
    //   'user_name': 'gyn',
    //   'preview': {
    //     'rev': '03f9c690c0354251bd66f50b7ea73861',
    //     'desc': '',
    //     'bytes': 18944,
    //     'preview_url': 'http://172.16.52.67:10081/v2/wopi/delivery/c0911a8979474edd8ae77bce1a7fff3e/?mimetype=.xls&neid=379&user_name=gyn',
    //     'updator': 'gyn',
    //     'delivery_creator_uid': 33,
    //     'creator': 'gyn',
    //     'data_url': 'http://idt.lenovows.com/delivery/data/c0911a8979474edd8ae77bce1a7fff3e/',
    //     'thumb_exist': false,
    //     'delivery_code': 'c0911a8979474edd8ae77bce1a7fff3e',
    //     'mime_type': 'doc/.xls',
    //     'download_url': 'http://172.16.52.67:10081/v2/delivery/data/c0911a8979474edd8ae77bce1a7fff3e/',
    //     'path': '/测试xls.xls',
    //     'client_mtime': '2018-01-30T11:17:50+0800',
    //     'delivery_desc': '',
    //     'neid': 379,
    //     'lock_uid': 0,
    //     'hash': '31c1fdc1a8e958df8f59fab9809b7e32',
    //     'delivery_mtime': '2018-01-30T11:14:26+0800',
    //     'watermarkDownloadUrl': '',
    //     'upload_url': 'http://172.16.52.67:10081/v2/delivery/data/c0911a8979474edd8ae77bce1a7fff3e/',
    //     'downLoad_available': true,
    //     'metadata_url': 'http://172.16.52.67/v2/delivery/metadata/c0911a8979474edd8ae77bce1a7fff3e/',
    //     'delivery_creator': 'gyn',
    //     'access_mode': 1029,
    //     'modified': '2018-01-24T10:25:55+0800',
    //     'size': '18.5 KB',
    //     'is_shared': false,
    //     'is_dir': false
    //   },
    //   'canview': 1,
    //   'thumb_exist': false
    // }
  },
  getters: {
    getLinkInfo: function getLinkInfo(state) {
      return state.linkInfo;
    }
  },
  mutations: {
    setIsBackReload: function setIsBackReload(state, obj) {
      state.isBackReload = obj;
    },
    setdeliverySuccess: function setdeliverySuccess(state, obj) {
      state.isSuccess = obj;
    },
    setTitle: function setTitle(state, obj) {
      state.title = obj;
    },
    setdeliveryIsRoot: function setdeliveryIsRoot(state, obj) {
      state.isRoot = obj;
    },
    setdeliveryIsShow: function setdeliveryIsShow(state, obj) {
      state.isShow = obj;
    },
    setDeliveryCurrentPath: function setDeliveryCurrentPath(state, obj) {
      state.currentPath = obj;
    },
    getList: function getList(state, obj) {
      state.linkInfo = obj;
    },
    getTransforList: function getTransforList(state, obj) {
      state.currentFolder = obj;
      state.content = [];
      var contents = obj.content;
      for (var i = 0; i < contents.length; i++) {
        var file = {};
        var item = contents[i];
        var d = __WEBPACK_IMPORTED_MODULE_2__common_js_util__["l" /* resolvePath */](item.path, item.is_dir);
        item.type = d.type;
        item.typeIcon = __WEBPACK_IMPORTED_MODULE_2__common_js_util__["q" /* typeIcon */](d.type);
        item.name = d.name;
        item.title = file.name;
        item.filename = file.name;
        item.size = __WEBPACK_IMPORTED_MODULE_2__common_js_util__["r" /* formatBytes */](item.bytes);
        item.datetime = __WEBPACK_IMPORTED_MODULE_2__common_js_util__["s" /* formatDate */](item.modified || item.datetime, 'yyyy-MM-dd' + ' hh:mm');
        item.authName = __WEBPACK_IMPORTED_MODULE_2__common_js_util__["t" /* getAuthNameByAccessMode */](item.access_mode).authName;
        if (item.dir_type === 2 || item.dir_type === 4) {
          // 2代表云端共享文件夹  4代表云端普通文件夹
          item.is_cloud = true;
          if (item.dir_type === 2) {
            item.is_shared = true;
          }
        } else {
          item.is_cloud = false;
        }
        if (item.is_dir) {
          if (item.is_shared && item.is_team) {
            item.typeIcon = 'folder_team';
          } else if (item.is_shared && item.is_cloud) {
            // 云端文件被共享
            item.typeIcon = 'cloud_share';
          } else if (item.is_cloud) {
            // 云端文件
            item.typeIcon = 'folder_cloud';
          } else if (item.is_shared) {
            item.typeIcon = 'folder_share';
          } else if (item.is_team) {
            item.typeIcon = 'folder_team';
          } else {
            item.typeIcon = 'folder';
          }
        }
        switch (item.dir_type) {
          case 1:
            item.category = '团队文件夹';
            break;
          case 2:
            item.category = '云端共享文件夹';
            break;
          case 4:
            item.category = '云端文件夹';
            break;
          case 6:
            item.category = '共享文件夹';
            break;
          case 8:
            item.category = '普通文件';
            break;
          default:
            item.category = '普通文件夹';
            break;
        }
        if (item.is_dir) {
          state.content.push(item);
        }
      }
    }
  },
  actions: {
    getTransforList: function getTransforList(_ref, obj) {
      var commit = _ref.commit;

      __WEBPACK_IMPORTED_MODULE_0__SDK_FileManager__["b" /* metaData */](obj.params).then(function (response) {
        commit('getTransforList', response);
      }, function (err) {
        console.log(err);
      });
    },

    // getDeliveryData ({commit}, obj) {
    //   DeliveryManager.deliveryMetaData(obj.params).then(response => {
    //     commit('getdumpList', response)
    //   }, err => {
    //     console.log(err)
    //   })
    // },
    deliveryTransforAddFolder: function deliveryTransforAddFolder(_ref2, obj) {
      var commit = _ref2.commit,
          rootState = _ref2.rootState,
          dispatch = _ref2.dispatch;

      var params = {
        path: '/' + rootState.deliveryTransfor.currentFolder.path + '/' + obj,
        path_type: rootState.deliveryTransfor.currentFolder.path_type,
        prefix_neid: rootState.deliveryTransfor.currentFolder.prefix_neid,
        from: rootState.deliveryTransfor.currentFolder.from
      };
      __WEBPACK_IMPORTED_MODULE_0__SDK_FileManager__["c" /* createFolder */](params).then(function (response) {
        commit('setAddFolderShow', false);
        var params = { path: rootState.deliveryTransfor.currentFolder.path,
          path_type: rootState.deliveryTransfor.currentFolder.path_type,
          prefix_neid: rootState.deliveryTransfor.currentFolder.prefix_neid,
          from: rootState.deliveryTransfor.currentFolder.from,
          limit: 1000,
          content_type: 'dir'
        };
        dispatch({
          type: 'getTransforList',
          params: params
        });
      }, function (err) {
        if (err.type === 'error') {
          commit('setToast', { isShow: true, message: err.message, iconClass: 'icon-error' });
        }
      });
    },
    deliveryTransfor: function deliveryTransfor(_ref3, obj) {
      var commit = _ref3.commit;

      __WEBPACK_IMPORTED_MODULE_1__SDK_DeliveryManager__["a" /* deliveryTransfor */](obj.params).then(function (response) {
        commit('setdeliverySuccess', true);
        commit('setToast', { isShow: true, message: '转存成功', iconClass: 'icon-success' });
      }, function (err) {
        commit('setdeliverySuccess', false);
        commit('setProgress', { isShow: false });
        commit('setToast', { isShow: true, message: err.message, iconClass: 'icon-error' });
      });
    },
    getInfo: function getInfo(_ref4, obj) {
      var commit = _ref4.commit;

      var info = window.localStorage.getItem('linkInfo');
      commit('getList', info);
      // window.localStorage.removeItem('linkInfo')
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (deliveryTransfor);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SDK_FileManager__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_util__ = __webpack_require__(0);



var SHOW_LIST = true;
var HIDE_LIST = false;
var fileInfo = {
  state: {
    isShow: true, // 是否显示文件列表
    // 是否需要重新加载filelist
    isReloadFilelist: false,
    // 是否为搜索模式
    isSearch: false,
    // 当前操作的文件
    currentFile: {},
    // 当前操作的文件的更多信息
    currentFileDetailMore: {},
    // 是否显示当前文件详情
    isShowFileDetail: false,
    // 是否显示当前文件的更多信息
    detailMore: false,
    // 创建文件夹后台返回的错误提示
    // isAddFolderErr: '',
    // 共享下文件重命名
    // isShareRenameError: '',
    // 当前目录信息
    currentFolder: {
      // 当前目录权限
      access_mode: 4095,
      // 路径类型
      path_type: 'ent',
      // 是否包含删除文件
      include_deleted: false,
      // 每页显示条数
      limit: 20,
      // 本次查询起始索引
      offset: 0,
      // 排序(升序、降序)
      sort: 'desc',
      // from
      from: '',
      // from_name
      from_name: '',
      // prefix_neid
      prefix_neid: '',
      // 排序类型
      orderBy: 'mtime',
      // 当前全路径
      fullPath: '',
      // 是否还有下一页
      haveMore: true,
      // 正在加载
      isLoading: true,
      // 当前路径
      path: '/',
      // 文件类型
      dir_type: ''
    },
    // 当前列表内容
    content: [],
    // 当前列表搜索内容
    searchContent: [],
    // 确认删除提示
    confirmTipsIsShow: '',
    // tip的标题
    tipsTitle: '',
    // 再次确认
    againConfirm: false,
    // 重命名组件
    renameDialogIsShow: false,
    // 新建文件夹
    addFolderShow: false,
    // 当前文件index
    currentIndex: 0,
    // 根路径名称
    rootPathName: '企业空间',
    // 数据中心
    region: ''
  },
  getters: {
    // 获取当前选中的文件索引
    getCurrentIndex: function getCurrentIndex(state) {
      return state.currentIndex;
    },
    // 获取当前文件夹中文件信息
    getFileList: function getFileList(state) {
      return state.content;
    },
    // 获取当前文件夹中文件信息
    getSearchList: function getSearchList(state) {
      return state.searchContent;
    },
    // 获取当前文件夹信息
    getCurrentFolderInfo: function getCurrentFolderInfo(state) {
      return state.currentFolder;
    },
    // 获取当前选中文件信息
    getCurrentFile: function getCurrentFile(state) {
      return state.currentFile;
    },
    // 获取当前选中文件更多信息
    getCurrentFileDetailMore: function getCurrentFileDetailMore(state) {
      return state.currentFileDetailMore;
    },
    // 获取当前选中文件更多信息
    isShowDetailMore: function isShowDetailMore(state) {
      return state.detailMore;
    },
    // 获取当前选中文件更多信息
    isShowFileDetail: function isShowFileDetail(state) {
      return state.isShowFileDetail;
    },
    // 获取当前文件夹每页条数
    getCurrentFolderLimit: function getCurrentFolderLimit(state) {
      return state.currentFolder.limit;
    },
    // 获取当前文件夹排序方式
    getCurrentFolderSort: function getCurrentFolderSort(state) {
      return state.currentFolder.sort;
    },
    // 获取当前文件夹排序方式
    getCurrentFolderOrderBy: function getCurrentFolderOrderBy(state) {
      return state.currentFolder.orderBy;
    },
    // 获取当前文件夹是否包含已删除文件
    getCurrentFolderIncludeDeleted: function getCurrentFolderIncludeDeleted(state) {
      return state.currentFolder.include_deleted;
    },
    // 获取当前文件夹是否包含已删除文件
    getCurrentFolderAccessMode: function getCurrentFolderAccessMode(state) {
      return state.currentFolder.access_mode;
    },
    // 获取当前路径
    getCurrentPath: function getCurrentPath(state) {
      return state.currentFolder.fullPath;
    },
    // 获取是否还有下一页
    getCurrentHaveMore: function getCurrentHaveMore(state) {
      return state.currentFolder.haveMore;
    },
    // 获取当前是否正在加载
    getCurrentsLoading: function getCurrentsLoading(state) {
      return state.currentFolder.isLoading;
    },
    // 获取当前路径
    getCurrentFolderOffset: function getCurrentFolderOffset(state) {
      return state.currentFolder.offset;
    },
    // 获取当前路径
    getRootPathName: function getRootPathName(state) {
      return state.rootPathName;
    },
    // 获取全路径
    getFullPath: function getFullPath(state) {
      return state.currentFolder.path;
    },
    // 获取全路径
    getIsDeletingFile: function getIsDeletingFile(state) {
      return state.currentFolder.deletingFile;
    },
    // 删除提示框是否显示
    getTipsIsShow: function getTipsIsShow(state) {
      return state.confirmTipsIsShow;
    },
    // 重命名是否显示
    getRenameIsShow: function getRenameIsShow(state) {
      return state.renameDialogIsShow;
    },
    // 重命名是否显示
    getIsSearch: function getIsSearch(state) {
      return state.isSearch;
    },
    // 获取全路径
    getCurrentPathType: function getCurrentPathType(state) {
      return state.currentFolder.path_type;
    }
  },
  mutations: {
    showFileList: function showFileList(state) {
      state.isShow = SHOW_LIST;
    },
    hideFileList: function hideFileList(state) {
      state.isShow = HIDE_LIST;
    },
    intoItem: function intoItem(state, obj) {
      state.currentFile = obj.param;
      state.currentFolder.fullPath = obj.param.name;
    },
    showConfirmTips: function showConfirmTips(state, obj) {
      state.confirmTipsIsShow = obj;
    },
    hideConfirmTips: function hideConfirmTips(state) {
      state.confirmTipsIsShow = '';
    },
    showRenameDialog: function showRenameDialog(state) {
      state.renameDialogIsShow = true;
    },
    hideRenameDialog: function hideRenameDialog(state) {
      state.renameDialogIsShow = false;
    },
    setAgainTipTitle: function setAgainTipTitle(state, obj) {
      state.tipsTitle = obj;
    },
    setAgainConfirm: function setAgainConfirm(state, obj) {
      state.againConfirm = obj;
    },

    // 插入当前文件夹中文件信息
    setFileList: function setFileList(state, obj) {
      var files = [];
      var contents = obj.content;
      for (var i = 0; i < contents.length; i++) {
        var file = {};
        var item = {};
        if (contents[i].snapshot) {
          item = contents[i].snapshot;
          item.path_type = contents[i].snapshot.path_type;
          item.bookmark_id = contents[i].id;
          item.is_bookmark = false;
        } else {
          item = contents[i];
        }
        var d = __WEBPACK_IMPORTED_MODULE_1__common_js_util__["l" /* resolvePath */](item.path, item.is_dir);
        item.type = d.type;
        item.typeIcon = __WEBPACK_IMPORTED_MODULE_1__common_js_util__["q" /* typeIcon */](d.type);
        item.name = d.name;
        item.title = file.name;
        item.filename = file.name;
        item.size = __WEBPACK_IMPORTED_MODULE_1__common_js_util__["r" /* formatBytes */](item.bytes);
        item.datetime = __WEBPACK_IMPORTED_MODULE_1__common_js_util__["s" /* formatDate */](item.modified || item.datetime, 'yyyy-MM-dd' + ' hh:mm');
        item.authName = __WEBPACK_IMPORTED_MODULE_1__common_js_util__["t" /* getAuthNameByAccessMode */](item.access_mode).authName;
        //          file.hasDelivery = item.delivery_code ||item.hasDelivery ? true : false
        //          file.islocked = item.lock_uid ? true : false
        //          file.deliveryTitle = file.hasDelivery ? _('查看外链') : _('外链分享')
        if (item.dir_type === 2 || item.dir_type === 4) {
          // 2代表云端共享文件夹  4代表云端普通文件夹
          item.is_cloud = true;
          if (item.dir_type === 2) {
            item.is_shared = true;
          }
        } else {
          item.is_cloud = false;
        }
        if (item.is_dir) {
          if (item.is_shared && item.is_team) {
            item.typeIcon = 'folder_team';
          } else if (item.is_shared && item.is_cloud) {
            // 云端文件被共享
            item.typeIcon = 'cloud_share';
          } else if (item.is_cloud) {
            // 云端文件
            item.typeIcon = 'folder_cloud';
          } else if (item.is_shared) {
            item.typeIcon = 'folder_share';
          } else if (item.is_team) {
            item.typeIcon = 'folder_team';
          } else {
            item.typeIcon = 'folder';
          }
        }
        switch (item.dir_type) {
          case 1:
            item.category = '团队文件夹';
            break;
          case 2:
            item.category = '云端共享文件夹';
            break;
          case 4:
            item.category = '云端文件夹';
            break;
          case 6:
            item.category = '共享文件夹';
            break;
          case 8:
            item.category = '普通文件';
            break;
          default:
            item.category = '普通文件夹';
            break;

        }
        if (item.is_shared) {
          if (!item.is_team) {
            //              file.category = _('共享文件夹')
          } else {
              //              if (item.path_type === "self"&& Util.isAdmin()) {
              //                file.category = _('普通文件夹')
              //              } else {
              //                file.category = _('团队文件夹')
              //              }
            }
        } else {
            //            file.category = _("普通文件夹")
          }
        if (!item.is_dir) {
          item.rev = item.rev;
          item.version = item.rev_index > 999 ? '999+' : item.rev_index;
        }
        files.push(item);
      }
      // console.log('offset:' + state.currentFolder.offset)
      if (state.currentFolder.offset > 0) {
        state.content = state.content.concat(files);
      } else {
        state.content = files;
      }
    },
    setFavoriteFileList: function setFavoriteFileList(state, obj) {
      var files = [];
      var contents = obj.content;
      for (var i = 0; i < contents.length; i++) {
        var file = {};
        var item = {};
        if (contents[i].snapshot) {
          item = contents[i].snapshot;
          item.path_type = contents[i].snapshot.path_type;
        } else {
          item = contents[i];
          item.bytes = 0;
          item.isFileModify = true; //  源文件被修改或者已删除
        }
        item.is_bookmark = false;
        item.bookmark_id = contents[i].id;
        item.path = contents[i].title;
        item.modified = contents[i].ctime;
        var d = __WEBPACK_IMPORTED_MODULE_1__common_js_util__["l" /* resolvePath */](item.path);
        if (d.type === '') {
          d.type = 'folder';
          item.is_dir = true;
        }
        item.type = d.type;
        item.typeIcon = __WEBPACK_IMPORTED_MODULE_1__common_js_util__["q" /* typeIcon */](d.type);
        item.name = d.name;
        item.title = file.name;
        item.filename = file.name;
        item.size = __WEBPACK_IMPORTED_MODULE_1__common_js_util__["r" /* formatBytes */](item.bytes);
        item.datetime = __WEBPACK_IMPORTED_MODULE_1__common_js_util__["s" /* formatDate */](item.modified || item.datetime, 'yyyy-MM-dd' + ' hh:mm');
        item.authName = __WEBPACK_IMPORTED_MODULE_1__common_js_util__["t" /* getAuthNameByAccessMode */](item.access_mode).authName;
        if (item.dir_type === 2 || item.dir_type === 4) {
          // 2代表云端共享文件夹  4代表云端普通文件夹
          item.is_cloud = true;
          if (item.dir_type === 2) {
            item.is_shared = true;
          }
        } else {
          item.is_cloud = false;
        }
        if (item.is_dir) {
          if (item.is_shared && item.is_team) {
            item.typeIcon = 'folder_team';
          } else if (item.is_shared && item.is_cloud) {
            // 云端文件被共享
            item.typeIcon = 'cloud_share';
          } else if (item.is_cloud) {
            // 云端文件
            item.typeIcon = 'folder_cloud';
          } else if (item.is_shared) {
            item.typeIcon = 'folder_share';
          } else if (item.is_team) {
            item.typeIcon = 'folder_team';
          } else {
            item.typeIcon = 'folder';
          }
        }
        switch (item.dir_type) {
          case 1:
            item.category = '团队文件夹';
            break;
          case 2:
            item.category = '云端共享文件夹';
            break;
          case 4:
            item.category = '云端文件夹';
            break;
          case 6:
            item.category = '共享文件夹';
            break;
          case 8:
            item.category = '普通文件';
            break;
          default:
            item.category = '普通文件夹';
            break;

        }
        if (item.is_shared) {
          if (!item.is_team) {
            //              file.category = _('共享文件夹')
          } else {
              //              if (item.path_type === "self"&& Util.isAdmin()) {
              //                file.category = _('普通文件夹')
              //              } else {
              //                file.category = _('团队文件夹')
              //              }
            }
        } else {
            //            file.category = _("普通文件夹")
          }
        if (!item.is_dir) {
          item.rev = item.rev;
          item.version = item.rev_index > 999 ? '999+' : item.rev_index;
        }
        files.push(item);
      }
      // console.log('offset:' + state.currentFolder.offset)
      if (state.currentFolder.offset > 0) {
        state.content = state.content.concat(files);
      } else {
        state.content = files;
      }
    },
    setSearchFileList: function setSearchFileList(state, obj) {
      state.searchContent = [];
      state.searchContent = obj.content;
    },
    clearSearchFileList: function clearSearchFileList(state, obj) {
      state.searchContent = [];
    },

    // 插入当前文件夹信息
    setCurrentFolderInfo: function setCurrentFolderInfo(state, obj) {
      for (var o in state.currentFolder) {
        if (obj[o]) {
          state.currentFolder[o] = obj[o];
        }
      }
    },
    setRootPathName: function setRootPathName(state, obj) {
      state.rootPathName = obj;
    },
    setFullPath: function setFullPath(state, obj) {
      state.currentFolder.path = obj;
    },
    setCurrentPathType: function setCurrentPathType(state, obj) {
      // 设置当前
      if (obj) {
        state.currentFolder.path_type = obj.param.path_type;
      } else {}
      // 重置分页参数和排序参数
      // state.currentFolder.sort = 'desc'
      // state.currentFolder.orderBy = 'mtime'
      state.currentFolder.haveMore = true;
    },
    setSort: function setSort(state, obj) {
      state.currentFolder.sort = obj.param.sort;
      state.currentFolder.orderBy = obj.param.orderBy;
    },
    setIsLoading: function setIsLoading(state, obj) {
      state.currentFolder.isLoading = true;
    },
    clearIsLoading: function clearIsLoading(state, obj) {
      state.currentFolder.isLoading = false;
    },
    setHaveMore: function setHaveMore(state, obj) {
      state.currentFolder.haveMore = obj;
    },
    setOffset: function setOffset(state, obj) {
      state.currentFolder.offset = obj;
    },
    addOffset: function addOffset(state, obj) {
      state.currentFolder.offset += obj;
    },
    setDeletingFile: function setDeletingFile(state, obj) {
      state.currentFolder.deletingFile = obj;
    },
    setAddFolderShow: function setAddFolderShow(state, obj) {
      state.addFolderShow = obj;
    },
    setCurrentFileDetailMore: function setCurrentFileDetailMore(state, obj) {
      state.currentFileDetailMore = obj;
    },
    setCurrentFileDetailMoreShow: function setCurrentFileDetailMoreShow(state, obj) {
      state.detailMore = obj;
    },
    setCurrentFileDetailMoreHide: function setCurrentFileDetailMoreHide(state) {
      state.detailMore = false;
    },
    setCurrentFileDetailShow: function setCurrentFileDetailShow(state) {
      state.isShowFileDetail = true;
    },
    setCurrentFileDetailHide: function setCurrentFileDetailHide(state) {
      state.isShowFileDetail = false;
    },
    setIsReloadFilelist: function setIsReloadFilelist(state, obj) {
      // state.currentFolder.page_num = 0
      state.isReloadFilelist = obj;
      // state.currentFolder.offset = 0
    },
    setRegion: function setRegion(state, obj) {
      state.region = obj;
    },
    setIsSearch: function setIsSearch(state, obj) {
      state.isSearch = obj;
    }
  },
  actions: {
    set_MusicAllList: function set_MusicAllList(_ref, obj) {
      var commit = _ref.commit;

      commit('setMusicAllList', obj);
    },

    // 获取文件列表
    get_FileList: function get_FileList(_ref2, obj) {
      var commit = _ref2.commit,
          rootState = _ref2.rootState;

      commit('setIsLoading');
      if (rootState.fileInfo.currentFolder.haveMore) {
        if (rootState.fileInfo.currentFile.from && rootState.fileInfo.currentFile.from !== '') {
          obj.param.from = rootState.fileInfo.currentFile.from;
        }
        if (rootState.fileInfo.currentFile.prefix_neid && rootState.fileInfo.currentFile.prefix_neid !== '') {
          obj.param.prefix_neid = rootState.fileInfo.currentFile.prefix_neid;
        }
        if (rootState.fileInfo.currentFolder.path_type === 'favorite') {
          obj.param.path_type = rootState.fileInfo.currentFile.path_type;
        }
        __WEBPACK_IMPORTED_MODULE_0__SDK_FileManager__["b" /* metaData */](obj.param).then(function (response) {
          commit('clearIsLoading');
          if (response.content.length === 0) {
            // return
          }
          commit('setHaveMore', response.content.length === rootState.fileInfo.currentFolder.limit);
          commit('setFileList', response);
          commit('setCurrentFolderInfo', response);
        }, function (err) {
          commit('clearIsLoading');
          console.log(err);
        });
      }
    },
    getFileDetail: function getFileDetail(_ref3, obj) {
      var commit = _ref3.commit;

      __WEBPACK_IMPORTED_MODULE_0__SDK_FileManager__["i" /* info */](obj.param).then(function (response) {
        if (response) {
          commit('setCurrentFileDetailMore', response);
          commit('setCurrentFileDetailMoreShow', true);
        }
      }, function (err) {
        console.log(err);
      });
    },
    renameFileName: function renameFileName(_ref4, obj) {
      var commit = _ref4.commit,
          state = _ref4.state;

      if (state.againConfirm) {
        obj.ignore_share = true;
      }
      __WEBPACK_IMPORTED_MODULE_0__SDK_FileManager__["j" /* rename */](obj).then(function (response) {
        commit('clearIsLoading');
        if (response.result !== 'success') {
          return;
        }
        commit('setToast', { isShow: true, message: '重命名成功', iconClass: 'icon-success' });
        commit('setIsReloadFilelist', true);
        commit('setAgainConfirm', false);
      }, function (err) {
        if (err.state === 412) {
          commit('setAgainTipTitle', err.message);
          commit('setAgainConfirm', true);
          commit('setToast', { isShow: true, message: '重命名成功', iconClass: 'icon-success' });
        } else if (err.state === 403) {
          commit('setToast', { isShow: true, message: err.message, iconClass: 'icon-error' });
          // commit('setShareRenameError', err.message)
        } else {
          commit('setToast', { isShow: true, message: '重命名失败', iconClass: 'icon-error' });
        }
        console.log(err);
      });
    },
    deleteFile: function deleteFile(_ref5, obj) {
      var commit = _ref5.commit,
          state = _ref5.state;

      commit('setDeletingFile', true);
      var deleteFile = {
        'neid': obj.params.neid,
        'path': obj.params.path,
        'from': obj.params.from,
        'path_type': obj.params.path_type,
        'prefix_neid': obj.params.prefix_neid
      };
      if (state.againConfirm) {
        deleteFile.ignore_share = true;
      }
      __WEBPACK_IMPORTED_MODULE_0__SDK_FileManager__["k" /* batchDelete */](deleteFile).then(function (response) {
        commit('clearIsLoading');
        if (response.success.length !== 0) {
          commit('setToast', { isShow: true, message: '删除成功', iconClass: 'icon-success' });
          commit('setIsReloadFilelist', true);
          commit('setAgainConfirm', false);
        }
      }, function (err) {
        if (err.state === 412) {
          commit('setAgainTipTitle', err.message);
          commit('setAgainConfirm', true);
          commit('showConfirmTips', 'confirmDelete');
        } else {
          commit('setToast', { isShow: true, message: err.message, iconClass: 'icon-error' });
        }
      });
    },
    set_SearchFileList: function set_SearchFileList(_ref6, obj) {
      var commit = _ref6.commit,
          rootState = _ref6.rootState;

      rootState.searchKeyword = obj.query;
      obj['path_type'] = rootState.fileInfo.currentFolder.path_type;
      obj['path'] = rootState.fileInfo.currentFolder.fullPath;
      __WEBPACK_IMPORTED_MODULE_0__SDK_FileManager__["l" /* search */](obj).then(function (response) {
        commit('clearIsLoading');
        if (response) {
          commit('setSearchFileList', response);
        }
      }, function (err) {
        commit('clearIsLoading');
        console.log(err);
      });
    },
    clear_SearchFileList: function clear_SearchFileList(_ref7, obj) {
      var commit = _ref7.commit;

      commit('clearSearchFileList', obj);
    },
    set_RootPathName: function set_RootPathName(_ref8, obj) {
      var commit = _ref8.commit;

      commit('setRootPathName', obj);
    },
    intoItem: function intoItem(_ref9, obj) {
      var commit = _ref9.commit;

      commit('intoItem', obj);
    },
    setCurrentPathType: function setCurrentPathType(_ref10, obj) {
      var commit = _ref10.commit;

      commit('setCurrentPathType', obj);
    },
    setCurrentFolderNextPageNum: function setCurrentFolderNextPageNum(_ref11, obj) {
      var commit = _ref11.commit;

      commit('setCurrentFolderNextPageNum', obj);
    },
    set_Sort: function set_Sort(_ref12, obj) {
      var commit = _ref12.commit;

      commit('setSort', obj);
    },
    addFolder: function addFolder(_ref13, obj) {
      var commit = _ref13.commit,
          rootState = _ref13.rootState;

      var params = {
        path: '/' + rootState.fileInfo.currentFolder.path + '/' + obj,
        path_type: rootState.fileInfo.currentFolder.path_type,
        prefix_neid: rootState.fileInfo.currentFolder.prefix_neid,
        from: rootState.fileInfo.currentFolder.from
      };
      __WEBPACK_IMPORTED_MODULE_0__SDK_FileManager__["c" /* createFolder */](params).then(function (response) {
        if (response.result === 'success') {
          var _params = {
            isShow: true,
            message: '添加文件夹成功',
            iconClass: 'icon-success'
          };
          commit('setToast', _params);
          commit('setIsReloadFilelist', true);
          commit('setAddFolderShow', false);
        }
      }, function (err) {
        if (err.type === 'error') {
          commit('setToast', { isShow: true, message: err.message, iconClass: 'icon-error' });
          // commit('setAddFolderError', err.message)
        }
      });
    },
    setFavorite: function setFavorite(_ref14, obj) {
      var commit = _ref14.commit;

      __WEBPACK_IMPORTED_MODULE_0__SDK_FileManager__["m" /* setFavorite */](obj).then(function (response) {
        commit('setToast', { isShow: true, message: '收藏成功', iconClass: 'icon-success' });
        commit('setIsReloadFilelist', true);
      }, function (err) {
        if (err.type === 'error') {
          commit('setToast', { isShow: true, message: err.message, iconClass: 'icon-error' });
        }
      });
    },
    cancelFavorite: function cancelFavorite(_ref15, obj) {
      var commit = _ref15.commit;

      __WEBPACK_IMPORTED_MODULE_0__SDK_FileManager__["n" /* removeFavorite */](obj).then(function (response) {
        if (obj.isRemoveFavorite) {
          commit('setToast', { isShow: true, message: '此条收藏已被移除', iconClass: 'icon-success' });
        } else {
          commit('setToast', { isShow: true, message: '已取消收藏', iconClass: 'icon-success' });
        }
        commit('setIsReloadFilelist', true);
      }, function (err) {
        if (err.type === 'error') {
          commit('setToast', { isShow: true, message: err.message, iconClass: 'icon-error' });
        }
      });
    },
    getFavoriteList: function getFavoriteList(_ref16, obj) {
      var commit = _ref16.commit,
          rootState = _ref16.rootState;

      __WEBPACK_IMPORTED_MODULE_0__SDK_FileManager__["o" /* getFavorite */](obj).then(function (response) {
        // commit('setHaveMore', response.content.length === rootState.fileInfo.currentFolder.limit)
        commit('setFavoriteFileList', response);
        // commit('setCurrentFolderInfo', response)
      }, function (err) {
        console.log(err);
      });
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (fileInfo);

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SDK_FileManager__ = __webpack_require__(18);


var history = {
  state: {
    isAuth: false,
    history: [],
    comments_total: 0,
    historyStatus: -1,
    page_num: 0
  },
  getters: {
    getHistory: function getHistory(state) {
      return state.history;
    }
  },
  mutations: {
    setHistory: function setHistory(state, obj) {
      state.history = obj;
    },
    setStatus: function setStatus(state, obj) {
      state.historyStatus = obj;
    }
  },
  actions: {
    getHistory: function getHistory(_ref, obj) {
      var commit = _ref.commit;

      var currentFile = obj.param.currentFile;
      __WEBPACK_IMPORTED_MODULE_0__SDK_FileManager__["d" /* getHistory */](currentFile).then(function (response) {
        if (response.length !== 0) {
          commit('setStatus', { code: 200, message: 'OK' });
          commit('setHistory', response);
        } else {
          commit('setStatus', { code: 0, message: 'OK' });
          commit('setHistory', []);
        }
      }, function (err) {
        commit('setStatus', { code: 201, message: 'OK' });
        commit('setHistory', []);
        console.log(err);
      });
    },
    deleteHistory: function deleteHistory(_ref2, obj) {
      var commit = _ref2.commit;

      __WEBPACK_IMPORTED_MODULE_0__SDK_FileManager__["e" /* deleteHistory */](obj).then(function (response) {
        console.log(response);
      });
    },
    restore: function restore(_ref3, obj) {
      var commit = _ref3.commit;

      __WEBPACK_IMPORTED_MODULE_0__SDK_FileManager__["f" /* restore */](obj.param).then(function (response) {
        commit('setStatus', { code: 201, message: 'OK' });
      }, function (err) {
        console.log(err);
        commit('setStatus', { code: 202, message: err.message });
      });
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (history);

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SDK_UserManager__ = __webpack_require__(17);

// import * as Util from 'util'

var SHOW_MENU = true;
var HIDE_MENU = false;

var logout = {
  state: {
    isShow: false,
    settingInfo: {
      color: '',
      user_name: '',
      quota: '',
      used: ''
    }
  },
  getters: {
    getLogoutIsShow: function getLogoutIsShow(state) {
      return state.isShow;
    },

    getSettingInfo: function getSettingInfo(state) {
      return state.settingInfo;
    }
  },
  mutations: {
    showLogout: function showLogout(state, obj) {
      state.isShow = SHOW_MENU;
    },
    hideLogout: function hideLogout(state) {
      state.isShow = HIDE_MENU;
    },
    setSettingInfo: function setSettingInfo(state, obj) {
      state.settingInfo.color = obj.color;
      state.settingInfo.user_name = obj.user_name;
      state.settingInfo.quota = obj.quota;
      state.settingInfo.used = obj.used;
    }
  },
  actions: {
    showLogoutInfo: function showLogoutInfo(_ref, obj) {
      var commit = _ref.commit;

      commit('showLogout', obj);
    },
    hideLogoutInfo: function hideLogoutInfo(_ref2) {
      var commit = _ref2.commit;

      commit('hideLogout');
    },
    getInfo: function getInfo(_ref3, obj) {
      var commit = _ref3.commit;

      __WEBPACK_IMPORTED_MODULE_0__SDK_UserManager__["i" /* getInfo */](obj).then(function (response) {
        commit('setSettingInfo', response);
      });
    },
    signout: function signout(_ref4, obj) {
      var commit = _ref4.commit;

      __WEBPACK_IMPORTED_MODULE_0__SDK_UserManager__["j" /* signout */](obj).then(function (response) {
        localStorage.removeItem('userInfo');
        // Util.delCookie('X-LENOVO-SESS-ID')
        window.location = '/H5/';
      });
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (logout);

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SDK_MessageManager__ = __webpack_require__(105);


var Message = {
  state: {
    isShow: false,
    loading: false,
    dynamic_hasMore: true,
    dynamic_params: {
      page_num: 1,
      page_size: 50
    },
    dynamic_list: {},
    msg_lastedId: 0,
    comment_lastedId: 0,
    notice_lastedId: 0,
    comment_hasMore: true,
    comment_params: {
      page_num: 1,
      num_each_page: 20,
      is_need_total: true
    },
    comment_list: {},
    notice_hasMore: true,
    notice_params: {
      limit: 50,
      offset: 0
    },
    notice_list: {},
    isNoticeDetail: false,
    isReloadMsg: false,
    unreadMsg: {},
    cleanSuccess: false
  },
  getters: {
    getMessageLoading: function getMessageLoading(state) {
      return state.loading;
    },
    getDynamicHasMore: function getDynamicHasMore(state) {
      return state.dynamic_hasMore;
    },
    getCommentHasMore: function getCommentHasMore(state) {
      return state.comment_hasMore;
    },
    getNoticeHasMore: function getNoticeHasMore(state) {
      return state.notice_hasMore;
    }
  },
  mutations: {
    setCleanSuccess: function setCleanSuccess(state, obj) {
      state.cleanSuccess = obj;
    },
    setDynamicPageNum: function setDynamicPageNum(state, obj) {
      state.dynamic_params.page_num = obj;
    },
    setCommentPageNum: function setCommentPageNum(state, obj) {
      state.comment_params.page_num = obj;
    },
    setNoticeOffset: function setNoticeOffset(state, obj) {
      state.notice_params.offset = obj;
    },
    setMessageLoading: function setMessageLoading(state, obj) {
      state.loading = obj;
    },
    setIsReloadMsg: function setIsReloadMsg(state, obj) {
      state.isReloadMsg = obj;
    },
    setDynamicHasMore: function setDynamicHasMore(state, obj) {
      state.dynamic_hasMore = obj;
    },
    setCommentHasMore: function setCommentHasMore(state, obj) {
      state.comment_hasMore = obj;
    },
    setNoticeHasMore: function setNoticeHasMore(state, obj) {
      state.notice_hasMore = obj;
    },
    getDynamicList: function getDynamicList(state, obj) {
      state.dynamic_list = obj;
      if (obj.content.length < state.dynamic_params.page_size) {
        state.dynamic_hasMore = false;
      }
      for (var i = 0; i < obj.content.length; i++) {
        if (obj.content[i].id > state.msg_lastedId) {
          state.msg_lastedId = obj.content[i].id;
        }
      }
    },
    getCommentList: function getCommentList(state, obj) {
      state.comment_list = obj;
      if (obj.commlist.length < state.comment_params.num_each_page) {
        state.comment_hasMore = false;
      }
      for (var i = 0; i < obj.commlist.length; i++) {
        if (obj.commlist[i].id > state.comment_lastedId) {
          state.comment_lastedId = obj.commlist[i].id;
        }
      }
    },
    getNoticeList: function getNoticeList(state, obj) {
      state.notice_list = obj;
      if (obj.messages.length < state.notice_params.limit) {
        state.notice_hasMore = false;
      }
      for (var i = 0; i < obj.messages.length; i++) {
        if (obj.messages[i].id > state.notice_lastedId) {
          state.notice_lastedId = obj.messages[i].id;
        }
      }
    },
    setNoticeDetail: function setNoticeDetail(state, obj) {
      state.isNoticeDetail = obj;
    },
    setUnreadMsg: function setUnreadMsg(state, obj) {
      state.unreadMsg = obj;
    }
  },
  actions: {
    getDynamicList: function getDynamicList(_ref, obj) {
      var commit = _ref.commit,
          rootState = _ref.rootState,
          dispatch = _ref.dispatch;

      __WEBPACK_IMPORTED_MODULE_0__SDK_MessageManager__["a" /* getDynamicList */](rootState.message.dynamic_params).then(function (response) {
        commit('getDynamicList', response);
        commit('setMessageLoading', false);
        rootState.message.dynamic_params.page_num++;
        if (rootState.message.unreadMsg.message_retval > 0) {
          dispatch('setMsgStatus');
        }
      }, function (err) {
        console.log(err);
      });
    },
    getCommentList: function getCommentList(_ref2, obj) {
      var commit = _ref2.commit,
          rootState = _ref2.rootState,
          dispatch = _ref2.dispatch;

      __WEBPACK_IMPORTED_MODULE_0__SDK_MessageManager__["b" /* getCommentList */](rootState.message.comment_params).then(function (response) {
        commit('getCommentList', response);
        commit('setMessageLoading', false);
        rootState.message.comment_params.page_num++;
        if (rootState.message.unreadMsg.comment_retval > 0) {
          dispatch({ type: 'setCommentStatus' });
        }
      }, function (err) {
        console.log(err);
      });
    },
    getNoticeList: function getNoticeList(_ref3, obj) {
      var commit = _ref3.commit,
          rootState = _ref3.rootState,
          dispatch = _ref3.dispatch;

      __WEBPACK_IMPORTED_MODULE_0__SDK_MessageManager__["c" /* getNoticeList */](rootState.message.notice_params).then(function (response) {
        commit('getNoticeList', response);
        commit('setMessageLoading', false);
        rootState.message.notice_params.offset += rootState.message.notice_params.limit;
        if (rootState.message.unreadMsg.notice_retval > 0) {
          dispatch({ type: 'setNoticeStatus' });
        }
      }, function (err) {
        console.log(err);
      });
    },
    getRedpoint: function getRedpoint(_ref4, obj) {
      var commit = _ref4.commit,
          rootState = _ref4.rootState;

      __WEBPACK_IMPORTED_MODULE_0__SDK_MessageManager__["d" /* getRedpoint */]().then(function (response) {
        commit('setUnreadMsg', response);
      }, function (err) {
        console.log(err);
      });
    },
    setMsgStatus: function setMsgStatus(_ref5, obj) {
      var commit = _ref5.commit,
          rootState = _ref5.rootState,
          dispatch = _ref5.dispatch;

      var params = { logId: rootState.message.msg_lastedId };
      __WEBPACK_IMPORTED_MODULE_0__SDK_MessageManager__["e" /* setMsgStatus */](params).then(function (response) {
        dispatch({ type: 'getRedpoint' });
      }, function (err) {
        console.log(err);
      });
    },
    setCommentStatus: function setCommentStatus(_ref6, obj) {
      var commit = _ref6.commit,
          rootState = _ref6.rootState,
          dispatch = _ref6.dispatch;

      var params = { lastedId: rootState.message.comment_lastedId };
      __WEBPACK_IMPORTED_MODULE_0__SDK_MessageManager__["f" /* setCommentStatus */](params).then(function (response) {
        dispatch({ type: 'getRedpoint' });
      }, function (err) {
        console.log(err);
      });
    },
    setNoticeStatus: function setNoticeStatus(_ref7, obj) {
      var commit = _ref7.commit,
          rootState = _ref7.rootState,
          dispatch = _ref7.dispatch;

      var params = { lastedId: rootState.message.notice_lastedId };
      __WEBPACK_IMPORTED_MODULE_0__SDK_MessageManager__["g" /* setNoticeStatus */](params).then(function (response) {
        dispatch({ type: 'getRedpoint' });
      }, function (err) {
        console.log(err);
      });
    },
    cleanMsg: function cleanMsg(_ref8, obj) {
      var commit = _ref8.commit;

      __WEBPACK_IMPORTED_MODULE_0__SDK_MessageManager__["h" /* cleanMsg */]().then(function (response) {
        commit('setCleanSuccess', true);
        commit('setIsReloadMsg', true);
      }, function (err) {
        console.log(err);
      });
    },
    cleanComment: function cleanComment(_ref9, obj) {
      var commit = _ref9.commit;

      __WEBPACK_IMPORTED_MODULE_0__SDK_MessageManager__["i" /* cleanComment */]().then(function (response) {
        commit('setCleanSuccess', true);
        commit('setIsReloadMsg', true);
      }, function (err) {
        console.log(err);
      });
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Message);

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SDK_FileManager__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_util__ = __webpack_require__(0);



var MoveCopy = {
  state: {
    isShow: false,
    title: '',
    flag: 'move',
    isRoot: true,
    currentPath: '',
    content: [],
    currentFolder: {},
    isShowCreate: false,
    isShowCopy: false,
    isShowMove: false,
    isSuccess: false,
    isBackReload: false
  },
  getters: {},
  mutations: {
    setIsBackReload: function setIsBackReload(state, obj) {
      state.isBackReload = obj;
    },
    setSuccess: function setSuccess(state, obj) {
      state.isSuccess = obj;
    },
    setTitle: function setTitle(state, obj) {
      state.title = obj;
    },
    setMoveCopyFlag: function setMoveCopyFlag(state, obj) {
      state.flag = obj;
      state.title = obj === 'move' ? '请选择要移动的位置' : '请选择要复制的位置';
    },
    setIsRoot: function setIsRoot(state, obj) {
      state.isRoot = obj;
    },
    setIsShow: function setIsShow(state, obj) {
      state.isShow = obj;
    },
    setMoveCopyCurrentPath: function setMoveCopyCurrentPath(state, obj) {
      state.currentPath = obj;
    },
    getMoveCopyList: function getMoveCopyList(state, obj) {
      console.log('getMoveCopyList');
      state.currentFolder = obj;
      state.content = [];
      var contents = obj.content;
      for (var i = 0; i < contents.length; i++) {
        var file = {};
        var item = contents[i];
        var d = __WEBPACK_IMPORTED_MODULE_1__common_js_util__["l" /* resolvePath */](item.path, item.is_dir);
        item.type = d.type;
        item.typeIcon = __WEBPACK_IMPORTED_MODULE_1__common_js_util__["q" /* typeIcon */](d.type);
        item.name = d.name;
        item.title = file.name;
        item.filename = file.name;
        item.size = __WEBPACK_IMPORTED_MODULE_1__common_js_util__["r" /* formatBytes */](item.bytes);
        item.datetime = __WEBPACK_IMPORTED_MODULE_1__common_js_util__["s" /* formatDate */](item.modified || item.datetime, 'yyyy-MM-dd' + ' hh:mm');
        item.authName = __WEBPACK_IMPORTED_MODULE_1__common_js_util__["t" /* getAuthNameByAccessMode */](item.access_mode).authName;
        if (item.dir_type === 2 || item.dir_type === 4) {
          // 2代表云端共享文件夹  4代表云端普通文件夹
          item.is_cloud = true;
          if (item.dir_type === 2) {
            item.is_shared = true;
          }
        } else {
          item.is_cloud = false;
        }
        if (item.is_dir) {
          if (item.is_shared && item.is_team) {
            item.typeIcon = 'folder_team';
          } else if (item.is_shared && item.is_cloud) {
            // 云端文件被共享
            item.typeIcon = 'cloud_share';
          } else if (item.is_cloud) {
            // 云端文件
            item.typeIcon = 'folder_cloud';
          } else if (item.is_shared) {
            item.typeIcon = 'folder_share';
          } else if (item.is_team) {
            item.typeIcon = 'folder_team';
          } else {
            item.typeIcon = 'folder';
          }
        }
        switch (item.dir_type) {
          case 1:
            item.category = '团队文件夹';
            break;
          case 2:
            item.category = '云端共享文件夹';
            break;
          case 4:
            item.category = '云端文件夹';
            break;
          case 6:
            item.category = '共享文件夹';
            break;
          case 8:
            item.category = '普通文件';
            break;
          default:
            item.category = '普通文件夹';
            break;
        }
        if (item.is_dir) {
          state.content.push(item);
        }
      }
    }
  },
  actions: {
    getMoveCopyList: function getMoveCopyList(_ref, obj) {
      var commit = _ref.commit;

      __WEBPACK_IMPORTED_MODULE_0__SDK_FileManager__["b" /* metaData */](obj.params).then(function (response) {
        commit('getMoveCopyList', response);
      }, function (err) {
        console.log(err);
      });
    },
    moveCopyAddFolder: function moveCopyAddFolder(_ref2, obj) {
      var commit = _ref2.commit,
          rootState = _ref2.rootState,
          dispatch = _ref2.dispatch;

      var params = {
        path: '/' + rootState.movecopy.currentFolder.path + '/' + obj,
        path_type: rootState.movecopy.currentFolder.path_type,
        prefix_neid: rootState.movecopy.currentFolder.prefix_neid,
        from: rootState.movecopy.currentFolder.from
      };
      __WEBPACK_IMPORTED_MODULE_0__SDK_FileManager__["c" /* createFolder */](params).then(function (response) {
        commit('setAddFolderShow', false);
        var params = { path: rootState.movecopy.currentFolder.path,
          path_type: rootState.movecopy.currentFolder.path_type,
          prefix_neid: rootState.movecopy.currentFolder.prefix_neid,
          from: rootState.movecopy.currentFolder.from,
          limit: 1000,
          content_type: 'dir'
        };
        dispatch({
          type: 'getMoveCopyList',
          params: params
        });
      }, function (err) {
        if (err.type === 'error') {
          commit('setToast', { isShow: true, message: err.message, iconClass: 'icon-error' });
        }
      });
    },
    copy: function copy(_ref3, obj) {
      var commit = _ref3.commit;

      console.log('movecopy.js --- copy' + obj);
      __WEBPACK_IMPORTED_MODULE_0__SDK_FileManager__["g" /* copy */](obj.params).then(function (response) {
        commit('setSuccess', true);
        commit('setToast', { isShow: true, message: '复制成功', iconClass: 'icon-success' });
      }, function (err) {
        commit('setSuccess', false);
        commit('setProgress', { isShow: false });
        commit('setToast', { isShow: true, message: err.message, iconClass: 'icon-error' });
        console.log(err);
      });
    },
    move: function move(_ref4, obj) {
      var commit = _ref4.commit;

      __WEBPACK_IMPORTED_MODULE_0__SDK_FileManager__["h" /* move */](obj.params).then(function (response) {
        commit('setSuccess', true);
        commit('setToast', { isShow: true, message: '移动成功', iconClass: 'icon-success' });
        commit('setIsBackReload', true);
      }, function (err) {
        commit('setSuccess', false);
        commit('setProgress', { isShow: false });
        commit('setToast', { isShow: true, message: err.message, iconClass: 'icon-error' });
        console.log(err);
      });
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (MoveCopy);

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SHOW_MENU = true;
var HIDE_MENU = false;

var navigator = {
  state: {
    isShow: false,
    detail: {
      title: '',
      content: []
    }
  },
  mutations: {
    showNavigator: function showNavigator(state, obj) {
      state.detail = obj === undefined ? state.detail : obj.amount;
      state.isShow = SHOW_MENU;
    },
    hideNavigator: function hideNavigator(state) {
      state.detail = {};
      state.isShow = HIDE_MENU;
    }
  },
  actions: {
    showNavigator: function showNavigator(_ref, obj) {
      var commit = _ref.commit;

      commit('showNavigator', obj);
    },
    hideNavigator: function hideNavigator(_ref2) {
      var commit = _ref2.commit;

      commit('hideNavigator');
    }
  },
  getters: {
    getNavigatorIsShow: function getNavigatorIsShow(state) {
      return state.isShow;
    },
    getNavigatorMenuInfo: function getNavigatorMenuInfo(state) {
      return state.detail;
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (navigator);

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// 测面滑动菜单效果
var SHOW_MENU = true;
var HIDE_MENU = false;

var search = {
  state: {
    isShow: false,
    detail: {
      title: 'title : by 把苹果咬哭'
    }
  },
  mutations: {
    showSearch: function showSearch(state, obj) {
      state.detail = state.detail;
      state.isShow = SHOW_MENU;
    },
    hideSearch: function hideSearch(state) {
      // state.detail = {}
      state.isShow = HIDE_MENU;
    }
  },
  actions: {
    showSearch: function showSearch(_ref, obj) {
      var commit = _ref.commit;

      commit('showSearch', obj);
    },
    hideSearch: function hideSearch(_ref2) {
      var commit = _ref2.commit;

      commit('hideSearch');
    }
  },
  getters: {
    getSearchShow: function getSearchShow(state) {
      return state.isShow;
    }
    // getShowMenuInfo: state => state.detail
  }
};
/* harmony default export */ __webpack_exports__["a"] = (search);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// 测面滑动菜单效果
var SHOW_MENU = true;
var HIDE_MENU = false;

var sortList = {
  state: {
    isShow: false,
    detail: {
      content: [{
        'id': 0,
        name: '按时间从新到旧排序',
        type: 'mtime',
        action: 'desc',
        showBorder: true
      }, {
        'id': 1,
        name: '按时间从旧到新排序',
        type: 'mtime',
        action: 'asc',
        showBorder: true
      }, {
        'id': 2,
        name: '按从大到小排序',
        type: 'size',
        action: 'desc',
        showBorder: true
      }, {
        'id': 3,
        name: '按从小到大排序',
        type: 'size',
        action: 'asc',
        showBorder: true
      }, {
        'id': 4,
        name: '按名称A-Z排序',
        icon: 'icon-delete',
        count: 'none',
        type: 'name',
        action: 'asc',
        showBorder: true
      }, {
        'id': 4,
        name: '按名称Z-A排序',
        type: 'name',
        action: 'desc',
        showBorder: true
      }]
    }
  },
  mutations: {
    showSortList: function showSortList(state, obj) {
      state.detail = state.detail;
      state.isShow = SHOW_MENU;
    },
    hideSortList: function hideSortList(state) {
      // state.detail = {}
      state.isShow = HIDE_MENU;
    }
  },
  actions: {
    showSortList: function showSortList(_ref, obj) {
      var commit = _ref.commit;

      commit('showSortList', obj);
    },
    hideSortList: function hideSortList(_ref2) {
      var commit = _ref2.commit;

      commit('hideSortList');
    }
  },
  getters: {
    getSortShow: function getSortShow(state) {
      return state.isShow;
    },
    getSortInfo: function getSortInfo(state) {
      return state.detail;
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (sortList);

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_uploader_uploader_vue__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_uploader_uploader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_uploader_uploader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_preview_preview_vue__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_preview_preview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_preview_preview_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toast_toast_vue__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toast_toast_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_toast_toast_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_filelist_filelist_rename_vue__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_filelist_filelist_rename_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_filelist_filelist_rename_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_menu_menu_current_file_vue__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_menu_menu_current_file_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_menu_menu_current_file_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_menu_menu_current_folder_vue__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_menu_menu_current_folder_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_menu_menu_current_folder_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_menu_menu_sort_vue__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_menu_menu_sort_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_menu_menu_sort_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_filelist_filelist_add_folder_vue__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_filelist_filelist_add_folder_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_filelist_filelist_add_folder_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SDK_UserManager__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      info: {}
    };
  },

  methods: {
    uploadComplete: function uploadComplete(total) {
      console.log('app upload complete ....');
      var params = {
        isShow: true,
        message: this.translate(this.$language, 'upload_complete_text', [total]),
        iconClass: 'icon-success', // iconClass根据实际情况传相对应的值
        autoClose: false
      };
      __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].commit('setToast', params);
      __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].commit('setStartUpload', false);
      __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].commit('setIsReloadFilelist', true);
      document.getElementById('lenovobox_upload_btn').value = '';
    },
    uploadFail: function uploadFail(message) {
      var params = {
        isShow: true,
        message: message,
        iconClass: 'icon-error' // iconClass根据实际情况传相对应的值
      };
      __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].commit('setToast', params);
      document.getElementById('lenovobox_upload_btn').value = '';
    },
    getUploadURL: function getUploadURL() {
      var currentPath = __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters.getFullPath;
      var sessionID = '';
      var UID = '';
      var s = '';
      if (__WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].state.userInfo) {
        UID = __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].state.userInfo['user_id'];
      }
      var pathType = __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters.getCurrentPathType;
      var prefix = '';
      if (__WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters.getCurrentFolderInfo.prefix_neid) {
        prefix += 'prefix_neid=' + __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters.getCurrentFolderInfo.prefix_neid + '&';
      }
      if (__WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters.getCurrentFolderInfo.from) {
        prefix += 'from=' + __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters.getCurrentFolderInfo.from;
      }

      if (__WEBPACK_IMPORTED_MODULE_9_util__["a" /* getCookie */]('S')) {
        s = 'S=' + __WEBPACK_IMPORTED_MODULE_9_util__["a" /* getCookie */]('S');
      }
      if (__WEBPACK_IMPORTED_MODULE_9_util__["a" /* getCookie */]('X-LENOVO-SESS-ID')) {
        sessionID = __WEBPACK_IMPORTED_MODULE_9_util__["a" /* getCookie */]('X-LENOVO-SESS-ID');
      }
      return '/v2/files/databox' + currentPath + '/{0}?X-LENOVO-SESS-ID=' + sessionID + '&uid=' + UID + '&overwrite=true&source=file&t=&path_type=' + pathType + '&' + prefix + '&' + s;
    },
    close: function close() {
      __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].commit('setStartPreview', false);
    }
  },
  watch: {},
  components: {
    'v-action-list': __WEBPACK_IMPORTED_MODULE_5__components_menu_menu_current_folder_vue___default.a,
    'v-menu-list': __WEBPACK_IMPORTED_MODULE_4__components_menu_menu_current_file_vue___default.a,
    'v-sort-list': __WEBPACK_IMPORTED_MODULE_6__components_menu_menu_sort_vue___default.a,
    'v-uploader': __WEBPACK_IMPORTED_MODULE_0__components_uploader_uploader_vue___default.a,
    'v-preview': __WEBPACK_IMPORTED_MODULE_1__components_preview_preview_vue___default.a,
    'v-dialog': __WEBPACK_IMPORTED_MODULE_3__components_filelist_filelist_rename_vue___default.a,
    'v-add-folder': __WEBPACK_IMPORTED_MODULE_7__components_filelist_filelist_add_folder_vue___default.a,
    'v-toast': __WEBPACK_IMPORTED_MODULE_2__components_toast_toast_vue___default.a
  },
  created: function created() {
    // 判断是否开启了水印
    var params = {
      config_type: 0,
      config_id: 0,
      name: 'watermark_enable'
    };
    __WEBPACK_IMPORTED_MODULE_10__SDK_UserManager__["a" /* configGet */](params).then(function (response) {
      console.log(response + 'configGet Success');
      if (response.length > 0 && response[0].value === 'true') {
        __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].state.watermarkEnable = true;
      } else {
        __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].state.watermarkEnable = false;
      }
    }, function (error) {
      console.log(error + 'configSet Error');
    });
  },

  computed: {}
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util__ = __webpack_require__(0);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      fileName: '',
      errorInfo: ''
    };
  },

  methods: {
    cancel: function cancel() {
      this.$store.commit('setAddFolderShow', false);
    },
    ok: function ok() {
      this.errorInfo = __WEBPACK_IMPORTED_MODULE_0_util__["d" /* validFilename */](this.fileName);
      if (this.errorInfo) {
        return;
      }
      if (this.$store.state.movecopy.isShow) {
        // 移动复制中新建文件夹
        this.$store.dispatch('moveCopyAddFolder', this.fileName);
      } else if (this.$store.state.deliveryTransfor.isShow) {
        this.$store.dispatch('deliveryTransforAddFolder', this.fileName);
      } else {
        this.$store.dispatch('addFolder', this.fileName);
        this.$store.commit('setAddFolderShow', false);
      }
    },
    focusAbsolute: function focusAbsolute() {
      var isIOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent); // 解决ios光标错位
      var scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      if (isIOS) {
        if (scrollHeight > 0) {
          // document.body.scrollTo(0, 0)
          document.body.scrollTop = 0;
          window.scrollTo(0, 300);
        } else {
          window.scrollTo(0, 0);
        }
        this.$refs.maskPosition.style.position = 'absolute';
      }
    },
    blurFixed: function blurFixed() {
      this.$refs.maskPosition.style.position = 'fixed';
    }
  },
  watch: {
    '$store.getters.getAddFolderErr': function $storeGettersGetAddFolderErr(val) {
      if (val !== '') {
        this.errorInfo = val;
      }
    },
    '$store.state.fileInfo.addFolderShow': function $storeStateFileInfoAddFolderShow(val) {
      if (val) {
        this.fileName = '';
        this.errorInfo = '';
      }
    }
  },
  components: {}
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tips__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tips___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_tips__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    dialogTitle: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      isShow: true,
      nameIndex: '',
      errorInfo: '',
      extensionReg: '',
      fileName: '',
      tipTitle: '',
      tipsType: 'confirmRename',
      okBtnText: '继续',
      extensionTitle: '如果改变文件扩展名，可能会导致文件不可用。确实要更改吗？',
      extensionType: 'extensionConfirm',
      textarea: ''
    };
  },

  directives: {
    focus: {
      update: function update(el, _ref) {
        var value = _ref.value;

        if (value) {
          el.scrollIntoView(true);
          el.focus();
        }
      }
    }
  },
  //    mounted () {
  //      this.$refs['inputA'].focus()
  //      // this.$refs['input'].value = ''
  //    },
  methods: {
    stopTouch: function stopTouch(event) {
      return;
    },

    //      onf (event) {
    //        event.currentTarget.focus()
    //        event.currentTarget.select()
    //      },
    focusAbsolute: function focusAbsolute() {
      var isIOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent); // 解决ios光标错位
      var scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      if (isIOS) {
        if (scrollHeight > 0) {
          // document.body.scrollTo(0, 0)
          document.body.scrollTop = 0;
          window.scrollTo(0, 300);
        } else {
          window.scrollTo(0, 0);
        }
        this.$refs.maskPosition.style.position = 'absolute';
      }
    },
    blurFixed: function blurFixed() {
      this.$refs.maskPosition.style.position = 'fixed';
    },
    ok: function ok() {
      this.errorInfo = __WEBPACK_IMPORTED_MODULE_1_util__["d" /* validFilename */](this.fileName);
      if (this.errorInfo) {
        return;
      }
      var oldExtension = this.$store.getters.getCurrentFile.name.substr(this.$store.getters.getCurrentFile.name.lastIndexOf('.'));
      var newExtension = this.fileName.substr(this.fileName.lastIndexOf('.'));
      if (newExtension.indexOf('.') > -1 && oldExtension !== newExtension) {
        __WEBPACK_IMPORTED_MODULE_0_store__["a" /* default */].commit('showConfirmTips', 'extensionConfirm');
      } else {
        this.commitData();
        this.hideDialogList();
      }
    },
    extensionTips: function extensionTips() {
      this.commitData();
      this.hideDialogList();
    },
    renameFile: function renameFile() {
      this.commitData();
      this.hideDialogList();
    },
    hideDialogList: function hideDialogList() {
      __WEBPACK_IMPORTED_MODULE_0_store__["a" /* default */].commit('hideRenameDialog');
    },
    cancel: function cancel() {
      this.hideDialogList();
      this.errorInfo = '';
    },
    highlight: function highlight() {
      this.nameIndex = this.fileName.lastIndexOf('.');
      if (this.$store.getters.getCurrentFile.is_dir) {
        this.nameIndex = this.fileName.length;
      }
      //  文件名默认选中
      // if (this.$store.getters.getRenameIsShow) {
      //   setTimeout(function () {
      //     self.$refs.inputA.scrollIntoView(true)
      //   }, 400)
      //   this.$refs.inputA.setSelectionRange(0, this.nameIndex > 0 ? this.nameIndex : this.fileName.length)
      //   this.$refs.inputA.focus()
      // }
      // 高亮文件名，不包括文件后缀
      if (this.nameIndex !== -1) {
        //          this.$refs.inputA.select(0, this.nameIndex)
        // 考虑更改文件后缀名
        var sss = this.fileName.substr(this.nameIndex) + '$';
        if (/\)/.test(sss)) {
          sss = sss.replace(')', '\\)');
        }
        if (/\[/.test(sss)) {
          sss = sss.replace('[', '\\[');
        }
        if (/\{/.test(sss)) {
          sss = sss.replace('{', '\\{');
        }
        this.extensionReg = new RegExp('.' + sss);
      } else {
        this.extensionReg = new RegExp('.');
      }
      console.log(this.extensionReg);
    },
    commitData: function commitData() {
      if (this.nameIndex !== -1 && this.extensionReg.test(this.fileName)) {
        var currentFile = this.$store.getters.getCurrentFile;
        if (currentFile.name === this.fileName) {
          return;
        }
        if (this.$store.getters.getFullPath === '/') {
          currentFile.to_path = this.$store.getters.getFullPath + this.$refs.inputA.value;
        } else {
          currentFile.to_path = this.$store.getters.getFullPath + '/' + this.$refs.inputA.value;
        }
        currentFile.to_path_type = currentFile.path_type;
        __WEBPACK_IMPORTED_MODULE_0_store__["a" /* default */].dispatch('renameFileName', currentFile);
      }
    }
  },
  computed: {
    showMenu: function showMenu() {
      var self = this;
      if (this.$store.getters.getRenameIsShow) {
        this.fileName = this.$store.getters.getCurrentFile.name;
      }
      if (this.$store.getters.getRenameIsShow) {
        setTimeout(function () {
          self.highlight();
        }, 2000);
      }
      return this.$store.getters.getRenameIsShow ? this.$store.getters.getRenameIsShow : false;
    }
  },
  created: function created() {},
  updated: function updated() {
    this.highlight();
  },

  watch: {
    '$store.state.fileInfo.tipsTitle': function $storeStateFileInfoTipsTitle(val, oldVal) {
      this.tipTitle = val;
      __WEBPACK_IMPORTED_MODULE_0_store__["a" /* default */].commit('showConfirmTips', 'confirmRename');
    },
    fileName: {
      handler: function handler(newValue) {
        // var isIOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent)
        if (newValue.replace(/[^\x00-\xff]/g, '01').length > 24) {
          this.textarea = true;
        } else {
          this.textarea = false;
        }
      },
      deep: true
    }
  },
  components: {
    'confirm-tips': __WEBPACK_IMPORTED_MODULE_2_tips___default.a
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__menu_item_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__menu_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__menu_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tips__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tips___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_tips__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util__ = __webpack_require__(0);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isShow: false,
      tipsType: 'confirmDelete',
      tipTitle: '确定删除该文件',
      deliveryTip: '确定要取消外链么？',
      deliveryType: 'confirmDelivery'
    };
  },

  methods: {
    stopTouch: function stopTouch(event) {
      return;
    },
    clickItem: function clickItem(obj) {
      switch (obj.action) {
        case 'preview':
          __WEBPACK_IMPORTED_MODULE_0_store__["a" /* default */].commit('setStartPreview', true);
          this.hideMenuList();
          break;
        case 'delivery':
          this.hideMenuList();
          this.$router.push('/delivery');
          break;
        case 'cancelDelivery':
          this.hideMenuList();
          __WEBPACK_IMPORTED_MODULE_0_store__["a" /* default */].commit('showConfirmTips', 'confirmDelivery');
          break;
        case 'favorite':
          this.hideMenuList();
          __WEBPACK_IMPORTED_MODULE_0_store__["a" /* default */].dispatch('setFavorite', { uid: __WEBPACK_IMPORTED_MODULE_0_store__["a" /* default */].state.userInfo.uid, snapshot: this.$store.getters.getCurrentFile });
          break;
        case 'cancelFavorite':
          this.hideMenuList();
          __WEBPACK_IMPORTED_MODULE_0_store__["a" /* default */].dispatch('cancelFavorite', { snapshot: this.$store.getters.getCurrentFile });
          break;
        case 'rename':
          console.log('rename');
          __WEBPACK_IMPORTED_MODULE_0_store__["a" /* default */].commit('showRenameDialog');
          this.hideMenuList();
          break;
        case 'move':
          console.log('move');
          this.hideMenuList();
          this.$router.push('/movecopy');
          __WEBPACK_IMPORTED_MODULE_0_store__["a" /* default */].commit('setMoveCopyFlag', 'move');
          break;
        case 'copy':
          console.log('copy');
          this.hideMenuList();
          this.$router.push('/movecopy');
          __WEBPACK_IMPORTED_MODULE_0_store__["a" /* default */].commit('setMoveCopyFlag', 'copy');
          break;
        case 'download':
          console.log('download');
          var params = this.$store.getters.getCurrentFile;
          var uri = '';
          if (params.url) {
            uri = params.url + '&token=' + params.token;
          } else {
            uri = '/v2/dl_router/databox/' + params.path + '?';
            if (params.path_type) uri += 'path_type=' + params.path_type;
            if (params.from) uri += '&from=' + params.from;
            if (params.neid) uri += '&neid=' + params.neid;
            if (__WEBPACK_IMPORTED_MODULE_3_util__["a" /* getCookie */]('S')) {
              uri += '&S=' + __WEBPACK_IMPORTED_MODULE_3_util__["a" /* getCookie */]('S');
            }
          }
          uri += '&X-LENOVO-SESS-ID=' + __WEBPACK_IMPORTED_MODULE_0_store__["a" /* default */].state.userInfo['X-LENOVO-SESS-ID'];
          uri = encodeURI(uri);
          uri = uri.replace(/#/g, '%23');
          location.href = uri;
          this.hideMenuList();
          break;
        case 'delete':
          console.log('delete');
          __WEBPACK_IMPORTED_MODULE_0_store__["a" /* default */].commit('showConfirmTips', 'confirmDelete');
          this.hideMenuList();
          break;
        case 'detail':
          console.log('detail');
          this.$router.push('/fileDetail');
          this.hideMenuList();
          break;
        case 'comment':
          console.log('comment');
          this.$router.push('/comments');
          this.hideMenuList();
          break;
        case 'history':
          console.log('history');
          this.$router.push('/history');
          this.hideMenuList();
          break;
      }
      console.log(obj.action + '===menuList1==' + obj.type);
      //        console.log(menuList.content)
    },
    deleteFile: function deleteFile() {
      __WEBPACK_IMPORTED_MODULE_0_store__["a" /* default */].dispatch('deleteFile', { params: this.$store.getters.getCurrentFile });
    },
    cancelDelivery: function cancelDelivery() {
      var params = {
        'codes[]': this.$store.getters.getCurrentFile.delivery_code
      };
      __WEBPACK_IMPORTED_MODULE_0_store__["a" /* default */].dispatch('cancelDelivery', { params: params });
    },
    cancelFavorite: function cancelFavorite() {},
    hideMenuList: function hideMenuList() {
      __WEBPACK_IMPORTED_MODULE_0_store__["a" /* default */].dispatch({
        type: 'hideMenuList'
      });
    }
  },
  computed: {
    showMenu: function showMenu() {
      this.isShow = this.$store.getters.getIsShow ? this.$store.getters.getIsShow : false;
      return this.$store.getters.getIsShow ? this.$store.getters.getIsShow : false;
    },
    menuList: function menuList() {
      return this.$store.getters.getShowMenuList;
    }
  },
  watch: {
    '$store.state.fileInfo.tipsTitle': function $storeStateFileInfoTipsTitle(val, oldVal) {
      this.tipTitle = val;
    }
  },
  components: {
    'type-list': __WEBPACK_IMPORTED_MODULE_1__menu_item_vue___default.a,
    'confirm-tips': __WEBPACK_IMPORTED_MODULE_2_tips___default.a
  }
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_index__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menu_item__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menu_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__menu_item__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isShow: false,
      allMenu: {
        upload: {
          name: '上传',
          icon: 'icon-upload',
          type: 'event',
          action: 'upload',
          align: 'left'
        },
        create: {
          name: '新建文件夹',
          icon: 'icon-new-folder',
          type: 'event',
          action: 'newFolder',
          align: 'left'
        }
      }
    };
  },

  methods: {
    stopTouch: function stopTouch(event) {
      return;
    },
    clickItem: function clickItem(obj) {
      console.log(obj.action + '===actionList==' + obj.type);
      switch (obj.action) {
        case 'upload':
          this.hideMenuList();
          // 判断是否为wifi
          if (__WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state.currentNetworkType === 0) {
            var params = {
              isShow: true,
              message: '无网络',
              iconClass: 'icon-error' // iconClass根据实际情况传相对应的值
            };
            __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].commit('setToast', params);
            return;
          }
          if (__WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state.onlyWIFI && __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state.currentNetworkType !== 1) {
            var _params = {
              isShow: true,
              message: '仅在WIFI环境下上传',
              iconClass: 'icon-error' // iconClass根据实际情况传相对应的值
            };
            __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].commit('setToast', _params);
            return;
          }
          document.getElementById('lenovobox_upload_btn').click(); // 将上传触发弹框放在这里，解决点击上传无反应的问题
          //            store.commit('setStartUpload', true)
          break;
        case 'newFolder':
          this.hideMenuList();
          __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].commit('setAddFolderShow', true);
          break;
      }
    },
    hideMenuList: function hideMenuList() {
      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].dispatch({
        type: 'hideActionMenuList'
      });
    }
  },
  computed: {
    showMenu: function showMenu() {
      this.isShow = this.$store.getters.getActionListIsShow ? this.$store.getters.getActionListIsShow : false;
      return this.$store.getters.getActionListIsShow ? this.$store.getters.getActionListIsShow : false;
    },
    menuList: function menuList() {
      var menus = [];
      var auth = __WEBPACK_IMPORTED_MODULE_1__common_js_util__["e" /* getCSSActionByCode */](this.$store.getters.getCurrentFolderInfo.access_mode).authCSS.split(':');
      for (var o in auth) {
        if (this.allMenu[auth[o]]) {
          menus.push(this.allMenu[auth[o]]);
        }
      }
      return menus;
    }
  },
  watch: {
    isShow: function isShow(newisShow) {
      if (newisShow) {
        // this.$refs.content.style.height = `${this.$store.getters.getShowMenuInfo.content.length * 50 + 20}px`
      }
    }
  },
  components: {
    'type-list': __WEBPACK_IMPORTED_MODULE_2__menu_item___default.a
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    name: {
      type: String,
      default: '未曾遗忘的青春'
    },
    clickItem: {
      type: Function,
      default: undefined
    },
    action: {
      type: String,
      default: 'preview'
    },
    type: {
      type: String,
      default: 'router'
    },
    border: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String
    },
    color: {
      type: String
    },
    align: {
      type: String,
      default: 'center'
    }
  },
  methods: {
    itemClick: function itemClick() {
      this.clickItem({ action: this.action, type: this.aType, name: this.name });
    }
  }
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_index__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__menu_item_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__menu_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__menu_item_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isShow: false,
      allMenu: {}
    };
  },

  methods: {
    stopTouch: function stopTouch(event) {
      return;
    },
    clickItem: function clickItem(obj) {
      console.log(obj.action + '===sortList==' + obj.type);
      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].dispatch({
        type: 'set_Sort',
        param: {
          sort: obj.action,
          orderBy: obj.type
        }
      });
      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].commit('setIsReloadFilelist', true);
      this.hideMenuList();
    },
    hideMenuList: function hideMenuList() {
      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].dispatch({
        type: 'hideSortList'
      });
    }
  },
  computed: {
    menuList: function menuList() {
      return this.$store.getters.getSortInfo;
    },
    isCurrentSort: function isCurrentSort() {
      return this.$store.getters.getCurrentFolderSort;
    },
    isCurrentOrderBy: function isCurrentOrderBy() {
      return this.$store.getters.getCurrentFolderOrderBy;
    }
  },
  watch: {
    isShow: function isShow(newisShow) {
      if (newisShow) {
        // this.$refs.content.style.height = `${this.$store.getters.getShowMenuInfo.content.length * 50 + 20}px`
      }
    }
  },
  components: {
    'type-list': __WEBPACK_IMPORTED_MODULE_1__menu_item_vue___default.a
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__preview_audio_vedio_vue__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__preview_audio_vedio_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__preview_audio_vedio_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preview_img_vue__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preview_img_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__preview_img_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util__ = __webpack_require__(0);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    isStartPreview: {
      type: Boolean,
      required: true
    },
    datas: Object
  },
  data: function data() {
    return {
      isShow: false,
      isAudioVideo: false,
      isImgs: false,
      isDocs: false
    };
  },

  watch: {
    isStartPreview: function isStartPreview(val, oldVal) {
      console.log('isStartPreview:' + val);
      var auth = __WEBPACK_IMPORTED_MODULE_2_util__["e" /* getCSSActionByCode */](this.datas.access_mode).authCSS.split(':');
      console.log(auth);
      var canpreview = false;
      for (var o in auth) {
        if (auth[o] === 'preview') {
          canpreview = true;
        }
      }
      if (!canpreview) {
        this.$store.commit('setStartPreview', false);
        var params = {
          isShow: true,
          message: '没有预览权限',
          iconClass: 'icon-error'
        };
        this.$store.commit('setToast', params);
        return;
      }
      if (__WEBPACK_IMPORTED_MODULE_2_util__["f" /* canPreview */](this.datas.mime_type)) {
        if (val === true) {
          if (__WEBPACK_IMPORTED_MODULE_2_util__["g" /* isAudio */](this.datas.mime_type) || __WEBPACK_IMPORTED_MODULE_2_util__["h" /* isVideo */](this.datas.mime_type)) {
            this.isImgs = false;
            this.isAudioVideo = true;
            this.isDocs = false;
          } else if (__WEBPACK_IMPORTED_MODULE_2_util__["i" /* isDocs */](this.datas.mime_type) || __WEBPACK_IMPORTED_MODULE_2_util__["j" /* isPdf */](this.datas.mime_type)) {
            this.isImgs = false;
            this.isAudioVideo = false;
            this.isDocs = true;
            this.$store.commit('setStartPreview', false);
            this.$router.push({ name: 'preview_doc', params: { neid: this.datas.neid, uid: __WEBPACK_IMPORTED_MODULE_2_util__["c" /* getUserId */](), token: __WEBPACK_IMPORTED_MODULE_2_util__["k" /* getSessionId */]() } });
          } else {
            this.isImgs = true;
            this.isAudioVideo = false;
            this.isDocs = false;
          }
        }
        this.isShow = val;
      } else {
        this.$store.commit('setStartPreview', false);
      }
    }
  },
  computed: {},
  methods: {
    close: function close() {
      this.isShow = false;
      this.isImgs = false;
      this.isAudioVideo = false;
      console.log('children colse ....');
      this.$emit('close');
    }
  },
  components: {
    'audio-video-preview': __WEBPACK_IMPORTED_MODULE_0__preview_audio_vedio_vue___default.a,
    'imgs-preview': __WEBPACK_IMPORTED_MODULE_1__preview_img_vue___default.a
  }
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util__ = __webpack_require__(0);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    isStartPreview: {
      type: Boolean,
      required: true
    },
    datas: {
      type: Object
    }
  },
  data: function data() {
    return {
      isShow: false,
      isShowAudio: false,
      isShowVideo: false,
      audioUrl: '',
      videoUrl: '',
      poster: '/static/logo.png'
    };
  },

  methods: {
    close: function close() {
      this.isShow = false;
      this.isShowAudio = false;
      this.isShowVideo = false;
      this.$emit('close');
    },
    preview: function preview() {
      var sessionID = __WEBPACK_IMPORTED_MODULE_0_util__["n" /* getSession */]();
      // http://172.16.22.226/v2/preview_router?type=av&root=databox&path=/%E9%9F%B3%E8%A7%86%E9%A2%91/test1.mp4&path_type=ent&from&neid=280&rev=63bfa369812448caa5a8e96a8504b73a
      // http://172.16.22.226:10095/file/databox/%E9%9F%B3%E8%A7%86%E9%A2%91/test1.mp4?X-LENOVO-SESS-ID=htu1tqaidtvevlg2u5366pmeu2&neid=280&path_type=ent&rev=63bfa369812448caa5a8e96a8504b73a
      var url = __WEBPACK_IMPORTED_MODULE_0_util__["o" /* getPreviewUrl */](this.datas) + '&X-LENOVO-SESS-ID=' + sessionID + '&S=' + __WEBPACK_IMPORTED_MODULE_0_util__["a" /* getCookie */]('S');
      console.log('url:' + url);
      if (__WEBPACK_IMPORTED_MODULE_0_util__["g" /* isAudio */](this.datas.mime_type)) {
        this.isShowVideo = false;
        this.isShowAudio = true;
        this.audioUrl = url;
        var timer = setTimeout(function () {
          var audio = document.getElementById('lenovobox_audio_player');
          console.log('start play audio');
          audio.play();
          clearTimeout(timer);
        }, 500);
      } else {
        this.isShowAudio = false;
        this.isShowVideo = true;
        this.videoUrl = url;
        var _timer = setTimeout(function () {
          var video = document.getElementById('lenovobox_video_player');
          console.log('start play video');
          video.play();
          clearTimeout(_timer);
        }, 500);
      }
    }
  },
  computed: {},
  watch: {
    isStartPreview: function isStartPreview(val, oldVal) {
      console.log('isStartAudioVedioPreview:' + val);
      if (val === true) {
        this.isShow = true;
        this.preview();
      }
    },
    isShowAudio: function isShowAudio(val, oldVal) {
      if (val === false) {
        var audio = document.getElementById('lenovobox_audio_player');
        audio.pause();
      }
    },
    isShowVideo: function isShowVideo(val, oldVal) {
      if (val === false) {
        var video = document.getElementById('lenovobox_video_player');
        video.pause();
      }
    }
  }
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util__ = __webpack_require__(0);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Preview',
  data: function data() {
    return {
      isShowLoading: false,
      url: '',
      isShow: false,
      title: '',
      startX: '',
      startY: '',
      endX: '',
      endY: '',
      currentIndex: '',
      imgsList: [],
      page: ''
    };
  },

  props: {
    isStartPreview: Boolean,
    datas: Object
  },
  computed: {},
  watch: {
    isStartPreview: function isStartPreview(val, oldVal) {
      this.title = val;
      this.isShow = val;
      if (val === true) {
        this.url = this.getPreviewUrl(this.datas);
        this.currentNeid = this.datas.neid;
        var d = __WEBPACK_IMPORTED_MODULE_1_util__["l" /* resolvePath */](this.datas.path, this.datas.is_dir);
        this.title = d.name;
      }
      this.initImgsList();
    }
  },
  methods: {
    stopTouch: function stopTouch(event) {
      return;
    },
    initImgsList: function initImgsList() {
      console.log(__WEBPACK_IMPORTED_MODULE_0_store__["a" /* default */].state.fileInfo.content);
      this.imgsList = __WEBPACK_IMPORTED_MODULE_0_store__["a" /* default */].state.fileInfo.content.filter(function (element) {
        return element.thumb_exist || element.thumbExist;
      });
      console.log(this.imgsList);
      for (var i = 0; i < this.imgsList.length; i++) {
        if (this.imgsList[i].neid === this.datas.neid) {
          this.currentIndex = i;
        }
      }
      this.page = this.currentIndex + 1 + '/' + this.imgsList.length;
    },
    pre: function pre() {
      if (this.currentIndex + 1 < this.imgsList.length) {
        this.currentIndex++;
      } else {
        this.currentIndex = 0;
      }
      this.isShowLoading = true;
      this.showImg();
    },
    next: function next() {
      if (this.currentIndex !== 0) {
        this.currentIndex--;
      } else {
        this.currentIndex = this.imgsList.length - 1;
      }
      this.showImg();
    },
    showImg: function showImg() {
      var _this = this;

      this.isShowLoading = true;
      this.page = this.currentIndex + 1 + '/' + this.imgsList.length;
      var newImg = new Image();
      var url = this.getPreviewUrl(this.imgsList[this.currentIndex]);
      newImg.src = url;
      newImg.onload = function () {
        _this.url = url;
        _this.isShowLoading = false;
        _this.title = _this.imgsList[_this.currentIndex].name;
      };
      newImg.error = function () {
        _this.url = url;
      };
    },
    getDirection: function getDirection(startx, starty, endx, endy) {
      var angx = endx - startx;
      var angy = endy - starty;
      var result = 0;
      // 如果滑动距离太短
      if (Math.abs(angx) < 2 && Math.abs(angy) < 2) {
        return result;
      }
      var angle = Math.atan2(angy, angx) * 180 / Math.PI;
      if (angle >= -135 && angle <= -45) {
        result = 1;
      } else if (angle > 45 && angle < 135) {
        result = 2;
      } else if (angle >= 135 && angle <= 180 || angle >= -180 && angle < -135) {
        result = 3;
      } else if (angle >= -45 && angle <= 45) {
        result = 4;
      }

      return result;
    },
    touchstart: function touchstart(e) {
      if (this.imgsList.length === 0) {
        return;
      }
      this.startx = e.touches[0].pageX;
      this.starty = e.touches[0].pageY;
      e.stopPropagation();
      e.preventDefault();
    },
    touchend: function touchend(e) {
      console.log('touchend ......');
      var endx = e.changedTouches[0].pageX;
      var endy = e.changedTouches[0].pageY;
      var direction = this.getDirection(this.startx, this.starty, endx, endy);
      switch (direction) {
        case 0:
          console.log('未滑动！');
          break;
        case 1:
          console.log('向上！');
          break;
        case 2:
          console.log('向下！');
          break;
        case 3:
          console.log('向左！');
          this.pre();
          break;
        case 4:
          console.log('向右！');
          this.next();
          break;
      }
    },
    getPreviewUrl: function getPreviewUrl(params) {
      var uri = '/v2/preview_router?type=pic&root=databox&path=';
      if (params.isDelivery) {
        params.previewUrl = __WEBPACK_IMPORTED_MODULE_1_util__["m" /* getMyEncodeURI */](params.previewUrl);
        uri = params.previewUrl;
        if (params.path_type) {
          uri += '&path_type=' + params.path_type;
        }
        if (params.delivery_token) {
          uri += '&delivery_token=' + params.delivery_token;
        }
      } else {
        uri += __WEBPACK_IMPORTED_MODULE_1_util__["m" /* getMyEncodeURI */](params.path);
      }
      if (params.path_type) {
        uri += '&path_type=' + params.path_type;
      }
      if (params.from) {
        uri += '&from=' + params.from;
      }
      if (params.neid) {
        uri += '&neid=' + params.neid;
      }
      if (params.width) {
        uri += '&width=' + params.width;
      }

      if (params.height) {
        uri += '&height=' + params.height;
      }

      if (params.hash) {
        uri += '&hash=' + params.hash;
      }

      if (params.rev) {
        uri += '&rev=' + params.rev;
      }

      if (params.preview_type) {
        uri += '&preview_type=' + params.preview_type;
      }
      if (__WEBPACK_IMPORTED_MODULE_1_util__["a" /* getCookie */]('S')) {
        uri += '&S=' + __WEBPACK_IMPORTED_MODULE_1_util__["a" /* getCookie */]('S');
      }
      if (__WEBPACK_IMPORTED_MODULE_1_util__["a" /* getCookie */]('X-LENOVO-SESS-ID')) {
        uri += '&X-LENOVO-SESS-ID=' + __WEBPACK_IMPORTED_MODULE_1_util__["a" /* getCookie */]('X-LENOVO-SESS-ID');
      }
      return uri;
    },
    close: function close(e) {
      this.isShow = false;
      this.url = '';
      this.$emit('close');
    }
  }
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    tipsType: {
      type: String,
      default: 'confirmDelete'
    },
    tipTitle: {
      type: String,
      default: ''
    },
    okBtnText: {
      type: String,
      default: '确定'
    },
    clickCallBack: {
      type: Function,
      default: undefined
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    clickOkBtn: function clickOkBtn() {
      this.clickCallBack();
      this.hideTips();
    },
    hideTips: function hideTips() {
      __WEBPACK_IMPORTED_MODULE_0_store__["a" /* default */].commit('hideConfirmTips');
    }
  },
  computed: {
    showTips: function showTips() {
      return this.$store.getters.getTipsIsShow === this.tipsType;
    }
  }
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  methods: {
    closeToast: function closeToast() {
      __WEBPACK_IMPORTED_MODULE_0_store__["a" /* default */].commit('setToast', { isShow: false });
    }
  },
  computed: {},
  watch: {
    '$store.state.toast.isShow': {
      handler: function handler(val, oldVal) {
        if (val === true) {
          if (__WEBPACK_IMPORTED_MODULE_0_store__["a" /* default */].state.toast.autoClose === undefined || __WEBPACK_IMPORTED_MODULE_0_store__["a" /* default */].state.toast.autoClose) {
            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_0_store__["a" /* default */].commit('setToast', { isShow: false });
            }, 2000);
          }
        }
      },
      deep: true
    }
  }
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SDK_FileManager__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    isStartUpload: {
      type: Boolean,
      required: true
    },
    postURL: {
      type: String,
      required: true
    },
    minItems: {
      type: Number,
      default: 1
    },
    maxItems: {
      type: Number,
      default: 30
    },
    method: {
      type: String,
      default: 'post'
    },
    postMeta: {
      type: [String, Array, Object],
      default: ''
    }
  },
  /*
   * The component's data.
   */
  data: function data() {
    return {
      isUpload: false,
      isUploading: true,
      isUploaded: false,
      current: 0,
      total: 0,
      progress: 1,
      currentUploadFilename: '',
      items: [],
      itemsAdded: '',
      itemsNames: [],
      itemsSizes: [],
      formData: '',
      successMsg: '',
      errorMsg: '',
      isLoaderVisible: false
    };
  },

  methods: {
    startUploadHandle: function startUploadHandle() {
      document.getElementById('lenovobox_upload_btn').click();
    },
    bytesToSize: function bytesToSize(bytes) {
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      if (bytes === 0) return 'n/a';
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      if (i === 0) return bytes + ' ' + sizes[i];
      return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
    },
    onChange: function onChange(e) {
      this.isUpload = true;
      this.successMsg = '';
      this.errorMsg = '';
      console.log('1:' + e.target.files.length);
      var files = e.target.files || e.dataTransfer.files;
      var fileSizes = 0;
      for (var x in files) {
        if (!isNaN(x)) {
          var params = {
            file: e.target.files[x] || e.dataTransfer.files[x],
            name: files[x].name,
            size: files[x].size
          };
          console.log(navigator.userAgent);
          if (params.name === 'image.jpg' && /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            params.name = 'image' + new Date().getTime() + '.jpg';
          }
          fileSizes += files[x].size;
          this.items.push(params);
        }
      }
      this.total = this.items.length;
      this.itemsTotalSize = this.bytesToSize(fileSizes);
      console.log('upload total size:' + fileSizes);
      if (fileSizes > 1024 * 1024 * 2048) {
        this.$emit('uploadFail', '上传文件总大小不能超过2G');
        this.isUploading = false;
        this.isUpload = false;
        this.current = 0;
        this.items = [];
        return;
      }
      console.log('upload files:' + files.length);
      if (files.length > 20) {
        this.$emit('uploadFail', '仅能上传不超过20个文件');
        this.isUploading = false;
        this.isUpload = false;
        this.current = 0;
        this.items = [];
        return;
      }
      if (files.length === 1 && files[0].name === '/') {
        // 安卓手机企业微信点击上传按钮，返回后进入name为/，对于这种情况不进行上传
        this.isUploading = false;
        this.isUpload = false;
        this.current = 0;
        this.items = [];
        return;
      }
      this.startUpload();
    },
    uploadProgress: function uploadProgress(oEvent) {
      var vm = this;
      if (oEvent.lengthComputable) {
        var percentComplete = Math.round(oEvent.loaded * 100 / oEvent.total);
        vm.progress = percentComplete;
        console.log('percent:' + percentComplete);
      } else {}
    },

    /**
     * 验证权限
     * @param file
     * @param callback
     */
    checkUploadAuth: function checkUploadAuth(file, callback) {
      var _this = this;

      var params = {
        path: this.$store.getters.getFullPath,
        path_type: this.$store.getters.getCurrentPathType,
        bytes: file.size,
        from: this.$store.getters.getCurrentFolderInfo.from,
        prefix_neid: this.$store.getters.getCurrentFolderInfo.prefix_neid,
        iscloud: this.$store.getters.getCurrentFolderInfo.dir_type === 2 || this.$store.getters.getCurrentFolderInfo.dir_type === 4
      };
      __WEBPACK_IMPORTED_MODULE_0__SDK_FileManager__["a" /* checkUploadAuth */](params).then(function (response) {
        if (response.result !== 'success') {
          _this.$emit('uploadFail', response.message);
          _this.isUploading = false;
          _this.isUpload = false;
          return;
        } else {
          callback(response.region);
        }
      });
    },
    startUpload: function startUpload() {
      var vm = this;
      if (this.isUploaded) {
        this.$emit('uploadFail', '网络错误');
        this.isUploading = false;
        this.isUpload = false;
        this.current = 0;
        this.isUploaded = false;
        return;
      }
      if (!this.isUpload) {
        return;
      }
      if (!this.items.length) {
        this.isUploading = false;
        this.isUpload = false;
        this.current = 0;
        this.$emit('uploadComplete', vm.total);
        return;
      }
      var file = this.items.pop();
      this.checkUploadAuth(file, function (region) {
        vm.current++;
        vm.currentUploadFilename = file.name;
        vm.progress = 0;
        var uploadUrl = region + vm.getUploadurl(encodeURIComponent(file.name));
        console.log('upload url:' + uploadUrl);
        console.log(file.file);
        var form = new FormData();
        form.append('file', file.file, file.file.name);
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(uploadUrl, form, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: function onUploadProgress(event) {
            console.log(event);
          }
        }).then(function (res) {
          console.log(res);
        });

        // let formData = new FormData()
        // formData.append('file', file.file)
        // var xhr = new XMLHttpRequest()
        // xhr.open(`POST`, uploadUrl)
        // xhr.onloadstart = function (e) {
        //   console.log(`start`)
        // }
        // xhr.upload.onerror = function (e) {
        //   console.log('onerror')
        //   if (e) {
        //     vm.isUploaded = true
        //   }
        // }
        // xhr.onloadend = function (e) {
        //   console.log(`finish`)
        //   vm.startUpload()
        // }
        // xhr.upload.onprogress = vm.uploadProgress
        // xhr.send(formData)
      });
    },
    getUploadurl: function getUploadurl(name) {
      console.log('test' + this.postURL.replace('{0}', name));
      return this.postURL.replace('{0}', name);
    },
    removeItems: function removeItems() {
      this.items = '';
      this.itemsAdded = '';
      this.itemsNames = [];
      this.itemsSizes = [];
      this.total = '';
    }
  },
  watch: {
    isStartUpload: function isStartUpload(val, oldVal) {
      console.log('isStartUpload:' + val);
      if (val === true) {
        this.startUploadHandle();
      }
    }
  },
  computed: {},
  created: function created() {}
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SDK_UserManager__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      username: '',
      selectedOption: '0',
      pwd: '',
      error_msg: '',
      domainsId: '',
      domain: false,
      isLoading: true,
      isVisiable: true,
      disabled: false,
      // isShowPwd: true,
      domainArrs: [{ dnName: '普通登录', timesid: '0' }],
      domainArrList: [],
      thirdLoginList: [],
      domainOpen: false,
      isChange: true,
      positionText: 'fixed',
      bottomText: '0.5rem',
      errToast: ''
    };
  },
  beforeCreate: function beforeCreate() {},
  created: function created() {
    var _this = this;

    //  二次认证页面toast
    if (__WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('err_message')) {
      this.errToast = __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('err_message');
      setTimeout(function () {
        _this.errToast = '';
      }, 3000);
    }
    this.getAuthlogin();
    this.isLoading = false;
    __WEBPACK_IMPORTED_MODULE_1__SDK_UserManager__["f" /* getDomains */]().then(function (response) {
      if (response.length > 0) {
        _this.domainOpen = true;
        _this.domain = true;
        _this.selectedOption = response[0].timesid ? response[0].timesid : '0';
        _this.domainArrList = _this.domainArrs.concat(response);
        _this.domainsId = _this.selectedOption;
      } else {
        _this.domainOpen = false;
        _this.domain = false;
      }
    });
  },

  methods: {
    login: function login() {
      var _this2 = this;

      this.$refs.clickBtn.style.background = '#065BD1';
      if (this.username === '') {
        this.error_msg = '用户名不能为空';
        this.$refs.clickBtn.style.background = '#0A64FA ';
        return;
      }
      if (this.pwd === '') {
        this.error_msg = '密码不能为空';
        this.$refs.clickBtn.style.background = '#0A64FA ';
        return;
      }
      var params = {
        user_slug: this.username,
        password: this.pwd,
        bind_type: this.selectedOption !== '0'
      };
      if (this.domainsId) {
        params.timesid = this.domainsId;
      }
      __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.remove('X-LENOVO-SESS-ID');
      __WEBPACK_IMPORTED_MODULE_1__SDK_UserManager__["g" /* signin */](params).then(function (response) {
        if (response.captcha) {
          var postData = {
            user_slug: _this2.username,
            lenovo_token: response.lenovo_token
          };
          __WEBPACK_IMPORTED_MODULE_1__SDK_UserManager__["d" /* getCode */](postData).then(function (response) {
            var info = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response);
            sessionStorage.setItem('info', info);
            sessionStorage.setItem('refresh', true);
            sessionStorage.setItem('user_slug', _this2.username);
            _this2.$router.push({ path: '/secondary-certification' });
          }, function (error) {
            var info = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error);
            sessionStorage.setItem('info', info);
            sessionStorage.setItem('refresh', true);
            sessionStorage.setItem('errorMsg', true);
            sessionStorage.setItem('user_slug', _this2.username);
            _this2.$router.push({ path: '/secondary-certification' });
          });
          return;
        }
        sessionStorage.userInfo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response);
        _this2.$store.commit('login', response);
        _this2.$router.replace({ path: '/' });
        location.reload();
      }, function (error) {
        _this2.error_msg = error.message;
        _this2.pwd = '';
        // this.isShowPwd = false
        _this2.$refs.clickBtn.style.background = '#0A64FA ';
      });
    },
    focus: function focus() {
      this.disabled = true;
      // if (!this.isShowPwd) {
      //   this.pwd = ''
      //   this.isShowPwd = true
      // }
      this.positionText = 'static';
      this.isVisiable = false;
    },
    blur: function blur() {
      this.positionText = 'fixed';
      this.isVisiable = true;
    },
    showActive: function showActive() {
      this.domainsId = this.selectedOption;
      this.domain = this.selectedOption ? 'true' : 'false';
      console.log(this.domainsId);
      this.isChange = true;
    },
    test: function test() {
      console.log(this.$refs.clickSelect);
    },
    iconCurrentPathChange: function iconCurrentPathChange() {
      this.isChange = false;
    },

    // 三方登录接口
    getAuthlogin: function getAuthlogin() {
      var _this3 = this;

      var params = {
        'name': 'marne_sso_configs',
        'terminal': 'web'
      };
      __WEBPACK_IMPORTED_MODULE_1__SDK_UserManager__["h" /* authlogin */](params).then(function (res) {
        _this3.thirdLoginList = res.marne_sso_configs.map(function (ele) {
          if (ele.serviceType === 'corp_wx') {
            ele.icon = '../../../static/img/wechat.svg';
          } else if (ele.serviceType === 'dingding') {
            ele.icon = '../../../static/img/dingTalk.svg';
          }
          return ele;
        });
      });
    },


    // 三方登录跳转
    handleLink: function handleLink(item) {
      var redirectUrl = window.localStorage.getItem('linkUrl');
      window.location = item.url + '?redirect_url=' + encodeURIComponent(redirectUrl);
    }
  },
  watch: {
    // 'pwd': function (val, oldVal) {
    //   if (val === '') {
    //     this.isShowPwd = true
    //   }
    // }
  },
  computed: {
    // 判断是否显示三方登录
    isLink: function isLink() {
      if (this.thirdLoginList.length >= 1 && window.localStorage.getItem('linkUrl')) {
        return true;
      }
      return false;
    }
  }
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SDK_UserManager__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'secondaryCertification',
  data: function data() {
    return {
      infoSuc: 'init',
      appName: '企业微信',
      code: '',
      timer: null,
      time: 60,
      isGetCode: true,
      errInfo: '',
      token: '',
      errIcon: __webpack_require__(199)
    };
  },
  created: function created() {
    // 30min 未操作返回登录页
    this.token = __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('CA-LENOVO-AUTH-TOKEN');
    if (!this.token) {
      this.$router.replace({ path: '/' });
    }
    var refresh = sessionStorage.getItem('refresh');
    var errorMessage = sessionStorage.getItem('errorMsg');
    this.info = JSON.parse(sessionStorage.getItem('info'));
    this.errInfo = '';
    if (this.info && this.info.result) {
      this.appName = this.info.app_name;
      this.infoSuc = 'success';
      if (refresh) {
        this.isGetCode = false;
        this.timeFun();
        sessionStorage.removeItem('refresh');
      }
    } else if (this.info && this.info.state === 404) {
      this.infoSuc = 'error';
    } else if (this.info && this.info.state === 401) {
      this.infoSuc = 'success';
      if (this.info.code === 'ip is forbidden') {
        this.errInfo = this.info && this.info.message;
        this.code = '';
      } else {
        var seconds = 5;
        var expires = new Date(new Date() * 1 + seconds * 1000);
        __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.set('err_message', this.info.message, { expires: expires });
        this.$router.replace({ path: '/' });
      }
      console.log(this.info.message, 'this.info.message');
    } else {
      this.infoSuc = 'success';
      if (!errorMessage) {
        this.errInfo = '';
      } else {
        this.errInfo = this.info && this.info.message;
        sessionStorage.removeItem('errorMsg');
      }
    }
  },

  computed: {
    allowLogin: function allowLogin() {
      return this.code !== '';
    }
  },
  methods: {
    getCode: function getCode() {
      var _this = this;

      var postData = {
        user_slug: sessionStorage.getItem('user_slug'),
        lenovo_token: __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('CA-LENOVO-AUTH-TOKEN')
      };
      __WEBPACK_IMPORTED_MODULE_1__SDK_UserManager__["d" /* getCode */](postData).then(function (response) {
        if (response.result) {
          _this.errInfo = '';
          _this.appName = response.app_name;
          _this.infoSuc = 'success';
          _this.isGetCode = false;
          _this.timeFun();
        }
      }, function (err) {
        if (err.state === 404) {
          _this.infoSuc = 'error';
        } else if (err.state === 401) {
          _this.infoSuc = 'success';
          if (err.code === 'ip is forbidden') {
            _this.errInfo = err.message;
            _this.code = '';
          } else {
            var seconds = 5;
            var expires = new Date(new Date() * 1 + seconds * 1000);
            __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.set('err_message', err.message, { expires: expires });
            _this.$router.replace({ path: '/' });
          }
        } else {
          _this.infoSuc = 'success';
          _this.errInfo = err.message;
          _this.code = '';
        }
      });
    },
    getInput: function getInput() {
      if (this.code) {
        this.errInfo = '';
      }
    },
    loginHandler: function loginHandler() {
      var _this2 = this;

      if (!this.allowLogin) {
        return false;
      }
      this.errInfo = '';
      var postData = {
        user_slug: sessionStorage.getItem('user_slug'),
        lenovo_token: __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('CA-LENOVO-AUTH-TOKEN'),
        captcha: this.code
      };
      __WEBPACK_IMPORTED_MODULE_1__SDK_UserManager__["e" /* verifyCode */](postData).then(function (response) {
        sessionStorage.userInfo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response);
        _this2.$store.commit('login', response);
        _this2.$router.replace({ path: '/' });
        location.reload();
      }, function (err) {
        if (err.state === 401) {
          if (err.code === 'ip is forbidden') {
            _this2.errInfo = err.message;
            _this2.code = '';
          } else {
            var seconds = 5;
            var expires = new Date(new Date() * 1 + seconds * 1000);
            __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.set('err_message', err.message, { expires: expires });
            _this2.$router.replace({ path: '/' });
          }
        } else {
          _this2.errInfo = err.message;
          _this2.code = '';
        }
      });
    },
    timeFun: function timeFun() {
      var _this3 = this;

      this.timer = setInterval(function () {
        if (_this3.time === 0) {
          _this3.time = 60;
          _this3.isGetCode = true;
          clearInterval(_this3.timer);
        } else {
          _this3.isGetCode = false;
          _this3.time--;
        }
      }, 1000);
    },
    switchAccount: function switchAccount() {
      this.$router.replace({ path: '/' });
    }
  }
});

/***/ }),
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNDZweCIgaGVpZ2h0PSI0NnB4IiB2aWV3Qm94PSIwIDAgNDYgNDYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+Q29tYmluZWQgU2hhcGUgQ29weSA05aSH5Lu9IDk8L3RpdGxlPgogICAgPGcgaWQ9Iumhtemdoi0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0i55S75p2/IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjM3LjAwMDAwMCwgLTc1Ny4wMDAwMDApIiBmaWxsPSIjRkYzRDNDIj4KICAgICAgICAgICAgPHBhdGggZD0iTTI2MCw3NTcgQzI3Mi43MDI1NDksNzU3IDI4Myw3NjcuMjk3NDUxIDI4Myw3ODAgQzI4Myw3OTIuNzAyNTQ5IDI3Mi43MDI1NDksODAzIDI2MCw4MDMgQzI0Ny4yOTc0NTEsODAzIDIzNyw3OTIuNzAyNTQ5IDIzNyw3ODAgQzIzNyw3NjcuMjk3NDUxIDI0Ny4yOTc0NTEsNzU3IDI2MCw3NTcgWiBNMjY4LjcyOTY2NCw3NzAuMTQyODU3IEwyNjAuNTk4LDc3OC4yNzQgTDI1Mi40NjYyMDgsNzcwLjE0Mjg1NyBMMjUwLjE0Mjg1Nyw3NzIuNDY2MjA4IEwyNTguMjc0LDc4MC41OTggTDI1MC4xNDI4NTcsNzg4LjcyOTY2NCBMMjUyLjQ2NjIwOCw3OTEuMDUzMDE1IEwyNjAuNTk4LDc4Mi45MjIgTDI2OC43Mjk2NjQsNzkxLjA1MzAxNSBMMjcxLjA1MzAxNSw3ODguNzI5NjY0IEwyNjIuOTIyLDc4MC41OTggTDI3MS4wNTMwMTUsNzcyLjQ2NjIwOCBMMjY4LjcyOTY2NCw3NzAuMTQyODU3IFoiIGlkPSJDb21iaW5lZC1TaGFwZS1Db3B5LTTlpIfku70tOSI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(222),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(181)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(126),
  /* template */
  __webpack_require__(215),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(187)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(221),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(180)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(214),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(186)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(220),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(191)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(226),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(179)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(132),
  /* template */
  __webpack_require__(213),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(183)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(133),
  /* template */
  __webpack_require__(217),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-46ee275b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(189)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(135),
  /* template */
  __webpack_require__(224),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(184)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(136),
  /* template */
  __webpack_require__(218),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(188)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(223),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(185)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(138),
  /* template */
  __webpack_require__(219),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-518256c2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "sideUp"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTips),
      expression: "showTips"
    }]
  }, [_c('div', {
    staticClass: "tips-mask",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_c('div', {
    staticClass: "tips-content"
  }, [_c('p', {
    staticClass: "tips-title"
  }, [_vm._v(_vm._s(_vm.tipTitle))]), _vm._v(" "), _c('button', {
    staticClass: "tips-ok",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.clickOkBtn()
      }
    }
  }, [_vm._v(_vm._s(_vm.okBtnText))]), _vm._v(" "), _c('button', {
    staticClass: "tips-cancle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.hideTips()
      }
    }
  }, [_vm._v("取消")])])])])])
},staticRenderFns: []}

/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "sliderUpHideRight"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "lenovobox_audio_vedio_mask",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowVideo),
      expression: "isShowVideo"
    }]
  }, [_c('video', {
    staticClass: "lenovobox_vedio",
    attrs: {
      "controls": "controls",
      "autoplay": "autoplay",
      "src": _vm.videoUrl,
      "name": "media",
      "id": "lenovobox_video_player",
      "controlsList": "nodownload"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.videoUrl,
      "type": "video/mp4"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowAudio),
      expression: "isShowAudio"
    }]
  }, [_c('audio', {
    staticClass: "lenovobox_audio",
    attrs: {
      "id": "lenovobox_audio_player",
      "src": _vm.audioUrl,
      "controls": "controls",
      "autoplay": "autoplay",
      "controlsList": "nodownload"
    }
  }, [_vm._v("\n        您的浏览器暂不支持播放该音频，请升级至最新版浏览器\n      ")])])])])
},staticRenderFns: []}

/***/ }),
/* 214 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "actionlist"
  }, [_c('transition', {
    attrs: {
      "name": "sideDown"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenu),
      expression: "showMenu"
    }],
    ref: "content",
    staticClass: "content"
  }, _vm._l((_vm.menuList), function(item, index) {
    return _c('type-list', {
      key: item.id,
      attrs: {
        "item": item,
        "index": index,
        "name": item.name,
        "icon": item.icon,
        "align": item.align,
        "clickItem": _vm.clickItem,
        "count": item.count,
        "action": item.action,
        "color": item.color
      }
    })
  }))]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenu),
      expression: "showMenu"
    }],
    staticClass: "mask",
    on: {
      "click": _vm.hideMenuList,
      "touchmove": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.stopTouch($event)
      }
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),
/* 215 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenu),
      expression: "showMenu"
    }],
    ref: "maskPosition",
    staticClass: "mask"
  }, [_c('div', {
    staticClass: "dialog"
  }, [_c('div', {
    staticStyle: {
      "height": "3.52rem"
    }
  }, [_c('p', {
    staticClass: "dialog-title"
  }, [_c('span', [_vm._v("重命名")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorInfo),
      expression: "errorInfo"
    }],
    staticStyle: {
      "color": "red",
      "display": "block",
      "font-size": "0.32rem"
    }
  }, [_vm._v(_vm._s(_vm.errorInfo))])]), _vm._v(" "), _c('p', {
    staticClass: "dialog-content"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.fileName),
      expression: "fileName",
      modifiers: {
        "trim": true
      }
    }],
    ref: "inputA",
    style: ({
      height: _vm.textarea ? '1.4rem' : '0.8rem'
    }),
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.fileName)
    },
    on: {
      "focus": function($event) {
        _vm.focusAbsolute()
      },
      "blur": [function($event) {
        _vm.blurFixed()
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fileName = $event.target.value.trim()
      }
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "dialog-button"
  }, [_c('span', {
    staticClass: "cancel",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _c('span', {
    staticClass: "ok",
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("确定")])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "sideUp"
    }
  }, [_c('confirm-tips', {
    attrs: {
      "tipTitle": _vm.tipTitle,
      "clickCallBack": _vm.renameFile,
      "tipsType": _vm.tipsType,
      "okBtnText": _vm.okBtnText
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "sideUp"
    }
  }, [_c('confirm-tips', {
    attrs: {
      "tipTitle": _vm.extensionTitle,
      "clickCallBack": _vm.extensionTips,
      "tipsType": _vm.extensionType
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "typelist",
    on: {
      "click": function($event) {
        _vm.itemClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "typelist-detail",
    class: _vm.align
  }, [_c('span', {
    class: _vm.icon,
    staticStyle: {
      "font-size": "0.67rem",
      "display": "inline-block"
    }
  }, [_c('span', {
    staticClass: "name",
    style: ({
      color: _vm.color
    })
  }, [_vm._v(_vm._s(_vm.name))])])])])
},staticRenderFns: []}

/***/ }),
/* 217 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "preview-wrapper",
    on: {
      "click": function($event) {
        _vm.close($event)
      },
      "touchmove": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.stopTouch($event)
      }
    }
  }, [_c('div', {
    staticClass: "preview-header"
  }, [_c('i', {
    staticClass: "preview-header-icon icon-back"
  }), _vm._v(" "), _c('div', {
    staticClass: "preview-img-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowLoading),
      expression: "isShowLoading"
    }],
    staticClass: "preview-loading"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowLoading),
      expression: "isShowLoading"
    }]
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.isShowLoading) ? _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowLoading),
      expression: "!isShowLoading"
    }],
    staticClass: "preview-img",
    attrs: {
      "src": _vm.url,
      "alt": _vm.title
    },
    on: {
      "touchstart": function($event) {
        $event.stopPropagation();
        _vm.touchstart($event)
      },
      "touchend": function($event) {
        $event.stopPropagation();
        _vm.touchend($event)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.imgsList.length),
      expression: "this.imgsList.length"
    }],
    staticClass: "preview-page"
  }, [_vm._v(_vm._s(_vm.page))])], 1)
},staticRenderFns: []}

/***/ }),
/* 218 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isUpload),
      expression: "isUpload"
    }]
  }, [_c('div', {
    staticClass: "lenovobox_uploader_mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "lenovobox_uploader"
  }, [_c('div', [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "multiple": "",
      "id": "lenovobox_upload_btn",
      "size": "1"
    },
    on: {
      "change": function($event) {
        _vm.onChange($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "lang",
      rawName: "v-lang.upload_progress_text",
      value: ([_vm.current, _vm.total]),
      expression: "[current,total]",
      modifiers: {
        "upload_progress_text": true
      }
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "lenovobox_uploader_filename"
  }, [_vm._v(_vm._s(_vm.currentUploadFilename))]), _vm._v(" "), _c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "loading",
    style: ('width:' + _vm.progress + '%')
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 219 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "secondary-certification-body"
  }, [(_vm.infoSuc === 'success') ? _c('div', {
    staticClass: "info-suc"
  }, [_c('div', {
    staticClass: "top-info"
  }, [_c('span', [_vm._v("验证码消息已发送至："), _c('span', {
    staticClass: "information-tools"
  }, [_vm._v(_vm._s(_vm.appName))])])]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    class: {
      err: _vm.errInfo
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }, function($event) {
        _vm.getInput()
      }]
    }
  }), _vm._v(" "), (_vm.isGetCode) ? _c('div', {
    staticClass: "getCode",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v("获取验证码")]) : _c('div', {
    staticClass: "again"
  }, [_vm._v(_vm._s(_vm.time) + "s后重发")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errInfo),
      expression: "errInfo"
    }],
    staticClass: "err-info"
  }, [_vm._v(_vm._s(_vm.errInfo))]), _vm._v(" "), _c('div', {
    staticClass: "login-btn",
    class: {
      active: _vm.allowLogin
    },
    on: {
      "click": _vm.loginHandler
    }
  }, [_vm._v("\n      登录\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.infoSuc === 'error') ? _c('div', {
    staticClass: "info-err"
  }, [_c('img', {
    attrs: {
      "src": _vm.errIcon,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_vm._v("验证码发送失败")]), _vm._v(" "), _c('div', {
    staticClass: "err-details"
  }, [_vm._v("未找到对应的企业微信用户，请联系管理员处理")])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.infoSuc !== 'init'),
      expression: "infoSuc !== 'init'"
    }],
    staticClass: "switch-account"
  }, [_c('span', {
    on: {
      "click": _vm.switchAccount
    }
  }, [_vm._v("切换账号")])])])
},staticRenderFns: []}

/***/ }),
/* 220 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sortlist"
  }, [_c('transition', {
    attrs: {
      "name": "sideUp"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.getters.getSortShow),
      expression: "this.$store.getters.getSortShow"
    }],
    ref: "content",
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content-type"
  }, _vm._l((_vm.menuList.content), function(item, index) {
    return _c('div', {
      staticClass: "typelist",
      class: {
        'bottom-line': (index !== _vm.menuList.content.length - 1)
      },
      on: {
        "click": function($event) {
          _vm.clickItem(item)
        }
      }
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((_vm.isCurrentSort === item.action) && (_vm.isCurrentOrderBy === item.type)),
        expression: "(isCurrentSort === item.action) && (isCurrentOrderBy === item.type)"
      }],
      staticClass: "info icon-check"
    }), _vm._v(" "), _c('div', {
      staticClass: "typelist-detail"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "menu-cancel",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.hideMenuList($event)
      }
    }
  }, [_vm._v("取消")])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.getters.getSortShow),
      expression: "this.$store.getters.getSortShow"
    }],
    staticClass: "mask",
    on: {
      "click": _vm.hideMenuList,
      "touchmove": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.stopTouch($event)
      }
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 221 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menulist"
  }, [_c('transition', {
    attrs: {
      "name": "sideUp"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenu),
      expression: "showMenu"
    }],
    ref: "content",
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-wrapper"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.menuList.title) + "\n        ")]), _vm._v(" "), _vm._l((_vm.menuList.content), function(item, index) {
    return _c('type-list', {
      key: index,
      staticClass: "tips-ok",
      attrs: {
        "item": item,
        "index": index,
        "name": item.name,
        "action": item.action,
        "icon": item.iconInfo,
        "clickItem": _vm.clickItem,
        "color": item.color
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tips-cancle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.hideMenuList($event)
      }
    }
  }, [_vm._v("取消")])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "sideUp"
    }
  }, [_c('confirm-tips', {
    attrs: {
      "tipTitle": _vm.tipTitle,
      "clickCallBack": _vm.deleteFile,
      "tipsType": _vm.tipsType
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "sideUp"
    }
  }, [_c('confirm-tips', {
    attrs: {
      "tipTitle": _vm.deliveryTip,
      "clickCallBack": _vm.cancelDelivery,
      "tipsType": _vm.deliveryType
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenu),
      expression: "showMenu"
    }],
    staticClass: "mask",
    on: {
      "click": _vm.hideMenuList,
      "touchmove": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.stopTouch($event)
      }
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.fileInfo.addFolderShow),
      expression: "$store.state.fileInfo.addFolderShow"
    }],
    ref: "maskPosition",
    staticClass: "mask",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "dialog"
  }, [_c('div', {
    staticStyle: {
      "height": "3.52rem"
    }
  }, [_c('p', {
    staticClass: "dialog-title"
  }, [_c('span', [_vm._v("新建文件夹")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorInfo),
      expression: "errorInfo"
    }],
    staticStyle: {
      "color": "red",
      "height": "0.61rem",
      "display": "block",
      "font-size": "0.32rem"
    }
  }, [_vm._v(_vm._s(_vm.errorInfo))])]), _vm._v(" "), _c('p', {
    staticClass: "dialog-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.fileName),
      expression: "fileName",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.fileName)
    },
    on: {
      "focus": function($event) {
        _vm.focusAbsolute()
      },
      "blur": [function($event) {
        _vm.blurFixed()
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fileName = $event.target.value.trim()
      }
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "dialog-button"
  }, [_c('span', {
    staticClass: "cancel",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _c('span', {
    staticClass: "ok",
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("确定")])])])])
},staticRenderFns: []}

/***/ }),
/* 223 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isLoading) ? _c('div', {
    staticClass: "login-page"
  }, [(_vm.errToast) ? _c('div', {
    staticClass: "err-toast"
  }, [_c('span', [_vm._v(_vm._s(_vm.errToast))])]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "login-logo",
    attrs: {
      "src": "/v2/config/get_file?config_type=0&config_id=0&name=custom_main_logo"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "login-error",
    domProps: {
      "textContent": _vm._s(_vm.error_msg)
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.domainOpen),
      expression: "domainOpen"
    }],
    staticClass: "login-name"
  }, [_c('select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.domainOpen),
      expression: "domainOpen"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedOption),
      expression: "selectedOption"
    }],
    ref: "clickSelect",
    staticClass: "domins-select icon-currentPath-down",
    attrs: {
      "id": "select"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.showActive],
      "click": _vm.iconCurrentPathChange
    }
  }, _vm._l((_vm.domainArrList), function(domainOne) {
    return _c('option', {
      key: domainOne.timesid,
      domProps: {
        "value": domainOne.timesid
      }
    }, [_vm._v("\n        " + _vm._s(domainOne.dnName) + "\n      ")])
  })), _vm._v(" "), _c('span', {
    staticClass: "icon-currentPath-down",
    class: {
      'icon-currentPath-down': _vm.isChange,
      'icon-currentPath-up': !_vm.isChange,
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-msg",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.login($event)
      }
    }
  }, [_c('div', {
    staticClass: "login-input",
    staticStyle: {
      "border-bottom": "1px solid #dadddf"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "text",
      "maxlength": "32",
      "placeholder": "请输入用户名"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "focus": _vm.focus,
      "blur": _vm.blur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-input login-password"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    attrs: {
      "type": "password",
      "maxlength": "64",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.pwd)
    },
    on: {
      "focus": _vm.focus,
      "blur": _vm.blur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pwd = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.disabled) ? _c('button', {
    ref: "clickBtn",
    staticStyle: {
      "background": "#0A64FA",
      "margin-top": "0.8rem"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.login($event)
      }
    }
  }, [_vm._v("\n    登录\n  ")]) : _c('button', {
    staticStyle: {
      "background": "#8fcdff",
      "margin-top": "0.8rem"
    },
    attrs: {
      "disabled": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.login($event)
      }
    }
  }, [_vm._v("\n    登录\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [(_vm.isVisiable) ? _c('span', {
    staticClass: "bottomText",
    style: ({
      position: _vm.positionText,
      bottom: _vm.bottomText
    })
  }, [_vm._v("©Filez")]) : _vm._e()]), _vm._v(" "), (_vm.isLink) ? _c('div', {
    staticClass: "third-box"
  }, _vm._l((_vm.thirdLoginList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "third-login-list",
      on: {
        "click": function($event) {
          _vm.handleLink(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.icon,
        "alt": ""
      }
    }), _vm._v(_vm._s(item.name) + "\n    ")])
  })) : _vm._e()]) : _c('div', [_vm._v("Loading....")])
},staticRenderFns: []}

/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "sideUp"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.toast.isShow),
      expression: "$store.state.toast.isShow"
    }],
    staticClass: "header-toast"
  }, [_c('div', {
    staticClass: "header-toast-content"
  }, [_c('i', {
    class: _vm.$store.state.toast.iconClass
  }, [_c('span', {
    staticClass: "path1"
  }), _c('span', {
    staticClass: "path2"
  })]), _vm._v(" "), _c('span', {
    staticClass: "header-toast-title"
  }, [_vm._v(_vm._s(_vm.$store.state.toast.message))])]), _vm._v(" "), _c('span', {
    staticClass: "header-toast-close icon-cancel",
    on: {
      "click": _vm.closeToast
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('v-uploader', {
    attrs: {
      "postURL": _vm.getUploadURL(),
      "isStartUpload": _vm.$store.state.startUpload
    },
    on: {
      "uploadComplete": _vm.uploadComplete,
      "uploadFail": _vm.uploadFail
    }
  }), _vm._v(" "), _c('v-preview', {
    attrs: {
      "isStartPreview": _vm.$store.state.startPreview,
      "datas": _vm.$store.state.fileInfo.currentFile
    },
    on: {
      "close": function($event) {
        _vm.close()
      }
    }
  }), _vm._v(" "), _c('v-menu-list'), _vm._v(" "), _c('v-action-list'), _vm._v(" "), _c('v-sort-list'), _vm._v(" "), _c('v-dialog'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('v-add-folder'), _vm._v(" "), _c('v-toast')], 1)
},staticRenderFns: []}

/***/ }),
/* 226 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }]
  }, [_c('audio-video-preview', {
    attrs: {
      "isStartPreview": _vm.isAudioVideo,
      "datas": _vm.$store.state.fileInfo.currentFile
    },
    on: {
      "close": function($event) {
        _vm.close()
      }
    }
  }), _vm._v(" "), _c('imgs-preview', {
    attrs: {
      "isStartPreview": _vm.isImgs,
      "datas": _vm.$store.state.fileInfo.currentFile
    },
    on: {
      "close": function($event) {
        _vm.close()
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ })
],[110]);


// WEBPACK FOOTER //
// static/js/app.05f70ed15adaabb649f9.js